import { TranslationKey } from './fr';

const translationDe: Record<TranslationKey, string> = {
    'metadata.description': 'Das Innovorder Back-Office',
    'cookies.banner.message':
        'Unsere Website verwendet Cookies, um Ihre Erfahrung zu verbessern. Durch weiteres Surfen stimmen Sie der Verwendung dieser Cookies zu. Um mehr über unsere Datenschutzrichtlinie zu erfahren und Ihre Cookie-Einstellungen zu verwalten, besuchen Sie bitte unsere entsprechende Seite.',
    'cookies.banner.accept': 'Akzeptieren',
    'cookies.banner.decline': 'Ablehnen',
    'legend.DELIVERY': 'Lieferung',
    'legend.DRIVE': 'Drive',
    'legend.SIT_IN': 'Vor Ort',
    'legend.TAKE_AWAY': 'Zum Mitnehmen',
    'legend.KIOSK': 'Kiosk',
    'legend.WEB': 'Online-Bestellung',
    'legend.RECEPTION': 'Empfang',
    'legend.POS': 'Kasse',
    'legend.LOYALTY': 'Kundenbindung',
    'legend.EWALLET_KIOSK': 'Kiosk E-Wallet',
    'legend.VENDING_MACHINE': 'Automaten',
    'analyticsPage.needBrandSelection': 'Da Sie Administrator sind, müssen Sie mindestens eine Marke auswählen.',
    'analyticsPage.notAuthorizedToSeeBrand': 'Sie sind nicht berechtigt, diese Marke einzusehen.',
    'analyticsPage.cannotMixEducationAndNonEducationBrands':
        'Sie können nicht gleichzeitig Marken aus der Gemeinschaftsverpflegung und der kommerziellen Gastronomie auswählen.',
    'analyticsPage.reload': 'Daten aktualisieren',
    'beta_banner.message':
        '👋 Dies ist eine <b>Beta</b>-Version – viele Verbesserungen und Korrekturen folgen in Kürze.',
    'analytics.metabaseError': 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.',
    'analytics.noAdmin': 'Leider ist IO Analytics im Admin-Modus noch nicht verfügbar … Keine Sorge, das kommt bald!',
    'analytics.realTime': 'Echtzeit',
    'analytics.ranking': 'Rangliste',
    'analytics.products': 'Produkte',
    'analytics.sales': 'Umsätze',
    'analytics.salesSummary': 'Finanzübersicht',
    'analytics.demoStaging': 'Demo (Staging)',
    'analytics.attendance': 'Besucherfrequenz',
    'analytics.billing': 'Abrechnung',
    'analytics.dashboard': 'Metabase-Dashboard',
    'analytics.filter.restaurant': 'Nach Restaurant filtern',
    'analytics.filter.group': 'Nach Gruppe filtern',
    'analytics.filter.consumption': 'Verzehrart',
    'analytics.filter.channel': 'Kanäle',
    'analytics.filter.HT': 'Netto',
    'analytics.filter.TTC': 'Brutto',
    'analytics.filter.takeAway': 'Zum Mitnehmen',
    'analytics.filter.sitIn': 'Vor Ort',
    'analytics.filter.delivery': 'Lieferung',
    'analytics.filter.drive': 'Drive',
    'analytics.filter.kiosk': 'Kiosk',
    'analytics.filter.web': 'Online-Bestellung',
    'analytics.filter.pos': 'Kasse',
    'analytics.filter.ubereats': 'Ubereats',
    'analytics.filter.deliveroo': 'Deliveroo',
    'analytics.filter.justeat': 'Justeat',
    'analytics.filter.vendingmachine': 'Automatenverkauf',
    'leaderboard.title': 'Restaurantrangliste',
    'leaderboard.ranking': 'Position',
    'leaderboard.restaurantName': 'Restaurants',
    'leaderboard.revenue': 'Umsatz',
    'leaderboard.averageBasket': 'Durchschnittlicher Warenkorb',
    'leaderboard.ordersCount': 'Bestellungen',
    'leaderboard.RestaurantSearchPlaceholder': 'Restaurant suchen',
    'tile.genericErrorMessage': 'Ein Fehler ist aufgetreten!',
    'tile.errorHint': 'Bitte aktualisieren Sie die Daten',
    'random.or': 'oder',
    'tooltip.example.label': 'Beispiel:',
    'iopay.configuration.title': 'Adyen-Einstellungen',
    'iopay.commissions.online.title': 'Online-Provisionen',
    'iopay.commissions.proximity.title': 'Proximity-Provisionen',
    'iopay.form.name': 'Bezeichnung',
    'iopay.form.placeholder.name': 'Bezeichnung',
    'iopay.form.accountHolder': 'Kontoinhaber-ID',
    'iopay.form.placeholder.accountHolder': 'AH111222AAABBB',
    'iopay.form.balanceAccount': 'Finanzkonto-ID',
    'iopay.form.placeholder.balanceAccount': 'BA111222AAABBB',
    'iopay.form.storeId': 'Händler-ID',
    'iopay.form.placeholder.storeId': 'Händler-ID',
    'iopay.form.transferInstrumentId': 'Transferinstrument-ID',
    'iopay.form.placeholder.transferInstrumentId': 'SE111222AAABBB',
    'iopay.form.fixOnlineCommissionAmount': 'Betrag der fixen Provisionen (in Eurocent)',
    'iopay.form.fixProximityCommissionAmount': 'Betrag der fixen Provisionen (in Eurocent)',
    'iopay.form.placeholder.fixOnlineCommissionAmount': 'Betrag der fixen Provisionen (in Eurocent)',
    'iopay.form.placeholder.fixProximityCommissionAmount': 'Betrag der fixen Provisionen (in Eurocent)',
    'iopay.form.variableOnlineCommissionPercent': 'Prozentsatz der variablen Provisionen',
    'iopay.form.variableProximityCommissionPercent': 'Prozentsatz der variablen Provisionen',
    'iopay.form.placeholder.variableOnlineCommissionPercent': 'Prozentsatz der variablen Provisionen',
    'iopay.form.placeholder.variableProximityCommissionPercent': 'Prozentsatz der variablen Provisionen',
    'edenred.configuration.title': 'Konfiguration des Edenred-Moduls',
    'edenred.form.description':
        'Konfigurieren Sie die Edenred-Integration, indem Sie die erforderlichen Informationen eingeben. Nach dem Speichern wird die Händler-ID des Restaurants automatisch abgerufen.',
    'edenred.form.warning.toSend': 'Informationen gespeichert und vor dem Versand an Edenred noch änderbar.',
    'edenred.form.warning.sent': 'Wird derzeit von Edenred bearbeitet.',
    'edenred.form.mid': 'Händler-ID',
    'edenred.form.name': 'Restaurantname',
    'edenred.form.placeholder.name': 'Name meines Restaurants',
    'edenred.form.siret': 'Siret',
    'edenred.form.placeholder.siret': '12345678900012',
    'edenred.form.address': 'Adresse',
    'edenred.form.placeholder.address': '5 avenue Anatole France',
    'edenred.form.zipCode': 'Postleitzahl',
    'edenred.form.placeholder.zipCode': '75007',
    'edenred.form.city': 'Stadt',
    'edenred.form.placeholder.city': 'Paris',
    'paygreen.configuration.title': 'Konfiguration des Moduls für Essensgutscheine',
    'paygreen.form.description':
        'Sobald Ihr Konto über das oben bereitgestellte Formular erstellt wurde, werden Ihnen die öffentlichen und privaten Schlüssel zur Modulkonfiguration übermittelt.',
    'paygreen.form.ongoing_v3_migration':
        'Eine Migration auf eine neue Paygreen-Version ist in Vorbereitung. Es ist keine Aktion im Back-Office Ihrerseits erforderlich.',
    'paygreen.form.enablePaygreenV3': 'Paygreen V3 aktivieren',
    'paygreen.form.label': 'Name der Integration',
    'paygreen.form.publicKey': 'V2 Öffentlicher Schlüssel (shopId)',
    'paygreen.form.privateKey': 'V2 Privater Schlüssel (token)',
    'paygreen.form.secretKey': 'V3 Geheimschlüssel',
    'paygreen.form.shopId': 'V3 Shop ID',
    'paygreen.form.subShopId': 'V3 Unter-Shop-ID (nur im Marketplace-Modus ausfüllen)',
    'paygreen.form.supportsLuncheon': 'Zahlungen mit Pass Restaurant (Sodexo) oder Chèque Déjeuner (Up)',
    'paygreen.form.supportsSwile': 'Zahlungen mit Swile (ehem. Lunchr)',
    'paygreen.form.supportsRestoflash': 'Zahlungen mit Resto Flash',
    'paygreen.form.placeholder.enablePaygreenV3': 'Paygreen V3 aktivieren',
    'paygreen.form.placeholder.label': 'Name der Integration',
    'paygreen.form.placeholder.publicKey': 'V2 Öffentlicher Schlüssel (shopId)',
    'paygreen.form.placeholder.privateKey': 'V2 Privater Schlüssel (token)',
    'paygreen.form.placeholder.secretKey': 'V3 Geheimschlüssel',
    'paygreen.form.placeholder.shopId': 'V3 Shop ID',
    'paygreen.form.placeholder.subShopId': 'V3 Unter-Shop-ID (nur im Marketplace-Modus ausfüllen)',
    'paygreen.form.placeholder.supportsLuncheon': 'Zahlungen mit Pass Restaurant (Sodexo) oder Chèque Déjeuner (Up)',
    'paygreen.form.placeholder.supportsSwile': 'Zahlungen mit Swile (ehem. Lunchr)',
    'paygreen.form.placeholder.supportsRestoflash': 'Zahlungen mit Resto Flash',
    'ubereats.title': 'UberEats-Einstellungen',
    'ubereats.description.firstpart':
        'Konfigurieren Sie Ihre UberEats-Integration, indem Sie Ihre UUID-Referenz aus der UberEats-Oberfläche Ihres Restaurants eingeben. Falls Sie nicht wissen, wo Sie diese Information finden:',
    'ubereats.description.secondpart': 'Wie finde ich die Store ID meines Restaurants?',
    'ubereats.description.thirdpart':
        'Nach der Konfiguration empfängt Ihre Kasse automatisch UberEats-Bestellungen im Bereich Lieferung.',
    'ubereats.storid': 'Shop-ID',
    'ubereats.activestorids': 'Aktive Store-ID(s)',
    'deliverect.title': 'Konfiguration des Deliverect-Moduls',
    'deliverect.subtitle': 'Wie konfiguriere ich meine Integration mit Deliverect?',
    'deliverect.description.firstpart':
        'Sie müssen sich zunächst an einen Account Manager wenden, damit Sie ein Konto in der Deliverect-Umgebung anlegen können.',
    'deliverect.description.secondpart':
        'Sobald dieses Konto aktiviert ist, können Sie die Weiterleitung von Bestellungen an die Kanäle Ihrer Wahl direkt über diese Oberfläche aktivieren.',
    'deliverect.description.thirdpart':
        'Sie können außerdem die Synchronisierung Ihrer Produkte über die Oberfläche vornehmen.',
    'deliverect.contact': 'Account Manager kontaktieren',
    'deliveroo.title': 'Konfiguration des Deliveroo-Moduls',
    'deliveroo.subtitle': 'Wie konfiguriere ich meine Integration mit Deliveroo?',
    'deliveroo.description.firstpart':
        'Sie müssen sich zunächst an einen Account Manager wenden, damit Sie ein Konto in der Deliveroo-Umgebung anlegen können.',
    'deliveroo.description.secondpart':
        'Sobald dieses Konto konfiguriert ist, empfängt Ihre Kasse automatisch Deliveroo-Bestellungen im Bereich Lieferung.',
    'deliveroo.description.thirdpart':
        'Sie können außerdem die Synchronisierung Ihrer Produkte über die Deliveroo-Oberfläche vornehmen.',
    'deliveroo.contact': 'Account Manager kontaktieren',
    'crous.title': 'Konfiguration des CROUS-Katalogsynchronisierungsmoduls',
    'crous.description':
        'Wählen Sie das Restaurant aus, dessen Katalog Sie importieren möchten, und geben Sie die vom Kunden mitgeteilte Kassennummer des CROUS (pos_id) ein.',
    'crous.listcrousrestaurants.label': 'CROUS-Restaurants',
    'crous.listcrousrestaurants.placeholder': 'Restaurant auswählen',
    'crous.numerocaisse.label': 'CROUS-Kassennummer',
    'crous.numerocaisse.placeholder': 'Bitte geben Sie die CROUS-Kassennummer ein',
    'crous.apikey.label': 'CROUS-API-Schlüssel',
    'crous.apikey.placeholder': 'Bitte geben Sie den CROUS-API-Schlüssel ein',
    'marketplace.vatdefault.placeholder': 'Standard-MwSt. (%)',
    'marketplace.vatdefault.message': 'Standard-MwSt.',
    'marketplace.storid.label': 'ID Ihrer Standorte:',
    'marketplace.storid.placeholder': 'Standort-ID(s) angeben',
    'marketplace.storid.unknown': 'Shop-ID unbekannt',
    'marketplace.storid.alreadyused': 'Diese UUID ist bereits vorhanden ({name})',
    'marketplace.activestorids.label': 'Aktive virtuelle Marken:',
    'marketplace.activestorids.emptystate': 'Sie haben keine aktive virtuelle Marke',
    'marketplace.location.title': 'Marke {counter}',
    'marketplace.location.delete': 'Löschen',
    'status.status': 'Status',
    'status.active': 'Aktiv',
    'status.inactive': 'Inaktiv',
    'status.disabled': 'Nicht verfügbar',
    'status.loading': 'Wird geladen',
    'status.unknown': 'Unbekannt',
    'status.new': 'Neu',
    'status.file_uploaded': 'Datei hochgeladen',
    'status.processing': 'Wird verarbeitet',
    'status.done': 'Abgeschlossen',
    'status.error': 'Fehler',
    'date.created': 'Erstellungsdatum',
    'date.updated': 'Änderungsdatum',
    'external_pos.pos_ref.label': 'Deliverect-POS-ID:',
    'external_pos.pos_ref.placeholder': 'ID Ihres Deliverect-POS angeben',
    'external_pos.title': 'Konfiguration des externen Deliverect-POS',
    'external_pos.subtitle': 'Wie konfiguriere ich meinen externen Deliverect-POS?',
    'external_pos.description.firstpart':
        'Sie müssen sich zunächst an einen Account Manager wenden, damit Sie ein Konto in der Deliverect-Umgebung anlegen können.',
    'external_pos.description.secondpart':
        'Sobald Ihr externer Deliverect-POS konfiguriert ist, empfängt er Bestellungen, die über die aktivierten Innovorder-Kanäle eingehen.',
    'external_pos.description.thirdpart':
        'Mit dieser Integration empfehlen wir Ihnen, Ihre Menüs über Deliverect zu verwalten und zu synchronisieren.',
    'external_pos.contact': 'Account Manager kontaktieren',
    'external_pos.channels.title': 'Externe Deliverect-POS-Integration:',
    'external_pos.channels.subtitle': 'Aktive Kanäle:',
    'webhook_url.label': 'Webhook-URL',
    'webhook_url.placeholder': 'Webhook-URL',
    'webhook_secret.label': 'Geheimer Webhook-Schlüssel',
    'webhook_secret.placeholder': 'Geheimen Webhook-Schlüssel eingeben',
    'webhook.headers.label': 'Zusätzliche HTTP-Header',
    'webhook.headers.name.placeholder': 'Header-Name',
    'webhook.headers.value.placeholder': 'Header-Wert',
    'webhook.channels.title': 'Webhook-Auslösekanäle',
    'webhook.channels.subtitle': 'Verfügbare Kanäle:',
    'webhook.title': 'Webhook-Konfiguration',
    'webhook.firstpart.subtitle': 'Zweck dieses Webhooks',
    'webhook.firstpart.description':
        'Dieser Webhook hat die Aufgabe, Sie zu benachrichtigen, wenn eine Bestellung von einem Ihrer Gäste über Innovorder aufgegeben wurde.\nFalls ein Verkauf für einen per Badge identifizierten Gast stattfindet, wird dieser Webhook aufgerufen, um die relevanten Informationen zu dieser Bestellung zu übermitteln.',
    'webhook.secondpart.subtitle': 'Wie konfiguriere ich den Webhook?',
    'webhook.secondpart.description':
        'Die Webhook-URL muss eingetragen werden.\nDer geheime Webhook-Schlüssel wird automatisch generiert.\nKlicken Sie einfach auf die Kanäle, die für diesen Webhook aktiviert werden sollen.\nNach der Konfiguration muss der Dienst einen HTTP-Antwortcode 200 mit leerem Antworttext zurückgeben, um den Empfang des Webhook-Ereignisses zu bestätigen.',
    'webhook.documentationLink': 'Dokumentation zu diesem Webhook aufrufen',
    'webhook.modal.warning': 'Achtung',
    'webhook.modal.confirmDelete': 'Möchten Sie diesen Eintrag wirklich löschen?',
    'webhook.channels.kiosk': 'Kiosk',
    'webhook.channels.web': 'CEL',
    'webhook.channels.pos': 'POS',
    'webhook.channels.trayScan': 'Tablettscanner',
    'webhook.channels.vendingMachine': 'Automat',
    'webhook.eventTypes.title': 'Ereignistypen',
    'webhook.eventTypes.subtitle': 'Verfügbare Ereignistypen:',
    'webhook.brand.title': 'Webhook-Konfiguration',
    'webhook.brand.firstpart.subtitle': 'Zweck dieses Webhooks',
    'webhook.brand.firstpart.description':
        'Webhooks ermöglichen es Ihnen, Echtzeit-Benachrichtigungen zu erhalten, wenn bestimmte Ereignisse in Ihrem Innovorder-System auftreten. Sie können Webhooks konfigurieren, die durch verschiedene Ereignisse ausgelöst werden, z. B. Aktualisierungen von Kundendaten, Transaktionsereignisse oder Bestellbenachrichtigungen. Wenn ein Ereignis eintritt, sendet Innovorder eine HTTP-POST-Anfrage an Ihren angegebenen Endpunkt mit den relevanten Daten.',
    'webhook.brand.secondpart.subtitle': 'Wie konfiguriere ich den Webhook?',
    'webhook.brand.secondpart.description':
        '1. Geben Sie die Webhook-URL an, an die Sie Benachrichtigungen erhalten möchten.\n2. Wählen Sie die Ereignistypen aus, die Sie überwachen möchten.\n3. Wählen Sie die Kanäle aus, für die diese Ereignisse den Webhook auslösen sollen.\n4. Fügen Sie bei Bedarf zusätzliche HTTP-Header hinzu.\n5. Der geheime Webhook-Schlüssel wird automatisch zur Sicherung generiert.\n\nIhr Endpunkt muss einen HTTP-Statuscode 200 zurückgeben, um den Empfang des Webhook-Ereignisses zu bestätigen.',
    'webhook.system.badge': 'System',
    'webhook.system.readonly': 'Dieser Webhook wird vom System verwaltet und kann nicht geändert werden.',
    'login.panelTitle': 'Willkommen in Ihrem Back-Office',
    'login.login': 'Anmelden',
    'login.password': 'Passwort',
    'login.ssoChecking': 'SSO wird überprüft…',
    'login.ssoEnabled': 'SSO ist für diese E-Mail-Adresse aktiviert.',
    'login.ssoLogin': 'Mit SSO anmelden',
    'login.ssoFailed': 'SSO-Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.',
    'login.ssoLoginRequired': 'Dieses Konto erfordert eine SSO-Anmeldung. Weiterleitung läuft…',
    'login.noBrandsConfigured': 'Für diesen Benutzer ist keine Marke konfiguriert.',
    'login.guestBrandLoginFailed': 'Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.',
    'login.rememberMe': 'Angemeldet bleiben',
    'login.forgotPassword': 'Passwort vergessen?',
    'login.accountLocked': 'Konto vorübergehend gesperrt. Versuchen Sie es in {minutes} Minuten erneut.',
    'login.captchaRequired': 'Sicherheitsüberprüfung erforderlich.',
    'login.ipNotAllowed': 'Anmeldung von dieser IP-Adresse nicht erlaubt.',
    'login.accountDisabled': 'Dieses Konto wurde wegen Inaktivität deaktiviert.',
    'extendAccount.title': 'Verlängerung Ihres Kontos',
    'extendAccount.loadingBody': 'Link wird überprüft…',
    'extendAccount.successTitle': 'Konto verlängert',
    'extendAccount.successBody': 'Ihr Konto wurde verlängert. Sie können sich jetzt wieder anmelden.',
    'extendAccount.invalidTitle': 'Ungültiger Link',
    'extendAccount.invalidBody': 'Dieser Verlängerungslink ist ungültig oder abgelaufen.',
    'extendAccount.expiredHint':
        'Um den Zugriff auf Ihr Konto wiederherzustellen, wenden Sie sich an Ihren Administrator.',
    'extendAccount.missingTokenBody': 'Der Link ist unvollständig. Bitte öffnen Sie den Link erneut aus Ihrer E-Mail.',
    'extendAccount.backToLogin': 'Zurück zur Anmeldung',
    'forgotPassword.title': 'Passwort vergessen',
    'forgotPassword.subtitle': 'Geben Sie Ihre E-Mail-Adresse ein, um einen Zurücksetzungslink zu erhalten.',
    'forgotPassword.submit': 'Link senden',
    'forgotPassword.backToLogin': 'Zurück zur Anmeldung',
    'forgotPassword.successTitle': 'E-Mail gesendet',
    'forgotPassword.successMessage':
        'Wenn für diese E-Mail-Adresse ein Konto existiert, wurde soeben ein Zurücksetzungslink gesendet. Bitte überprüfen Sie Ihren Posteingang.',
    'forgotPassword.recaptchaLoading': 'reCAPTCHA wird geladen…',
    'forgotPassword.recaptchaFailed': 'reCAPTCHA-Überprüfung fehlgeschlagen. Bitte versuchen Sie es erneut.',
    'forgotPassword.recaptchaUnavailable':
        'reCAPTCHA nicht verfügbar. Bitte laden Sie die Seite neu und versuchen Sie es erneut.',
    'forgotPassword.recaptchaNotConfigured':
        'Konfiguration fehlt (REACT_APP_RECAPTCHA_SITE_KEY). Bitte wenden Sie sich an den Administrator.',
    'resetPassword.title': 'Neues Passwort',
    'resetPassword.subtitle': 'Wählen Sie ein neues Passwort für Ihr Konto.',
    'resetPassword.submit': 'Zurücksetzen',
    'resetPassword.backToLogin': 'Zurück zur Anmeldung',
    'resetPassword.successTitle': 'Passwort aktualisiert',
    'resetPassword.successMessage': 'Ihr Passwort wurde erfolgreich aktualisiert. Sie können sich jetzt anmelden.',
    'resetPassword.invalidLinkTitle': 'Ungültiger Link',
    'resetPassword.invalidLink':
        'Dieser Zurücksetzungslink ist ungültig oder abgelaufen. Fordern Sie bitte einen neuen Link über die Anmeldeseite an.',
    'resetPassword.passwordTooShort': 'Das Passwort muss mindestens {min} Zeichen enthalten.',
    'resetPassword.passwordsMismatch': 'Die beiden Passwörter stimmen nicht überein.',
    'mfa.verify.title': 'Zwei-Faktor-Verifizierung',
    'mfa.verify.subtitle': 'Geben Sie den 6-stelligen Code ein, der von Ihrer Authenticator-App generiert wurde.',
    'mfa.verify.backupTitle': 'Backup-Code',
    'mfa.verify.backupSubtitle': 'Geben Sie einen Ihrer Einmal-Backup-Codes ein.',
    'mfa.verify.submit': 'Verifizieren',
    'mfa.verify.useBackupInstead': 'Stattdessen einen Backup-Code verwenden',
    'mfa.verify.useTotpInstead': 'Authenticator-App verwenden',
    'mfa.verify.useDifferentMethod': 'Eine andere Methode verwenden',
    'mfa.verify.chooser.title': 'Methode wählen',
    'mfa.verify.chooser.subtitle': 'Mit welcher Methode möchten Sie Ihre Identität bestätigen?',
    'mfa.verify.chooser.webauthnHint': 'Verwenden Sie Ihren Sicherheitsschlüssel oder Ihre Biometrie.',
    'mfa.verify.chooser.totpHint': 'Geben Sie den Code aus Ihrer Authenticator-App ein.',
    'mfa.verify.failed': 'Ungültiger Code. Bitte versuchen Sie es erneut.',
    'mfa.verify.tokenExpired': 'Die MFA-Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
    'mfa.verify.tabs.totp': 'Authentifizierungs-App',
    'mfa.verify.tabs.webauthn': 'Sicherheitsschlüssel / Biometrie',
    'mfa.verify.webauthn.title': 'Mit Ihrem Sicherheitsschlüssel verifizieren',
    'mfa.verify.webauthn.subtitle':
        'Berühren Sie Ihren Sicherheitsschlüssel, verwenden Sie Touch ID oder einen anderen Plattform-Authentifikator.',
    'mfa.verify.webauthn.authenticate': 'Authentifizieren',
    'mfa.verify.webauthn.failed': 'Authentifizierung fehlgeschlagen. Bitte versuchen Sie eine andere Methode.',
    'mfa.verify.webauthn.noCredentials': 'Für dieses Konto ist kein Sicherheitsschlüssel registriert.',
    'mfa.verify.webauthn.ceremonyFailed':
        'Die Authentifizierung wurde abgebrochen oder Ihr Browser hat sie abgelehnt. Bitte versuchen Sie es erneut.',
    'mfa.setup.title': 'Zwei-Faktor-Authentifizierung einrichten',
    'mfa.setup.subtitle':
        'Scannen Sie diesen QR-Code mit Ihrer Authenticator-App (Google Authenticator, 1Password usw.) und geben Sie dann den generierten Code ein.',
    'mfa.setup.loadingQr': 'QR-Code wird geladen...',
    'mfa.setup.copySecret': 'Geheimen Schlüssel kopieren',
    'mfa.setup.copied': 'Kopiert!',
    'mfa.setup.confirm': 'Bestätigen',
    'mfa.setup.invalidCode': 'Ungültiger Code. Überprüfen Sie die Synchronisierung Ihrer App.',
    'mfa.setup.backupTitle': 'Sichern Sie Ihre Backup-Codes',
    'mfa.setup.backupSubtitle':
        'Bewahren Sie diese Codes an einem sicheren Ort auf. Sie ermöglichen es Ihnen, sich anzumelden, falls Sie den Zugriff auf Ihre Authenticator-App verlieren. Jeder Code kann nur einmal verwendet werden.',
    'mfa.setup.backupAcknowledge': 'Ich habe meine Codes gespeichert, weiter',
    'mfa.setup.tabs.totp': 'Authentifizierungs-App',
    'mfa.setup.tabs.webauthn': 'Sicherheitsschlüssel / Biometrie',
    'mfa.setup.webauthn.title': 'Sicherheitsschlüssel registrieren',
    'mfa.setup.webauthn.subtitle':
        'Verwenden Sie einen Hardware-Schlüssel (YubiKey), Touch ID, Windows Hello oder einen anderen Plattform-Authentifikator. Sie können dieses Gerät benennen, um es später zu identifizieren.',
    'mfa.setup.webauthn.deviceNamePlaceholder': "Gerätename (z. B. 'Mein Laptop')",
    'mfa.setup.webauthn.register': 'Registrieren',
    'mfa.setup.webauthn.ceremonyFailed':
        'Die Registrierung wurde abgebrochen oder Ihr Browser hat die Anfrage abgelehnt. Bitte versuchen Sie es erneut.',
    'mfa.setup.webauthn.finalizing': 'Sicherheitsschlüssel wird abgeschlossen…',
    'activateAccount.title': 'Kontoaktivierung',
    'activateAccount.submit': 'Mein Konto aktivieren',
    'activateAccount.submitting': 'Aktivierung läuft...',
    'activateAccount.loading': 'Token wird überprüft...',
    'activateAccount.resend': 'Aktivierungs-E-Mail erneut senden',
    'activateAccount.resending': 'Wird erneut gesendet...',
    'activateAccount.renewSuccess':
        'Eine neue Aktivierungs-E-Mail wurde gesendet. Bitte überprüfen Sie Ihren Posteingang.',
    'activateAccount.error.missingToken': 'Token fehlt',
    'activateAccount.error.invalidToken': 'Token abgelaufen',
    'activateAccount.error.password.minLength': 'Das Passwort muss mindestens {min} Zeichen enthalten',
    'activateAccount.error.password.maxLength': 'Das Passwort darf maximal {max} Zeichen enthalten',
    'activateAccount.error.password.requireUppercase': 'Das Passwort muss mindestens einen Großbuchstaben enthalten',
    'activateAccount.error.password.requireLowercase': 'Das Passwort muss mindestens einen Kleinbuchstaben enthalten',
    'activateAccount.error.password.requireNumbers': 'Das Passwort muss mindestens eine Ziffer enthalten',
    'activateAccount.error.password.requireSpecialCharacters':
        'Das Passwort muss mindestens ein Sonderzeichen enthalten',
    'activateAccount.password.placeholder': 'Passwort',
    'activateAccount.confirmPassword.placeholder': 'Passwort bestätigen',
    'sidebar.overview': 'Übersicht',
    'sidebar.orders': 'Bestellungen',
    'sidebar.customers': 'Kunden',
    'sidebar.brand': 'Marke',
    'sidebar.brands': 'Marken',
    'sidebar.restaurants': 'Restaurants',
    'sidebar.loyalty': 'Kundenbindung',
    'sidebar.coupons': 'Aktionscodes',
    'sidebar.paymentMeans': 'Zahlungsmittel',
    'sidebar.integrations': 'Integrationen',
    'sidebar.reports': 'Berichte',
    'sidebar.reportsSales': 'Umsätze',
    'sidebar.reportsEwallets': 'Badge-Guthaben',
    'sidebar.monthly_sales_report': 'Monatlicher Umsatzbericht',
    'sidebar.exports': 'Exporte',
    'sidebar.exportsAccounting': 'Buchhaltung',
    'sidebar.exportsEwallets': 'E-Wallet',
    'sidebar.exportsSales': 'Finanzübersicht',
    'sidebar.salesSummary': 'Finanzübersicht',
    'sidebar.exportsPreInvoicing': 'Vorfakturierung',
    'sidebar.exportsBadge': 'Badge-Bewegungen',
    'sidebar.reportGenerationsHistory': 'Generierungsverlauf',
    'sidebar.help': 'Hilfe benötigt?',
    'sidebar.languages': 'Sprachen',
    'sidebar.account': 'Mein Konto',
    'sidebar.media': 'Medien',
    'sidebar.marketplaces': 'Marktplätze',
    'sidebar.urssaf': 'URSSAF-Minimum',
    'sidebar.vatRatesMatrix': 'MwSt.-Referenz',
    'sidebar.autoBilling': 'Automatische Fakturierung',
    'sidebar.logout': 'Abmelden',
    'sidebar.password': 'Mein Passwort',
    'sidebar.security': 'Sicherheit',
    'security.title': 'Sicherheit',
    'security.loading': 'Wird geladen…',
    'security.actions.remove': 'Entfernen',
    'security.actions.cancel': 'Abbrechen',
    'security.totp.title': 'Authentifizierungs-App',
    'security.totp.subtitle':
        'Einmalcodes, die von einer App wie Google Authenticator oder 1Password generiert werden.',
    'security.totp.label': 'Authentifizierungs-App',
    'security.totp.added': 'Hinzugefügt am {date}',
    'security.totp.empty': 'Keine Authentifizierungs-App konfiguriert.',
    'security.totp.add': 'Authentifizierungs-App hinzufügen',
    'security.totp.modalTitle': 'Authentifizierungs-App einrichten',
    'security.totp.confirmRemove': 'Möchten Sie Ihre Authentifizierungs-App wirklich entfernen?',
    'security.passkeys.title': 'Sicherheitsschlüssel und Passkeys',
    'security.passkeys.subtitle':
        'Hardware-Schlüssel, Touch ID, Windows Hello und andere für dieses Konto registrierte Authentifikatoren.',
    'security.passkeys.empty': 'Keine Sicherheitsschlüssel registriert.',
    'security.passkeys.unnamedDevice': 'Unbenanntes Gerät',
    'security.passkeys.lastUsed': 'Zuletzt verwendet: {date}',
    'security.passkeys.added': 'Hinzugefügt am {date}',
    'security.passkeys.add': 'Sicherheitsschlüssel hinzufügen',
    'security.passkeys.confirmRemove':
        'Möchten Sie diesen Schlüssel wirklich entfernen? Sie können sich mit diesem Gerät dann nicht mehr anmelden.',
    'security.passkeys.ceremonyFailed':
        'Die Registrierung wurde abgebrochen oder Ihr Browser hat sie abgelehnt. Bitte versuchen Sie es erneut.',
    'security.passkeys.requestFailed': 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
    'security.allowedIps.title': 'Erlaubte IP-Adressen',
    'security.allowedIps.subtitle':
        'Beschränken Sie Ihre Anmeldung auf eine Liste von IPs oder CIDR-Bereichen. Erlaubte IPs umgehen auch CAPTCHA und Sperrzähler.',
    'security.allowedIps.empty': 'Keine Einschränkung. Sie können sich von jeder IP-Adresse aus anmelden.',
    'security.allowedIps.add': 'Hinzufügen',
    'security.allowedIps.placeholder': '192.168.1.1 oder 10.0.0.0/24',
    'security.allowedIps.invalid': 'Ungültige IP-Adresse oder CIDR-Bereich.',
    'security.allowedIps.confirmRemoveTitle': 'Diese IP-Adresse entfernen?',
    'security.allowedIps.confirmRemove': 'Mit dieser Adresse kann sich niemand mehr bei Ihrem Konto anmelden.',
    'security.allowedIps.cancel': 'Abbrechen',
    'security.allowedIps.warning':
        'Achtung: Solange die Liste mindestens einen Eintrag enthält, können Sie sich nicht von einer anderen IP aus anmelden.',
    'sidebar.billing': 'Mein Abrechnungsbereich',
    'sidebar.ioPay': 'Zahlungen',
    'sidebar.news': 'Neuigkeiten',
    'sidebar.analytics': 'Analytics',
    'message.message': 'Nachricht',
    'name.name': 'Name',
    'name.firstName': 'Vorname',
    'name.lastName': 'Nachname',
    'notFound.message': 'Entschuldigung, die angeforderte Seite wurde nicht gefunden.',
    'notFound.backToHome': 'Zur Startseite zurückkehren',
    'permissionDenied.title': 'Zugriff verweigert',
    'permissionDenied.message': 'Es tut uns leid, aber Sie haben keine Berechtigung, auf diese Seite zuzugreifen.',
    'permissionDenied.backToHome': 'Zur Startseite zurückkehren',
    'errorPage.message':
        'Es tut uns leid, wir haben ein technisches Problem. Wir arbeiten mit Hochdruck daran, dieses Problem zu lösen!',
    'errorPage.support': 'Support kontaktieren',
    'file.noFile': 'Keine Datei',
    'file.cannotProcessJson': 'Die JSON-Datei kann nicht verarbeitet werden. Bitte überprüfen Sie das Format.',
    'file.fileNotAllowed': 'Dieser Dateityp ist nicht zulässig. Erlaubte Erweiterungen: {allowedExtensionsString}',
    'file.fileTemplate': 'Dateivorlage',
    'file.metabaseLink': 'Metabase-Link',
    'fileInput.placeholder.title': 'Dateien hier ablegen!',
    'fileInput.placeholder.drop': 'Dateien hier ablegen!',
    'fileInput.placeholder': 'Datei(en) per Drag & Drop in das Fenster ziehen',
    'fileInput.browse': 'Vom Computer importieren',
    'imageInput.section.modal.title': 'Bild hinzufügen',
    'imageInput.section.modal.resize.label': 'Hintergrundbildmodus',
    'imageInput.section.modal.resize.details':
        'Verwenden Sie diese Option, wenn Sie Bilder hochladen, die als Hintergrund für Kioske oder Online-Bestellungen verwendet werden.',
    'imageInput.section.library.title': 'Aus der Galerie',
    'imageInput.section.upload.title': 'Von meinem Computer',
    'languages.fr_FR': 'Französisch',
    'languages.en_EN': 'Englisch',
    'languages.it_IT': 'Italienisch',
    'languages.sodexo_SODEXO': 'Sodexo',
    'languages.es_ES': 'Spanisch',
    'languages.zh-CN_ZH-CN': 'Chinesisch (Vereinfacht)',
    'languages.zh-TW_ZH-TW': 'Chinesisch (Traditionell)',
    'languages.ar_AR': 'Arabisch',
    'languages.de_DE': 'Deutsch',
    'button.add': 'Hinzufügen',
    'button.delete': 'Löschen',
    'button.edit': 'Bearbeiten',
    'button.configure': 'Konfigurieren',
    'button.cancel': 'Abbrechen',
    'button.close': 'Schließen',
    'button.generate': 'Generieren',
    'button.save': 'Speichern',
    'button.import': 'Importieren',
    'button.publish': 'Veröffentlichen',
    'button.saveAndPublish': 'Speichern und veröffentlichen',
    'button.uploadFile': 'Datei hochladen',
    'button.previous': 'Zurück',
    'button.next': 'Weiter',
    'button.ok': 'OK',
    'button.validate': 'Bestätigen',
    'button.refresh': 'Aktualisieren',
    'button.confirm': 'Bestätigen',
    'button.yes': 'Ja',
    'button.understand': 'Verstanden',
    'button.convertToCrossSell': 'In Zusatzverkauf umwandeln',
    'button.convertToCustomization': 'In Personalisierung umwandeln',
    'button.skipStep': 'Diesen Schritt überspringen',
    'button.block': 'Sperren',
    'button.unblock': 'Entsperren',
    'select.selectAll': 'Alle auswählen',
    'switch.activate': 'Aktivieren',
    'form.preventLeave': 'Sie haben nicht gespeicherte Änderungen. Möchten Sie diese Seite wirklich verlassen?',
    'field.required': 'Dieses Feld ist erforderlich',
    'field.optional': '(optional)',
    'field.greaterThanZero': 'Dieser Wert muss größer als 0 sein',
    'field.invalidEmail': 'Diese E-Mail-Adresse ist ungültig',
    'field.invalidURL': 'Diese URL ist ungültig',
    'field.atLeastOneEventType': 'Es muss mindestens ein Ereignistyp ausgewählt werden',
    'field.unmatchedPassword': 'Die beiden Passwörter müssen identisch sein',
    'field.invalidPassword': 'Ihr Passwort muss mindestens 8 Zeichen enthalten',
    'field.invalidPhoneNumber': 'Ungültige Telefonnummer',
    'field.duplicate_email': 'Diese E-Mail-Adresse ist bereits vorhanden',
    'field.duplicate_student_number': 'Diese Gästenummer ist bereits vorhanden',
    'field.duplicate_badge_number': 'Diese Badge-Nummer ist bereits vorhanden',
    'field.minTwo': 'Dieses Feld muss mindestens 2 Zeichen enthalten',
    'field.ewallet_is_not_null_to_postpayment':
        'Um den Gast in ein Nachzahlerkonto umzuwandeln, muss sein Guthaben zwingend auf 0 € stehen',
    'select.enabled': 'Aktiviert',
    'select.customised': 'Angepasst',
    'select.disabled': 'Deaktiviert',
    'table.search': 'Suchen',
    'table.searchColumn': '{name} suchen',
    'table.searchColumn.placeholder': 'Wert suchen',
    'table.searchColumn.placeholder.from': 'Min',
    'table.searchColumn.placeholder.to': 'Max',
    'table.searchColumn.clearFilter': 'Filter entfernen',
    'table.clearAllFilters': 'Alle Filter entfernen',
    'table.rowsPerPage': 'Zeilen pro Seite',
    'table.firstPage': 'Erste',
    'table.lastPage': 'Letzte',
    'table.noRowsAfterFilter': 'Keine Ergebnisse entsprechen Ihrer Suche',
    'table.noRowsAfterFilter.dateRangeHint': 'Haben Sie versucht, den Datumsbereich zu ändern?',
    'table.noRowsAfterFilter.dateRangePresetHint': 'Keine Ergebnisse für die letzten {days} Tage.',
    'table.noRowsAfterFilter.dateRangeCustomHint': 'Keine Ergebnisse für den ausgewählten Zeitraum.',
    'table.noRowsAfterFilter.dateRangeAction': 'Ändern Sie das Datumsfenster, um Bestellungen anzuzeigen.',
    'table.sort': 'Sortieren nach {name}',
    'table.columnSelection.button': 'Spaltenverwaltung',
    'table.columnSelection.buttonFiltered': 'Spaltenverwaltung ({count})',
    'table.columnSelection.header': 'Spalten filtern',
    'table.columnSelection.placeholder': 'Spalte suchen',
    'table.columnSelection.allEntries': 'Alle Spalten',
    'table.selection.count': '{count} {count, plural, =1 {Zeile} other {Zeilen}} ausgewählt',
    'table.empty': 'Keine Daten verfügbar',
    'pagination.previous': 'Zurück',
    'pagination.next': 'Weiter',
    'navigation.back': 'Zurück',
    'navigation.next': 'Weiter',
    'navigation.disabled': 'Zurück',
    'navigation.backToV1': 'Zur alten Version zurückkehren',
    'savingBar.changesDone':
        '{changesCount, plural, =0 {} one {# Änderung vorgenommen} other {# Änderungen vorgenommen}}',
    'ticketLabel.name.mismatch.confirmation':
        'Achtung: Der Produktname wurde geändert, die Produktionsbezeichnung blieb jedoch gleich. Möchten Sie diese Änderung wirklich bestätigen?',
    'form.validation.integer': 'Dieses Feld muss eine ganze Zahl sein',
    'form.validation.positive': 'Dieses Feld muss positiv sein',
    'form.validation.positiveOrZero': 'Dieses Feld muss positiv oder null sein',
    'form.validation.length': 'Dieses Feld muss {length} Zeichen enthalten',
    'form.validation.maxLength': 'Dieses Feld überschreitet die zulässige Länge',
    'form.validation.email': 'Dieses Feld muss eine gültige E-Mail-Adresse sein',
    'form.validation.mustMatchValue': 'Dieses Feld muss {value1} oder {value2 } sein',
    'form.validation.siret.length': 'Die SIRET-Nummer muss genau 14 Zeichen lang sein (ohne Leerzeichen)',
    'form.validation.siret.invalid': 'Die SIRET-Nummer ist ungültig',
    'integrations.section.title': 'Zahlungslösungen',
    'integrations.section.subtitle':
        'Zahlungslösungen ermöglichen es Ihnen, Funktionen wie Online-Kartenzahlung oder Zahlung am Kartenterminal am Point of Sale anzubieten.',
    'integrations.stripe': 'Stripe',
    'integrations.stripeDescription':
        'Integrieren Sie Stripe in Ihre Website und ermöglichen Sie Ihren Kunden, ihr Konto einfach zu verbinden – für ein optimales Online-Bestellerlebnis.',
    'integrations.configured': 'Konfiguriert',
    'integrations.notConfigured': 'Nicht konfiguriert',
    'integrations.webhooks.title': 'Webhooks',
    'integrations.webhooks.description':
        'Die verschiedenen Webhook-Integrationen sind hier aufgelistet. Sie können einen neuen Webhook erstellen, indem Sie auf die Schaltfläche "+" klicken, oder einen vorhandenen Webhook bearbeiten, indem Sie darauf klicken. Ein Status zeigt den Konfigurationszustand an.',
    'pricingRule.emptyMessage': 'Kein Tarif mit dieser Marke verknüpft.',
    'pricingRule.tableCard.title': 'Tarife',
    'pricingRule.tableCard.subtitle':
        'Tarife sind Zusammenstellungen aus einer oder mehreren Zutrittsgebühren, Subventionen und umsatzexkludierten Komponenten.',
    'pricingRule.tableCard.description':
        'Wenn der Tarif eine prozentuale und eine absolute Subvention enthält, platzieren Sie die Subvention, die vom Gesamtbetrag der Bestellung abgezogen werden soll, an erster Stelle. Die folgenden Subventionen beziehen sich auf den nach Abzug der vorherigen Subventionen verbleibenden Betrag.',
    'pricingRule.tableCard.action': '+ Neuen Tarif erstellen',
    'pricingRule.code': 'Code',
    'pricingRule.applyScope': 'Strategie',
    'pricingRule.strategy': 'Strategie',
    'pricingRule.labelTicket': 'Bonbezeichnung',
    'pricingRule.grants_fees.amount': 'Betrag',
    'pricingRule.grants_fees.dailyLimit': 'Tageslimit',
    'pricingRule.grants': 'Subventionen',
    'pricingRule.entranceFees': 'Zutrittsgebühren',
    'pricingRule.excludedTurnover': 'Umsatzexkludiert',
    'pricingRule.associatedPricingRules': 'Verknüpfte Tarife',
    'pricingRule.action': 'Aktion',
    'pricingRule.product': 'Lebensmittelanteil',
    'pricingRule.fee': 'Gebühren inkl. Zutrittsgebühr',
    'pricingRule.modal.warning': 'Achtung',
    'pricingRule.modal.required': 'Das Feld `Tarif` ist erforderlich',
    'pricingRule.modal.confirmDelete': 'Möchten Sie diesen Eintrag wirklich löschen?',
    'pricingRule.modal.delete.error.detail': 'Dieser Tarif ist mit einem oder mehreren Gästen verknüpft',
    'pricingRule.modal.unassociatedUser': 'Gast hat keinen Tarif mehr',
    'pricingRule.modal.unassociatedUsers': 'Gäste haben keinen Tarif mehr',
    'pricingRule.form.title': 'Tarif',
    'pricingRule.form.description':
        'Konfigurieren Sie den Tarif, indem Sie die gewünschten vorhandenen Subventionen zusammenstellen.',
    'pricingRule.form.creation': 'Tarif erstellen',
    'pricingRule.form.update': 'Tarif bearbeiten',
    'pricingRule.form.pricingRuleCode': 'Tarifcode',
    'pricingRule.form.applyScope': 'Strategie',
    'pricingRule.form.authorizedChannels': 'Autorisierte Kanäle',
    'pricingRule.form.isUrssafEnabled': 'URSSAF-Minimum auf diesen Tarif anwenden?',
    'pricingRule.form.composition': 'Zusammensetzung dieses Tarifs festlegen',
    'pricingRule.form.compositionDescription':
        'Tarife sind Zusammenstellungen aus einer oder mehreren Zutrittsgebühren, Subventionen und umsatzexkludierten Komponenten.',
    'pricingRule.emptyGrant': 'Keine Subvention mit diesem Tarif verknüpft.',
    'pricingRule.emptyEntranceFee': 'Keine Zutrittsgebühr mit diesem Tarif verknüpft.',
    'pricingRule.emptyTurnoverExcluded': 'Keine umsatzexkludierte Komponente mit diesem Tarif verknüpft.',
    'pricingRule.emptyAssociatedPricingRule': 'Kein verknüpfter Tarif mit diesem Tarif verbunden.',
    'pricingRule.noResult': 'Kein Ergebnis',
    'pricingRule.addGrant': 'Subvention hinzufügen',
    'pricingRule.addEntranceFee': 'Zutrittsgebühr hinzufügen',
    'pricingRule.addComponentWithoutTurnover': 'Umsatzexkludierte Komponente hinzufügen',
    'pricingRule.addAssociatedPricingRule': 'Verknüpften Tarif hinzufügen',
    'pricingRule.search': 'Tarif suchen',
    'pricingRule.channels.kiosk': 'Kiosk',
    'pricingRule.channels.pos': 'Kasse',
    'pricingRule.channels.web': 'Online-Bestellung',
    'pricingRule.channels.ewalletKiosk': 'Aufladekiosk',
    'pricingRule.channels.vendingMachine': 'Automat',
    'pricingRule.action.import': 'Importieren',
    'pricingRule.action.export': 'Exportieren',
    'pricingRule.modal.import.title': 'Zutrittsgebühren, Subventionen und Tarife importieren',
    'pricingRule.modal.import.firstPart': '{fileTemplate} auf Ihren Computer herunterladen',
    'pricingRule.modal.import.secondPart':
        'Die Vorlage mit den Informationen zu den hinzuzufügenden oder zu ändernden Zutrittsgebühren, Subventionen und Tarifen ausfüllen',
    'pricingRule.modal.import.thirdPart': 'Die neue Datei durch Klicken auf die Schaltfläche unten importieren',
    'pricingRule.modal.import.warning':
        'Das Löschen einer Zutrittsgebühr, Subvention oder eines Tarifs erfolgt ausschließlich über das Innovorder-Back-Office',
    'pricingRule.modal.import.secondWarning':
        '⚠️\nDer Import von Zutrittsgebühren oder Subventionen löscht ENDGÜLTIG die personalisierten Werte.\n(die per Restaurant oder Service personalisierten Werte)\n',
    'pricingRule.modal.import.report.title': 'Importbericht',
    'pricingRule.modal.import.report.result': 'Importergebnis',
    'pricingRule.modal.import.report.success': 'Erfolg',
    'pricingRule.modal.import.report.error': 'Fehler',
    'pricingRule.modal.import.report.warning': 'Warnung',
    'pricingRule.modal.import.report.entranceFees': 'Zutrittsgebühren',
    'pricingRule.modal.import.report.grants': 'Subventionen',
    'pricingRule.modal.import.report.pricingRules': 'Tarife',
    'pricingRule.modal.import.report.successMessage': '• Erstellt: {created}\n • Geändert: {updated}',
    'pricingRule.modal.import.report.errorMessage': '• Zeile {line} - {field}: {message}',
    'pricingRule.export.report.entranceFee.entranceFeeId': 'Zutrittsgebühren-ID',
    'pricingRule.export.report.entranceFee.code': 'Zutrittsgebührencode',
    'pricingRule.export.report.entranceFee.labelTicket': 'Bonbezeichnung',
    'pricingRule.export.report.entranceFee.amount': 'Betrag (in €)',
    'pricingRule.export.report.entranceFee.dailyLimit': 'Tageslimit',
    'pricingRule.export.report.entranceFee.strategy':
        'Strategie (1 für immer / 2 für Tageslimit + zugewiesenes Produkt)',
    'pricingRule.export.report.entranceFee.vat': 'MwSt.',
    'pricingRule.export.report.entranceFee.type': 'Umsatz (eingeschlossen/ausgeschlossen)',
    'pricingRule.export.report.entranceFee.type.admissionfee': 'eingeschlossen',
    'pricingRule.export.report.entranceFee.type.royaltyfee': 'ausgeschlossen',
    'pricingRule.export.report.entranceFee.active':
        'Standardmäßig in allen Restaurants aktiv (ja / nein) (gilt nur für die Erstellung)',
    'pricingRule.export.report.grant.grantId': 'Subventions-ID',
    'pricingRule.export.report.grant.code': 'Subventionscode',
    'pricingRule.export.report.grant.labelTicket': 'Bonbezeichnung',
    'pricingRule.export.report.grant.threshold': 'Auslöseschwelle in € (leer wenn keine)',
    'pricingRule.export.report.grant.type': 'Betragstyp (Absolut / Prozentsatz)',
    'pricingRule.export.report.grant.type.absolute': 'Absolut',
    'pricingRule.export.report.grant.type.rate': 'Prozentsatz',
    'pricingRule.export.report.grant.ceiling': 'Subventionsobergrenze in € (erforderlich wenn Typ = Prozentsatz)',
    'pricingRule.export.report.grant.amount': 'Betrag (in €)',
    'pricingRule.export.report.grant.dailyLimit': 'Tageslimit',
    'pricingRule.export.report.grant.strategy':
        'Strategie (1 für Tageslimit + Betrag / 2 für Tageslimit + Betrag + betroffene Produkte)',
    'pricingRule.export.report.grant.tag': 'Tags (leer wenn keine Anwendung auf Tags)',
    'pricingRule.export.report.grant.active': 'Standardmäßig in allen Restaurants aktiv (ja / nein)',
    'pricingRule.export.report.pricingRule.pricingRuleId': 'Tarif-ID',
    'pricingRule.export.report.pricingRule.code': 'Tarifcode',
    'pricingRule.export.report.pricingRule.canals':
        'Kanäle (Kasse, Aufladekiosk, Automat, Kiosk und/oder Online-Bestellung)',
    'pricingRule.export.report.pricingRule.isUrssafEnabled':
        'URSSAF-Minimum anwenden (nur für die Warenkorb-API)? (ja/nein)',
    'pricingRule.export.report.pricingRule.entranceFees':
        'Enthaltene Zutrittsgebühr(en) (Code angeben, bei mehreren durch Komma + Leerzeichen trennen)',
    'pricingRule.export.report.pricingRule.grants':
        'Enthaltene Subvention(en) (Code angeben, bei mehreren durch Komma + Leerzeichen trennen)',
    'pricingRule.export.report.pricingRule.includeCA': 'Enthaltene umsatzexkludierte Komponenten',
    'pricingRule.export.report.pricingRule.applyScope':
        'Strategie (Gebühren inkl. Zutrittsgebühr und/oder Lebensmittelanteil)',
    'pricingRule.export.report.pricingRule.applyScope.product': 'Lebensmittelanteil',
    'pricingRule.export.report.pricingRule.applyScope.fee': 'Gebühren inkl. Zutrittsgebühr',
    'entranceFee.create': 'Zutrittsgebühr erstellen',
    'entranceFee.title': 'Zutrittsgebühr',
    'entranceFee.description': 'Geben Sie Name, Betrag und Regeln der Zutrittsgebühr für alle Ihre Betriebe an.',
    'entranceFee.customUse': 'Besondere Anwendungen der Zutrittsgebühr',
    'entranceFee.descCustomUse': 'Aktivierung und Anpassung der Zutrittsgebühr pro Restaurant',
    'entranceFee.warningForm':
        'Füllen Sie alle Felder Ihrer Zutrittsgebühr vollständig aus, bevor Sie sie für Ihre Restaurants aktivieren.',
    'entranceFee.default': 'Standard',
    'entranceFee.code': 'Zutrittsgebührencode',
    'entranceFee.codeAlreadyUsed': 'Zutrittsgebührencode bereits verwendet',
    'entranceFee.labelTicket': 'Bonbezeichnung',
    'entranceFee.amount': 'Betrag',
    'entranceFee.vat': 'MwSt.',
    'entranceFee.strategy': 'Strategie',
    'entranceFee.dailyLimit': 'Tageslimit',
    'entranceFee.type': 'Umsatz',
    'entranceFee.select.always': 'Tageslimit',
    'entranceFee.select.daily': 'Tageslimit + zugewiesenes Produkt',
    'entranceFee.select.salesExcluded': 'Ausgeschlossen',
    'entranceFee.select.salesIncluded': 'Eingeschlossen',
    'entranceFee.emptyMessage': 'Keine Zutrittsgebühr mit dieser Marke verknüpft.',
    'entranceFee.table.state': 'Aktivierungsstatus',
    'entranceFee.table.services': 'Aktivierte Services',
    'entranceFee.table.state.enabled': 'Aktiviert',
    'entranceFee.table.state.customised': 'Aktiviert mit personalisierten Werten',
    'entranceFee.table.state.disabled': 'Deaktiviert',
    'entranceFee.tableCard.title': 'Zutrittsgebühren',
    'entranceFee.tableCard.subtitle':
        'Erstellen und verwalten Sie die verschiedenen Zutrittsgebühren, die in Ihren Restaurants verwendet werden',
    'entranceFee.tableCard.action': '+ Neue Zutrittsgebühr erstellen',
    'entranceFee.restaurants': 'Restaurants',
    'entranceFee.restaurant': 'Restaurant',
    'entranceFee.action': 'Aktion',
    'entranceFee.modal.warning': 'Achtung',
    'entranceFee.modal.confirmDelete': 'Möchten Sie diesen Eintrag wirklich löschen?',
    'entranceFee.search': 'Zutrittsgebühr suchen',
    'entranceFee.configuration.title': 'Besondere Anwendung der Zutrittsgebühr – {name}',
    'entranceFee.configuration.header.title': 'Services dieses Restaurants verwalten',
    'entranceFee.configuration.search': 'Service suchen',
    'entranceFee.configuration.table.activation': 'Aktivierung',
    'entranceFee.configuration.table.name': 'Servicename',
    'entranceFee.configuration.table.time': 'Zeiten',
    'entranceFee.configuration.table.days': 'Zeitraum',
    'entranceFee.configuration.table.amount': 'Betrag',
    'entranceFee.configuration.table.vat': 'MwSt.',
    'entranceFee.configuration.table.defaultShift': 'Standard-Service',
    'entranceFee.warningShifts.title': 'Änderung bestätigen',
    'entranceFee.warningShifts.shift': 'Service: {time} – Betrag: {amount} – Differenz: {variation}',
    'entranceFee.warningShifts.shift.amount': '\nBetrag der Zutrittsgebühr: {amount}',
    'entranceFee.warningShifts.confirm': 'Möchten Sie wirklich fortfahren?',
    'grant.create': 'Subvention erstellen',
    'grant.title': 'Subvention',
    'grant.description': 'Geben Sie den Betrag und die Anwendungsregeln der Subvention für alle Ihre Betriebe an.',
    'grant.description.title1': 'Strategie 1: Tageslimit + Betrag',
    'grant.customUse': 'Besondere Anwendungen der Subvention',
    'grant.descCustomUse': 'Aktivierung und Anpassung der Subvention pro Restaurant',
    'grant.warningLimit':
        '⚠️ Das individuelle Tageslimit darf das standardmäßig festgelegte Tageslimit nicht überschreiten.',
    'grant.warningForm':
        'Füllen Sie alle Felder Ihrer Subvention vollständig aus, bevor Sie sie für Ihre Restaurants aktivieren.',
    'grant.desc1':
        'Die Subvention gilt für alle Produkte im Warenkorb unter folgenden Bedingungen:\nFalls ein Schwellenwert definiert ist, wird nur der Betrag des Warenkorbs oberhalb des Schwellenwerts berücksichtigt.\nFalls eine Obergrenze definiert ist, kann die Subvention diesen Betrag nicht überschreiten.\nFalls ein Tag definiert ist, werden nur Produkte mit diesem Tag von der Subvention erfasst.',
    'grant.description.title2': 'Strategie 2: Tageslimit + Betrag + betroffene Produkte',
    'grant.desc2':
        'Die Subvention gilt nach denselben Regeln wie oben, zusätzlich gilt:\nBei einer prozentualen Subvention werden nur als subventionierbar markierte Produkte erfasst.\nBei einer absoluten Subvention wird diese nur ausgelöst, wenn der Warenkorb mindestens 1 als subventionierbar markiertes Produkt enthält.',
    'grant.amount': 'Betrag',
    'grant.default': 'Standard',
    'grant.code': 'Subventionscode',
    'grant.codeAlreadyUsed': 'Subventionscode bereits verwendet',
    'grant.strategy': 'Strategie',
    'grant.dailyLimit': 'Tageslimit',
    'grant.type': 'Betragsart',
    'grant.tags': 'Nur auf Produkte mit folgendem Tag anwenden:',
    'grant.tags.placeholder': 'SUB1, SUB2',
    'grant.labelTicket': 'Ticket-Bezeichnung',
    'grant.select.rate': 'Prozentsatz',
    'grant.select.absolute': 'Absolut',
    'grant.select.minimum': 'Tageslimit + Betrag',
    'grant.select.minimumAndProduct': 'Tageslimit + Mindestbetrag + betroffene Produkte',
    'grant.threshold': 'Auslöseschwelle',
    'grant.ceiling': 'Subventionsobergrenze',
    'grant.restaurants': 'Restaurants',
    'grant.action': 'Aktion',
    'grant.emptyMessage': 'Keine Subvention für diese Marke hinterlegt.',
    'grant.tableCard.title': 'Subventionen',
    'grant.tableCard.subtitle': 'Erstellen und verwalten Sie die verschiedenen Subventionen in Ihren Restaurants',
    'grant.tableCard.action': '+ Neue Subvention hinzufügen',
    'grant.settings.button': 'Einstellungen',
    'grant.settings.modal.title': 'Zuschuss-Einstellungen',
    'grant.settings.modal.subtitle': 'Konfigurieren Sie die Regeln, die für die Zuschüsse Ihrer Marke gelten.',
    'grant.settings.modal.toggle.label': 'Zahlung mit Essensgutscheinen sperren, wenn ein Zuschuss angewendet wird',
    'grant.settings.modal.toggle.description':
        'Wenn aktiviert, sind Zahlungsmethoden mit Essensgutscheinen (Edenred, Paygreen) für Gäste, deren Warenkorb einen Zuschuss enthält, in der Online-Bestellung (CELV2) nicht verfügbar.',
    'grant.settings.modal.cancel': 'Abbrechen',
    'grant.settings.modal.save': 'Speichern',
    'grant.table.enabled': 'Aktivieren',
    'grant.table.state': 'Aktivierungsstatus',
    'grant.table.services': 'Aktivierte Dienste',
    'grant.table.state.enabled': 'Aktiviert',
    'grant.table.state.customised': 'Aktiviert mit benutzerdefinierten Werten',
    'grant.table.state.disabled': 'Deaktiviert',
    'grant.table.restaurant': 'Restaurant',
    'grant.table.threshold': 'Auslösung',
    'grant.table.ceiling': 'Obergrenze',
    'grant.table.dailyLimit': 'Tageslimit',
    'grant.table.strategy': 'Strategie',
    'grant.table.action': 'Aktion',
    'grant.modal.warning': 'Achtung',
    'grant.modal.confirmDelete': 'Sind Sie sicher, dass Sie löschen möchten?',
    'grant.search': 'Subvention suchen',
    'grant.configuration.title': 'Besondere Subventionsanwendung – {name}',
    'grant.configuration.header.title': 'Dienste dieses Restaurants verwalten',
    'grant.configuration.search': 'Dienst suchen',
    'grant.configuration.table.activation': 'Aktivierung',
    'grant.configuration.table.name': 'Dienstname',
    'grant.configuration.table.time': 'Öffnungszeiten',
    'grant.configuration.table.days': 'Zeitraum',
    'grant.configuration.table.amount': 'Betrag',
    'grant.configuration.table.threshold': 'Auslösung',
    'grant.configuration.table.ceiling': 'Obergrenze',
    'grant.configuration.table.defaultShift': 'Standarddienst',
    'grant.warningShifts.title': 'Bestätigung der Änderung',
    'grant.warningShifts.shift': '{time} – Betrag: {amount} – Differenz: {variation}',
    'grant.warningShifts.shift.amount': '\nSubventionsbetrag: {amount}',
    'grant.warningShifts.confirm': 'Sind Sie sicher, dass Sie fortfahren möchten?',
    'group.tableCard.title': 'Gruppen',
    'group.tableCard.action': '+ Neue Gruppe erstellen',
    'group.tableCard.subtitle':
        'Definieren Sie die Möglichkeiten zur Gruppierung Ihrer Gäste nach Gruppen und weisen Sie die verschiedenen Tarifregimes zu.',
    'group.tableCard.subtitle2': 'Definieren Sie hier die verschiedenen Organisationsmöglichkeiten für Ihre Gäste.',
    'group.emptyMessage': 'Keine Gruppe dieser Marke zugeordnet.',
    'group.name': 'Gruppe',
    'group.action': 'Aktion',
    'group.pricingRules': 'Tarifregimes',
    'group.guestsCount': 'Anzahl der Gäste',
    'group.guestsCountLabel': 'Gast/Gäste',
    'group.modal.warning': 'Achtung',
    'group.modal.confirmDelete': 'Sind Sie sicher, dass Sie löschen möchten?',
    'group.modal.deleteError': 'Sie können diese Gruppe nicht löschen.',
    'group.modal.deleteErrorReason':
        'Bitte heben Sie die Zuweisung der zugehörigen Gäste auf, um diesen Löschvorgang abzuschließen.',
    'group.warning.group_name_already_exist.message': 'Der Gruppenname existiert bereits.',
    'group.warning.group_name_already_exist.description':
        'Bitte schlagen Sie einen neuen Gruppennamen vor oder weisen Sie das/die ausgewählte(n) Tarifregime(s) der bereits bestehenden Gruppe zu.',
    'group.warning.pricing_rule_is_always_assigned_to_a_guest_in_this_group.message':
        'Ein oder mehrere Tarifregimes, die Sie von der aktuellen Gruppe trennen möchten, sind bestehenden Gästen zugewiesen.',
    'group.warning.pricing_rule_is_always_assigned_to_a_guest_in_this_group.description':
        'Bitte heben Sie die Zuweisung dieses/dieser Tarifregime(s) von den bestehenden Gästen auf, bevor Sie diese aus der Liste der verfügbaren Tarifregimes für die Gruppe entfernen können.',
    'group.modal.import.title': 'Gruppen, Abschnitte, Unterabschnitte und Tarifregimes importieren',
    'group.modal.import.firstPart': 'Laden Sie die {fileTemplate} auf Ihren Computer herunter',
    'group.modal.import.secondPart':
        'Füllen Sie die Vorlagedatei mit den Informationen zu Ihren Gruppen, Abschnitten, Unterabschnitten und Tarifregimes aus, die hinzugefügt oder geändert werden sollen',
    'group.modal.import.thirdPart': 'Importieren Sie Ihre neue Datei, indem Sie auf die Schaltfläche unten klicken',
    'group.modal.import.warning':
        'Das Löschen von Gruppen, Abschnitten, Unterabschnitten und Tarifregimes erfolgt ausschließlich über das Innovorder-Backoffice',
    'group.modal.import.report.title': 'Importbericht',
    'group.export.group': 'Gruppe',
    'group.export.section': 'Abschnitt',
    'group.export.subsection': 'Unterabschnitt',
    'group.export.pricingRule': 'Zugehörige(s) Tarifregime(s)',
    'group.modal.conflict.error.message': 'Sie können diese Gruppe nicht ändern',
    'group.modal.conflict.error.description': 'Bitte weisen Sie die Gäste neu zu, bevor Sie diese Gruppe ändern',
    'group.modal.conflict.export.button': 'Gäste exportieren',
    'group.modal.import.report.groups': 'Gruppen',
    'group.modal.import.report.sections': 'Abschnitte',
    'group.modal.import.report.subsections': 'Unterabschnitte',
    'group.modal.import.report.successMessage': '• Erstellung: {created}\n • Änderung: {updated}',
    'group.modal.import.report.errorMessage': '• Zeile {line} – Spalte {field}: {message}',
    'group.delete.modal.conflict.error.message': 'Sie können diese Gruppe nicht löschen',
    'group.delete.modal.conflict.error.description':
        'Bitte weisen Sie die Gäste neu zu, bevor Sie diese Gruppe löschen',
    'group.delete.modal.conflict.export.button': 'Gäste exportieren',
    'groups.export.student.customerId': 'Kunden-ID',
    'groups.export.student.email': 'E-Mail',
    'groups.export.student.password': 'Passwort',
    'groups.export.student.firstName': 'Vorname',
    'groups.export.student.lastName': 'Nachname',
    'groups.export.student.phone': 'Telefon',
    'groups.export.student.piCode': 'PIN-Code',
    'groups.export.student.badgeNumber': 'Ausweis-Nr.',
    'groups.export.student.studentNumber': 'Gast-Nr.',
    'groups.export.student.group': 'Gruppe',
    'groups.export.student.section': 'Abschnitt',
    'groups.export.student.subSection': 'Unterabschnitt',
    'groups.export.student.accountType': 'Kontotyp',
    'groups.export.student.tariffCode': 'Tarifcode',
    'groups.export.student.grantCode': 'Subventionscode',
    'groups.export.student.entranceFeeCode': 'Zulassungscode',
    'groups.export.student.pricingRuleCode': 'Tarifregime',
    'groups.export.student.ewalletOverdraftAmount': 'Benutzerdefinierter Überziehungsbetrag',
    'groups.export.student.exitDate': 'Archivierungsdatum',
    'groups.export.student.accessFrom': 'Eintrittsdatum',
    'groups.export.student.accessUntil': 'Austrittsdatum',
    'groups.export.student.inactive': 'Inaktiv',
    'groups.export.student.active': 'Aktiv',
    'groups.export.student.yes': 'Ja',
    'groups.export.student.no': 'Nein',
    'section.tableCard.title': 'Abschnitte',
    'section.tableCard.subtitle':
        'Definieren Sie die Möglichkeiten zur Gruppierung Ihrer Gäste nach Abschnitten und weisen Sie die verschiedenen Tarifregimes zu.',
    'section.tableCard.action': '+ Neuen Abschnitt erstellen',
    'section.name': 'Abschnitt',
    'group.warning.section_name_already_exist.message': 'Der Abschnittsname existiert bereits.',
    'group.warning.section_name_already_exist.description':
        'Bitte schlagen Sie einen neuen Abschnittsnamen vor oder weisen Sie das/die ausgewählte(n) Tarifregime(s) dem bereits bestehenden Abschnitt zu.',
    'section.modal.conflict.error.message': 'Sie können diesen Abschnitt nicht ändern',
    'section.modal.conflict.error.description': 'Bitte weisen Sie die Gäste neu zu, bevor Sie diesen Abschnitt ändern',
    'section.delete.modal.conflict.error.message': 'Sie können diesen Abschnitt nicht löschen',
    'section.delete.modal.conflict.error.description':
        'Bitte weisen Sie die Gäste neu zu, bevor Sie diesen Abschnitt löschen',
    'subsection.tableCard.title': 'Unterabschnitte',
    'subsection.tableCard.subtitle':
        'Definieren Sie die Möglichkeiten zur Gruppierung Ihrer Gäste nach Unterabschnitten und weisen Sie die verschiedenen Tarifregimes zu.',
    'subsection.tableCard.action': '+ Neuen Unterabschnitt erstellen',
    'subsection.name': 'Unterabschnitt',
    'group.warning.sub_section_name_already_exist.message': 'Der Unterabschnittsname existiert bereits.',
    'group.warning.sub_section_name_already_exist.description':
        'Bitte schlagen Sie einen neuen Unterabschnittsnamen vor oder weisen Sie das/die ausgewählte(n) Tarifregime(s) dem bereits bestehenden Unterabschnitt zu.',
    'subsection.modal.conflict.error.message': 'Sie können diesen Unterabschnitt nicht ändern',
    'subsection.modal.conflict.error.description':
        'Bitte weisen Sie die Gäste neu zu, bevor Sie diesen Unterabschnitt ändern',
    'subsection.delete.modal.conflict.error.message': 'Sie können diesen Unterabschnitt nicht löschen',
    'subsection.delete.modal.conflict.error.description':
        'Bitte weisen Sie die Gäste neu zu, bevor Sie diesen Unterabschnitt löschen',
    'options.main': 'Allgemein',
    'options.educationMode': 'Gemeinschaftsverpflegung',
    'options.birthdate': 'Geburtsdatum',
    'options.tripAdvisorUsername': 'TripAdvisor-Benutzername',
    'options.advancedSecurityRules': '12-Zeichen-Passwort aktivieren',
    'options.optIn': 'Opt-in',
    'options.productionDeclaration': 'Produktionsmeldung',
    'options.grantsAndEntranceFee': 'Subventionen und Zulassungen',
    'options.pinCodeDoubleAuth': 'PIN-Code zur Absicherung der Authentifizierung am Terminal verwenden',
    'options.charlemagneExport': 'Daten für Charlemagne exportieren',
    'options.handleBadgeForChar': 'Bei der Ausweis-Suche nur die letzten 4 Zeichen berücksichtigen',
    'options.autoBilling': 'Modul "Automatische Abrechnung" aktivieren',
    'options.linkProductImageBySku':
        'Bilder, deren Namen die SKU der Produkte enthalten, automatisch verknüpfen (beim Import)',
    'options.externalIdsMapping': 'ID-Übersetzung aktivieren',
    'options.ewalletAutoReload': 'E-Wallet-Autoreloader aktivieren (via Stripe)',
    'options.foodCourt': 'CEL v2 – Food Court',
    'options.foodCourtMode': 'Food-Court-Modus aktivieren',
    'options.shuffleRestaurants': 'Anzeigereihenfolge der Restaurants zufällig gestalten',
    'options.enableSodexoDictionary': 'Sodexo-Wörterbuch aktivieren',
    'options.enableOrderDetailV2': 'Order Detail V2 aktivieren',
    'options.usePickupPoints': 'Abholpunkte aktivieren',
    'options.linkProductSkuToExternalMapping': 'SKU der Produkte automatisch mit der ID-Übersetzung verknüpfen',
    'options.linkStudentNumberToExternalMapping': 'Gastnummer automatisch mit der ID-Übersetzung verknüpfen',
    'options.multiRestaurant': 'Terminal – Multi-Restaurant',
    'options.multiRestaurantMode': 'Multi-Restaurant-Modus aktivieren',
    'options.multiRestaurantModeMainRestaurant': 'Hauptrestaurant',
    'options.multiRestaurantModeMainUser': 'Terminal-Benutzer',
    'options.multiRestaurantModeAssignedRestaurants': 'Zugewiesene Restaurants',
    'options.enableLinkingMenuToPosAndWeb': 'Verknüpfung des Menüs mit einer Kasse und dem Web ermöglichen',
    'options.configureSodexoConsumerTransaction': 'Sodexo consumerTransactions-Webhooks aktivieren',
    'options.families': 'Familien',
    'options.families.empty': 'Keine Familie',
    'options.families.new': 'Neue Familie',
    'options.families.namePlaceholder': 'Name',
    'options.families.add': 'Hinzufügen',
    'options.families.delete': 'Löschen',
    'options.families.deleteTitle': 'Löschen der Familie {name} bestätigen',
    'options.families.deleteConfirmation': 'Sind Sie sicher, dass Sie die Familie "{name}" löschen möchten?',
    'brandInfo.title': 'Informationen',
    'brandInfo.ewalletOverdraft.title': 'E-Wallet-Überziehung',
    'brandInfo.ewalletOverdraft.description':
        'Kunden erlauben, ein negatives Guthaben auf ihrem E-Wallet bis zum angegebenen Betrag zu haben.',
    'brandInfo.ewalletOverdraft.enable': 'E-Wallet-Überziehung aktivieren',
    'brandInfo.ewalletOverdraft.amount': 'Maximaler Überziehungsbetrag',
    'brandInfo.ewalletOverdraft.amountPlaceholder': '0,00',
    'brandInfo.ewalletOverdraft.cannotDisable':
        'Überziehung kann nicht deaktiviert werden: {count} Kunde(n) haben derzeit die Nachzahlung aktiviert.',
    'restaurant.search': 'Restaurant suchen',
    'restaurant.name': 'Restaurantname',
    'restaurant.options.main': 'Allgemein',
    'restaurant.options.includeDepositsInTurnover': 'Pfandgut in den Umsatz einrechnen',
    'adminBanner.message': 'Sie sind angemeldet als',
    'adminBanner.backToAdmin': 'Zurück zum Administrator',
    'auto.billing.buttons.referential': 'Referential',
    'auto.billing.buttons.billing': 'Abrechnungsanfrage',
    'auto.billing.request.card.title': 'Abrechnungsanfrage',
    'auto.billing.request.card.subtitle':
        'Das automatische Abrechnungsmodul ermöglicht es, alle Verbrauchskosten der Gäste, die einem Dritten zugeordnet sind, zusammenzufassen, um (gemäß den konfigurierten Regeln) den Umsatz und die Einnahmen jedes Dritten zu berechnen.',
    'auto.billing.request.wizard.validate': 'Abschließen',
    'auto.billing.request.wizard.title': 'Abrechnungsanfrage stellen',
    'auto.billing.request.card.action': 'Abrechnungsanfrage stellen',
    'auto.billing.request.popup.confirm.title': 'Sie sind dabei, eine automatische Abrechnung anzufordern',
    'auto.billing.request.popup.confirm.text': 'Können Sie diese Aktion bestätigen?',
    'auto.billing.request.popup.success.title': 'Ihre Abrechnungsanfrage wurde bestätigt',
    'auto.billing.request.popup.fail.title': 'Fehler',
    'auto.billing.request.popup.pending.title': 'Verarbeitung läuft...',
    'auto.billing.request.popup.success.cancel': 'Schließen',
    'auto.billing.request.popup.success.text': 'Ihre Abrechnungsanfrage wurde erfolgreich übermittelt',
    'auto.billing.request.popup.fail.text': 'Ein Fehler ist aufgetreten, bitte versuchen Sie es später erneut',
    'auto.billing.request.preview.emptyMessage': 'Keine Verkäufe im ausgewählten Zeitraum',
    'auto.billing.request.preview.errorUndefinedReferential': 'Für diese Marke ist kein Referential definiert',
    'auto.billing.request.preview.error': 'Ein Fehler ist aufgetreten, bitte versuchen Sie es später erneut',
    'auto.billing.request.preview.code': 'Code',
    'auto.billing.request.preview.label': 'Bezeichnung',
    'auto.billing.request.preview.quantity': 'Menge',
    'auto.billing.request.preview.unitPriceWithTaxExcluded': 'Stückpreis netto',
    'auto.billing.request.preview.totalPriceWithTaxExcluded': 'Betrag netto',
    'auto.billing.request.preview.totalTax': 'MwSt.-Betrag',
    'auto.billing.request.preview.totalPriceWithTaxIncluded': 'Betrag brutto',
    'auto.billing.request.preview.cdpf': 'CDPF-Aussteller',
    'auto.billing.request.preview.clientCode': 'Kundencode',
    'auto.billing.request.preview.clientLabel': 'Kundenbezeichnung',
    'auto.billing.request.preview.billingPeriod': 'Abrechnungszeitraum',
    'auto.billing.request.preview.billingPeriod.from': 'Von',
    'auto.billing.request.preview.billingPeriod.to': 'bis',
    'auto.billing.request.preview.invoiceSelector.GROUP': 'Gruppe',
    'auto.billing.request.preview.invoiceSelector.ACCOUNT_PAYMENT_TYPE': 'Kontotyp',
    'auto.billing.request.preview.invoiceSelector.PRICING_RULE': 'Tarifregime',
    'auto.billing.request.preview.total.amountWithTaxIncluded': 'Gesamt brutto',
    'auto.billing.request.preview.total.amountWithTaxExcluded': 'Gesamtbetrag netto',
    'auto.billing.request.preview.total.tax': 'Gesamt MwSt.',
    'auto.billing.request.filter.title': 'Filter',
    'auto.billing.request.filter.entities.title': 'AUSWAHL DER ABRECHNUNGSENTITÄTEN',
    'auto.billing.request.filter.entities.all': 'Alle Entitäten',
    'auto.billing.request.filter.restaurants.title': 'RESTAURANTAUSWAHL',
    'auto.billing.request.filter.dropDown.errorMessage': 'Sie müssen mindestens eine Option auswählen',
    'auto.billing.request.filter.restaurants.all': 'Alle Restaurants',
    'auto.billing.request.filter.pricingRules.title': 'TARIFPROFIL',
    'auto.billing.request.filter.pricingRules.all': 'Alle Tarifregimes',
    'auto.billing.request.filter.pricingRules.noPricingRules': 'Kein Tarifregime',
    'auto.billing.request.accountPaymentTypes.title': 'VERWALTUNGSMODUS',
    'auto.billing.request.filter.accountPaymentTypes.all': 'Alle Verwaltungsmodi',
    'auto.billing.request.accountPaymentTypes.CASH': 'Barzahlung',
    'auto.billing.request.accountPaymentTypes.PREPAYMENT': 'Vorauszahlung',
    'auto.billing.request.accountPaymentTypes.POSTPAYMENT': 'Nachzahlung',
    'auto.billing.request.history.table.emptyMessage': 'Keine Abrechnungsanfragen gestellt',
    'auto.billing.request.history.table.date': 'Generierungsdatum',
    'auto.billing.request.history.table.period': 'Zeitraum',
    'auto.billing.request.history.table.user': 'Benutzer',
    'auto.billing.request.history.table.previewButton': 'Vorschau',
    'auto.billing.request.history.table.downloadButton': 'Herunterladen',
    'auto.billing.referential.serviceCodes.card.title': 'Leistungscodes',
    'auto.billing.referential.serviceCodes.card.subtitle': ' ',
    'auto.billing.referential.billingEntities.card.title': 'Abrechnungsentitäten',
    'auto.billing.referential.billingEntities.card.subtitle': ' ',
    'auto.billing.referential.billingEntities.add': '+ Entität hinzufügen',
    'auto.billing.referential.billingEntities.form.create.title': 'Erstellung der Abrechnungsentität',
    'auto.billing.referential.billingEntities.form.create.subtitle': ' ',
    'auto.billing.referential.billingEntities.costCompute.title': 'Berechnungsmodus',
    'auto.billing.referential.billingEntities.costCompute.subtitle': ' ',
    'auto.billing.referential.billingEntities.table.label': 'Bezeichnung',
    'auto.billing.referential.billingEntities.table.code': 'Code',
    'auto.billing.referential.billingEntities.table.groups': 'Zugehörige Gruppen',
    'auto.billing.referential.billingEntities.table.groupingBy': 'Aufschlüsselung',
    'auto.billing.referential.billingEntities.table.emptyMessage': 'Keine Abrechnungsentität für diese Marke definiert',
    'auto.billing.referential.billingEntities.form.label.title': 'BEZEICHNUNG',
    'auto.billing.referential.billingEntities.form.code.title': 'CODE',
    'auto.billing.referential.billingEntities.form.code.text': 'CODE',
    'auto.billing.referential.billingEntities.form.groups.text': 'ZIELGRUPPE',
    'auto.billing.referential.billingEntities.form.groupingBy.title': 'ART DER AUFSCHLÜSSELUNG',
    'auto.billing.referential.billingEntities.form.label.subtitle': 'Erstellung der Abrechnungsentität',
    'auto.billing.referential.billingEntities.form.groupingBy.options.PRICING_RULE': 'Tarifregime',
    'auto.billing.referential.billingEntities.form.groupingBy.options.BILLING_ENTITY': 'Ohne Aufschlüsselung',
    'auto.billing.referential.billingEntities.form.groupingBy.options.GROUP': 'Gruppe',
    'auto.billing.referential.billingEntities.form.groupingBy.options.ACCOUNT_PAYMENT_TYPE': 'Verwaltungsmodus',
    'auto.billing.referential.billingEntities.errors.duplicate.code':
        'Der Code {code} ist bereits der Abrechnungsentität {entity} zugeordnet',
    'auto.billing.referential.billingEntities.errors.duplicate.group':
        'Die Abrechnungsentität {entity} hat bereits folgende Gruppe(n): {groups}',
    'auto.billing.referential.serviceCodes.perceivedAmountCode.label': 'WAHRGENOMMENER BETRAG',
    'auto.billing.referential.serviceCodes.admissionLevelCostCode.label': 'ABRECHNUNG NACH ZULASSUNGSSTUFE',
    'auto.billing.referential.serviceCodes.fixedCostCode.label': 'MASSENABRECHNUNG MIT FESTKOSTEN',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.card.title': 'Wahrgenommener Betrag',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.code.label': 'Code',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.vat.label': 'MwSt.',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.add': '+ Code hinzufügen',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.emptyMessage': 'Kein Code eingetragen',
    'auto.billing.referential.accountingCostCompute.constantCost': 'Massenabrechnung mit Festkosten',
    'auto.billing.referential.accountingCostCompute.partitionedConstantCost': 'Abrechnung nach Staffel',
    'auto.billing.referential.accountingCostCompute.summedUpByAdmissionFeesAmount': 'Abrechnung pro Couvert',
    'auto.billing.referential.accountingCostCompute.costSlicesMode.constantCost': 'Festkostenmasse',
    'auto.billing.referential.accountingCostCompute.costSlicesMode.summedUpByAdmissionFeesAmount': 'Pro Couvert',
    'auto.billing.referential.accountingCostCompute.modal.sliceFrom': 'STAFFEL VON',
    'auto.billing.referential.accountingCostCompute.modal.to': 'BIS',
    'auto.billing.referential.accountingCostCompute.modal.constantCost': 'FESTKOSTENMASSE',
    'auto.billing.referential.accountingCostCompute.modal.summedUpByAdmissionFeesAmount': 'PRO COUVERT',
    'auto.billing.referential.accountingCostCompute.modal.billingMode': 'ABRECHNUNGSMODUS',
    'auto.billing.referential.accountingCostCompute.modal.title': 'Neue Staffel hinzufügen',
    'auto.billing.referential.accountingCostCompute.modal.input.maxLowerThanOrEqualToMin':
        'Die maximale Staffel muss größer als die minimale sein',
    'auto.billing.referential.accountingCostCompute.modal.input.intersection':
        'Diese Staffel überschneidet sich mit [{from} – {to}]',
    'auto.billing.referential.accountingCostCompute.modal.input.negative': 'Der Wert muss positiv sein',
    'auto.billing.referential.accountingCostCompute.partitionedCostByGuest': 'XXXX',
    'auto.billing.referential.accountingCostCompute.addSlice': '+ Staffel hinzufügen',
    'auto.billing.referential.accountingCostCompute.amount': 'Betrag brutto',
    'auto.billing.filters.entity': 'Abrechnungsentität',
    'auto.billing.referential.accountingGroups.code.text': 'XXXX CODE DU GROUPE',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.range': 'Anzahl der Couverts',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.mode': 'Berechnungsmodus',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.value': 'Werte',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.emptyMessage':
        'Keine Staffel für diesen Abrechnungsmodus definiert',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.to': 'bis',
    'route.brands': 'Marken',
    'route.brandInfo': 'Informationen',
    'route.brandInfoV2': 'Informationen',
    'route.brandMedias': 'Medien',
    'route.configIOPay': 'Adyen-Konfiguration',
    'route.configEdenred': 'Edenred-Konfiguration',
    'route.configPaygreen': 'Paygreen-Konfiguration',
    'route.integrations': 'Integrationen',
    'route.stripeIntegration': 'Stripe',
    'route.grantsAndEntranceFees': 'Subventionen und Zulassungen',
    'route.options': 'Optionen',
    'route.brandHistory': 'Verlauf',
    'route.groups': 'Hierarchie',
    'route.brandChannels': 'Kanäle',
    'route.brandMenus': 'Menüs',
    'route.brandMenu': 'Informationen',
    'route.brandRestaurants': 'Restaurants',
    'route.brandUsers': 'Benutzer',
    'route.billing': 'Mein Abrechnungsbereich',
    'route.home': 'Startseite',
    'route.pricingRule': 'Tarifregime',
    'route.logout': 'Abmelden',
    'route.configUbereats': 'Uber Eats-Integration',
    'route.configDeliveroo': 'Deliveroo-Integration',
    'route.configDeliverect': 'Deliverect-Integration',
    'route.configCrous': 'Crous-Integration',
    'route.createGrant': 'Neue Subvention',
    'route.grant': 'Subventionen',
    'route.createEntranceFee': 'Neue Zulassung',
    'route.entranceFee': 'Zulassung',
    'route.createPricingRule': 'Neue Tarifregel',
    'route.analytics': 'Übersicht',
    'route.restaurantIntegration': 'Integration',
    'route.autoBilling': 'Automatische Abrechnung',
    'route.autoBilling.referential': 'Referential',
    'route.autoBilling.request': 'Abrechnungsanfrage',
    'route.autoBilling.referential.createEntity': 'Erstellung einer Abrechnungsentität',
    'route.autoBilling.referential.editEntity': 'Bearbeitung einer Abrechnungsentität',
    'route.orders': 'Bestellungen',
    'route.orderDetails': 'Bestelldetails',
    'route.restaurantInfo': 'Informationen',
    'route.restaurantChannels': 'Kanäle',
    'route.restaurantUsers': 'Benutzer',
    'route.restaurantMenus': 'Menüs',
    'route.restaurantMenu': 'Informationen',
    'route.restaurantTickets': 'Tickets',
    'route.restaurantMedias': 'Medien',
    'route.restaurantIntegrations': 'Integrationen',
    'route.restaurantPayments': 'Zahlungsmethoden',
    'route.restaurantOptions': 'Optionen',
    'route.restaurantPricingRevaluation': 'Preisneubewertung',
    'route.createGroup': 'Neue Gruppe',
    'route.createSection': 'Neuer Abschnitt',
    'route.createSubSection': 'Neuer Unterabschnitt',
    'route.editGroup': 'Gruppe bearbeiten',
    'route.editSection': 'Abschnitt bearbeiten',
    'route.editSubSection': 'Unterabschnitt bearbeiten',
    'route.adminTools': 'Admin-Tools',
    'route.menus': 'Menüs',
    'route.menuOperations': 'Menüoperationen',
    'route.posLayout': 'POS-Tastenplan',
    'route.categories': 'Kategorien',
    'route.products': 'Produkte',
    'route.steps': 'Schritte',
    'route.tags': 'Tags',
    'route.functions': 'Funktionen',
    'route.brandCustomer': 'Kunden',
    'route.brandOrders': 'Bestellungen',
    'route.crossSelling': 'Cross-Selling',
    'route.tableLayout': 'Tischpläne',
    'route.tableLayout.room': 'Säle',
    'route.salesSummary': 'Finanzzusammenfassung',
    'route.tickets': 'Tickets',
    'route.reportStatus': 'Berichtstatus',
    'route.pos': 'POS',
    'route.posConfiguration': 'Konfiguration',
    'route.posDevices': 'Kassen',
    'route.posAccess': 'Rollen und Berechtigungen',
    'route.posAccess.users': 'Kassenbenutzer',
    'route.posAccess.roles': 'Kassenrollen',
    'route.posAccess.groups': 'Kassengruppen',
    'route.accessFlags': 'Berechtigungen',
    'route.userRestaurants': 'Zugehörige Restaurants',
    'route.updateUserPassword': 'Passwort ändern',
    'route.userInfo': 'Info',
    'route.badgeReader': 'Ausweisleser',
    'route.posDeviceInformation': 'Informationen',
    'route.posDeviceConfiguration': 'Konfiguration',
    'route.posDeviceAdditionalDevices': 'Peripheriegeräte',
    'route.posDeviceArchives': 'Fiskalarchive',
    'route.posDeviceFeatures': 'Optionen',
    'route.posDevicePreferences': 'Einstellungen',
    'route.posDeviceCatalogHistory': 'Katalogverlauf',
    'route.listCustomers': 'Kunden',
    'route.customerSettings': 'Einstellungen',
    'route.customerPricingRules': 'Tarifregimes',
    'route.splioLoyaltyIntegration': 'Splio',
    'route.pickupPoints': 'Abholpunkte',
    'route.comoLoyaltyIntegration': 'Como',
    'route.zerosixLoyaltyIntegration': 'Zerosix',
    'route.operationZones': 'Betriebszone',
    'route.createBrandWebhook': 'Webhook erstellen',
    'route.editBrandWebhook': 'Webhook bearbeiten',
    'operationZones.page.title': 'Betriebszone',
    'operationZones.page.description':
        'Definieren Sie die Gebiete, in denen Ihre Marke tätig ist. Eine Hauptzone muss für die maßgebliche juristische Einheit festgelegt werden.',
    'operationZones.emptyState': 'Keine Zone ausgewählt',
    'operationZones.emptyState.description':
        'Wählen Sie ein oder mehrere Gebiete aus der unten stehenden Liste aus, um Ihre Betriebszonen zu definieren.',
    'operationZones.availableTerritories': 'Verfügbare Gebiete',
    'operationZones.selectedCount': '{count} ausgewählt',
    'operationZones.solution': 'Lösung',
    'operationZones.warning.title': 'Unvollständige Konfiguration',
    'operationZones.warning.description':
        '{count, plural, one {{count} ausgewählte Zone muss konfiguriert werden, um betriebsbereit zu sein.} other {{count} ausgewählte Zonen müssen konfiguriert werden, um betriebsbereit zu sein.}}',
    'operationZones.warning.hint':
        'Bitte vervollständigen Sie die rechtlichen und technischen Informationen über die Schaltfläche "Konfigurieren".',
    'operationZones.immutabilityNotice':
        'Die Betriebszone kann nach der Erstellung des Restaurants nicht mehr geändert werden. <supportLink>Kontaktieren Sie den Support</supportLink>, falls erforderlich.',
    'operationZones.primaryZone': 'HAUPTZONE',
    'operationZones.setPrimary.disabled': 'Konfigurieren Sie diese Zone, bevor Sie sie als Hauptzone festlegen',
    'operationZones.cannotRemoveLastZone': 'Ein Restaurant muss mindestens eine Betriebszone haben',
    'operationZones.primaryBadge': 'HAUPT',
    'operationZones.secondaryZonesActive':
        '+ {count} {count, plural, one {AKTIVE SEKUNDÄRZONE} other {AKTIVE SEKUNDÄRZONEN}}',
    'operationZones.configure': 'Konfigurieren',
    'operationZones.viewVatRates': 'Sätze anzeigen',
    'operationZones.toConfigure': 'Zu konfigurieren',
    'operationZones.entity': 'Entität',
    'operationZones.vat': 'MwSt.',
    'operationZones.posConfig': 'POS-Konfiguration',
    'operationZones.notFilled': 'Nicht ausgefüllt',
    'operationZones.pending': 'Ausstehend',
    'operationZones.initialized': 'Initialisiert',
    'operationZones.configured': 'Konfiguriert',
    'operationZones.noPosDevice': 'Erstellen Sie eine POS-Kasse, bevor Sie diese Zone konfigurieren',
    'operationZones.configModal.title': 'Konfiguration: {zoneName}',
    'operationZones.configModal.subtitle': 'Rechtliche und steuerliche Parameter ({code})',
    'operationZones.configModal.entitySection': 'Entitätsinformationen',
    'operationZones.configModal.socialReason': 'Firmenname',
    'operationZones.configModal.address': 'Adresse',
    'operationZones.configModal.postalCode': 'Postleitzahl',
    'operationZones.configModal.city': 'Stadt',
    'operationZones.configModal.vatNumber': 'USt-IdNr.',
    'operationZones.configModal.siret': 'SIRET',
    'operationZones.configModal.save': 'Speichern',
    'operationZones.configModal.socialReason.placeholder': 'z. B.: Restaurant GmbH',
    'operationZones.configModal.address.placeholder': 'Musterstraße 123...',
    'operationZones.configModal.postalCode.placeholder': '10115',
    'operationZones.configModal.city.placeholder': 'Berlin',
    'operationZones.configModal.vatNumber.placeholder': 'z. B.: DE 123456789',
    'operationZones.configModal.siret.placeholder': 'z. B.: 522 296...',
    'operationZones.multiProvider': 'Nach Wahl',
    'operationZones.configModal.nifCif': 'NIF / CIF',
    'operationZones.configModal.nifCif.placeholder': 'z. B.: B12345678',
    'operationZones.configModal.fiscalRepresentative': 'Steuerlicher Vertreter',
    'operationZones.configModal.fiscalRepresentative.placeholder': 'Name des steuerlichen Vertreters',
    'operationZones.configModal.fiscalIdCode': 'Steuerliche Identifikationsnummer',
    'operationZones.configModal.fiscalIdCode.placeholder': 'z. B.: RSSMRA85T10A562S',
    'operationZones.configModal.vatNumberBtw': 'USt-IdNr. (BTW)',
    'operationZones.configModal.vatNumberBtw.placeholder': 'z. B.: BE 0123.456.789',
    'operationZones.configModal.enterpriseNumber': 'Unternehmensnummer',
    'operationZones.configModal.enterpriseNumber.placeholder': 'z. B.: 0123.456.789',
    'operationZones.configModal.if': 'IF',
    'operationZones.configModal.if.placeholder': 'z. B.: 12345678',
    'operationZones.configModal.ice': 'ICE',
    'operationZones.configModal.ice.placeholder': 'z. B.: 001234567000045',
    'operationZones.configModal.selectProvider': 'Konformitätsmodus auswählen',
    'operationZones.configModal.fiskaltrust': 'Fiskaltrust',
    'operationZones.configModal.fiskaltrustDescription': 'Fiscalkonformitäts-Middleware für das Kassensystem',
    'operationZones.configModal.noIntegration': 'Keine Integration',
    'operationZones.configModal.noIntegrationDescription': 'Es wird keine Steuer-Middleware konfiguriert',
    'operationZones.configModal.nf525': 'NF525',
    'operationZones.configModal.nf525Description': 'Französische Fiskalkonformitätszertifizierung',
    'operationZones.configModal.boiteNoire': 'Boîte Noire',
    'operationZones.configModal.boiteNoireDescription': 'Belgisches Fiskalkonformitätsmodul',
    'operationZones.configModal.middlewareSection': 'Middleware-Konfiguration (Fiskaltrust)',
    'operationZones.configModal.cashboxId': 'Cashbox ID',
    'operationZones.configModal.cashboxId.placeholder': 'z. B.: a1b2c3d4-...',
    'operationZones.configModal.accessToken': 'Access Token',
    'operationZones.configModal.accessToken.placeholder': 'z. B.: AZE123...',
    'operationZones.configModal.back': 'Zurück',
    'operationZones.deactivate.title': 'Betriebszone deaktivieren',
    'operationZones.deactivate.message':
        'Sind Sie sicher, dass Sie diese Betriebszone deaktivieren möchten? Alle konfigurierten Informationen (juristische Einheit, Steuerliche Einstellungen, POS-Konfiguration) gehen verloren.',
    'adminTools.confirmModal.description': 'Sind Sie sicher, dass Sie diese Aktion auslösen möchten?',
    'brand.adminTools.editCustomerLoyalties.title': 'IO-Treuepunkte eines Kunden dieser Marke hinzufügen/entfernen',
    'brand.adminTools.editCustomerLoyalties.form.placeholder.emailsOrCards': 'name@domain.com oder A1B2C3D4E5',
    'brand.adminTools.editCustomerLoyalties.form.placeholder.loyaltyAmountToAdd': '400 entspricht 4 Euro',
    'brand.adminTools.editCustomerLoyalties.form.emailsOrCards': 'E-Mail oder Nummer der Kundenkarte',
    'brand.adminTools.editCustomerLoyalties.form.loyaltyAmountToAdd': 'Betrag',
    'brand.adminTools.editCustomerLoyalties.form.error': 'Beim Starten des Skripts ist ein Fehler aufgetreten.',
    'brand.adminTools.editCustomerLoyalties.form.success': 'Das Skript wurde erfolgreich ausgeführt.',
    'brand.adminTools.unarchiveCustomer.title': 'Einen Gast dearchivieren',
    'brand.adminTools.unarchiveCustomer.form.placeholder.customerId': '1234567',
    'brand.adminTools.unarchiveCustomer.form.customerId': 'Zu dearchivierende CustomerId',
    'brand.adminTools.unarchiveCustomer.form.error': 'Beim Starten des Skripts ist ein Fehler aufgetreten.',
    'brand.adminTools.unarchiveCustomer.form.success': 'Das Skript wurde erfolgreich ausgeführt.',
    'brand.adminTools.deleteTransaction.title': 'Eine Transaktion löschen',
    'brand.adminTools.deleteTransaction.form.placeholder.transactionId': '1234567',
    'brand.adminTools.deleteTransaction.form.transactionId': 'Zu löschende Transaktion',
    'brand.adminTools.deleteTransaction.form.error': 'Beim Starten des Skripts ist ein Fehler aufgetreten.',
    'brand.adminTools.deleteTransaction.form.success': 'Das Skript wurde erfolgreich ausgeführt.',
    'brand.adminTools.addUserToRestaurant.title':
        'Ein Restaurantkonto einem anderen Restaurant derselben Marke zuweisen',
    'brand.adminTools.addUserToRestaurant.form.placeholder.email': 'beispiel@restaurant.com',
    'brand.adminTools.addUserToRestaurant.form.email': 'Konto-E-Mail',
    'brand.adminTools.addUserToRestaurant.form.placeholder.restaurantId': '1111',
    'brand.adminTools.addUserToRestaurant.form.restaurantId': 'RestaurantId des zuzuweisenden Restaurants',
    'brand.adminTools.addUserToRestaurant.form.error': 'Beim Starten des Skripts ist ein Fehler aufgetreten.',
    'brand.adminTools.addUserToRestaurant.form.success': 'Das Skript wurde erfolgreich ausgeführt.',
    'brand.adminTools.deleteUnassignedImages.title': 'Nicht verwendete Bilder dieser Marke löschen',
    'brand.adminTools.deleteUnassignedImages.description1':
        'Skript zum Löschen aller nicht verwendeten Bilder (z. B. von Produkten/Menüs, die seitdem gelöscht wurden)',
    'brand.adminTools.deleteUnassignedImages.description2':
        'Es wird empfohlen, alle nicht benötigten Menüs der Marke und ihrer Restaurants zu löschen, bevor dieses Skript ausgeführt wird, damit die Bereinigung effektiv ist.',
    'brand.adminTools.deleteUnassignedImages.form.error': 'Beim Starten des Skripts ist ein Fehler aufgetreten.',
    'brand.adminTools.deleteUnassignedImages.form.success': 'Das Skript wurde erfolgreich ausgeführt.',
    'brand.adminTools.importGeojsonPolygon.title': 'Ein GeoJSON als Lieferzone importieren',
    'brand.adminTools.importGeojsonPolygon.form.placeholder.restaurantId': '1234',
    'brand.adminTools.importGeojsonPolygon.form.placeholder.areaName': 'Creteil',
    'brand.adminTools.importGeojsonPolygon.form.placeholder.geoJsonPolygon':
        '[[4.8395748,50.0926849],[4.8393237,50.0926889],[4.8392677,50.0926748]]',
    'brand.adminTools.importGeojsonPolygon.form.restaurantId': 'RestaurantId',
    'brand.adminTools.importGeojsonPolygon.form.areaName': 'Name der zu erstellenden Lieferzone',
    'brand.adminTools.importGeojsonPolygon.form.geoJsonPolygon': 'Polygonkoordinaten des GeoJSON eingeben',
    'brand.adminTools.importGeojsonPolygon.form.error': 'Beim Starten des Skripts ist ein Fehler aufgetreten.',
    'brand.adminTools.importGeojsonPolygon.form.success': 'Das Skript wurde erfolgreich ausgeführt.',
    'brand.adminTools.deleteCustomer.title': 'Einen Kunden/Gast löschen',
    'brand.adminTools.deleteCustomer.description1':
        'Geben Sie die CustomerId ein, die Sie löschen möchten (Sie können mehrere CustomerIds eingeben, indem Sie diese durch ein Komma ohne Leerzeichen trennen, z. B.: 1234567,1234568,1234569)',
    'brand.adminTools.deleteCustomer.form.placeholder.customerId': '1234567',
    'brand.adminTools.deleteCustomer.form.customerId': 'Zu löschende CustomerId',
    'brand.adminTools.deleteCustomer.form.error': 'Beim Starten des Skripts ist ein Fehler aufgetreten.',
    'brand.adminTools.deleteCustomer.form.success': 'Das Skript wurde erfolgreich ausgeführt.',
    'brand.adminTools.razCustomer.title': 'Zurücksetzen eines Kunden/Gastes auf null',
    'brand.adminTools.razCustomer.description1':
        'Geben Sie die CustomerId ein, deren E-Wallet-Guthaben Sie auf null setzen möchten (Sie können mehrere CustomerIds eingeben, indem Sie diese durch ein Komma ohne Leerzeichen trennen, z. B.: 1234567,1234568,1234569)',
    'brand.adminTools.razCustomer.form.placeholder.customerId': '1234567',
    'brand.adminTools.razCustomer.form.customerId': 'CustomerId(s), die auf null gesetzt werden sollen (kommagetrennt)',
    'brand.adminTools.razCustomer.form.placeholder.brandId': '414',
    'brand.adminTools.razCustomer.form.brandId':
        'BrandId, die auf null gesetzt werden soll (wenn Sie eine BrandId eingeben, werden alle Kunden mit Nachzahlung dieser Marke auf null gesetzt; das Feld CustomerId(s) oben wird ignoriert)',
    'brand.adminTools.razCustomer.form.placeholder.date': '01/02/2024',
    'brand.adminTools.razCustomer.form.date':
        'Datum der Anwendung der Nullsetzung (Uhrzeit: 5:00 Uhr morgens); leer lassen, wenn die Nullsetzung sofort erfolgen soll',
    'brand.adminTools.razCustomer.form.error': 'Beim Starten des Skripts ist ein Fehler aufgetreten.',
    'brand.adminTools.razCustomer.form.success': 'Das Skript wurde erfolgreich ausgeführt.',
    'brand.adminTools.copySchedules.title':
        'Kopieren der Abholzeiten oder CEL-Zeiten von einem Restaurant zu einem oder mehreren anderen',
    'brand.adminTools.copySchedules.form.placeholder.scheduleType': 'pickup oder cel',
    'brand.adminTools.copySchedules.form.placeholder.idSource': '900',
    'brand.adminTools.copySchedules.form.placeholder.idsDestination': '901',
    'brand.adminTools.copySchedules.form.scheduleType': 'Art des zu kopierenden Zeitplans (pickup oder cel eingeben)',
    'brand.adminTools.copySchedules.form.idSource': 'Quell-RestaurantId',
    'brand.adminTools.copySchedules.form.idsDestination':
        'Ziel-RestaurantId(s) (Sie können mehrere RestaurantIds eingeben, indem Sie diese durch ein Komma ohne Leerzeichen trennen, z. B.: 901,902,903)',
    'brand.adminTools.copySchedules.form.error': 'Beim Starten des Skripts ist ein Fehler aufgetreten.',
    'brand.adminTools.copySchedules.form.success': 'Das Skript wurde erfolgreich ausgeführt.',
    'brand.adminTools.changeOrderDateInReport.title':
        'Datum einer Bestellung in den Berichten bearbeiten (Dies ändert auch das Datum der Transaktion)',
    'brand.adminTools.changeOrderDateInReport.form.orderPosId': 'Bestellnummer (orderId), Trennung durch Komma möglich',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.orderPosId': '1234567,1234568,1234569,...',
    'brand.adminTools.changeOrderDateInReport.form.day': 'Tag',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.day': 'Beispiel: 14',
    'brand.adminTools.changeOrderDateInReport.form.month': 'Monat',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.month': 'Beispiel: 7',
    'brand.adminTools.changeOrderDateInReport.form.year': 'Jahr',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.year': 'Beispiel: 2025',
    'brand.adminTools.changeOrderDateInReport.form.hour': 'Stunde',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.hour': 'Beispiel: 10',
    'brand.adminTools.changeOrderDateInReport.form.minutes': 'Minuten',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.minutes': 'Beispiel: 35',
    'brand.adminTools.changeOrderDateInReport.form.error': 'Beim Starten des Skripts ist ein Fehler aufgetreten.',
    'brand.adminTools.changeOrderDateInReport.form.success': 'Das Skript wurde erfolgreich ausgeführt.',
    'brand.adminTools.editPasswordExpiresAt.title': 'Eine Marke/einen Gast zum Passwortwechsel zwingen',
    'brand.adminTools.editPasswordExpiresAt.form.placeholder.shouldResetPassword': 'force oder cancel',
    'brand.adminTools.editPasswordExpiresAt.form.placeholder.brandId': '900',
    'brand.adminTools.editPasswordExpiresAt.form.placeholder.customerId': ' ',
    'brand.adminTools.editPasswordExpiresAt.form.shouldResetPassword':
        'Zum Passwortwechsel zwingen (force) oder Passwortwechsel abbrechen (cancel)',
    'brand.adminTools.editPasswordExpiresAt.form.brandId': 'Zielmarke',
    'brand.adminTools.editPasswordExpiresAt.form.customerId':
        'Zielgast/-gäste: Sie können mehrere CustomerIds durch Komma ohne Leerzeichen trennen (z. B.: 123456,234567,345678). Leer lassen, um die gesamte Marke anzusprechen',
    'brand.adminTools.editPasswordExpiresAt.form.error': 'Beim Starten des Skripts ist ein Fehler aufgetreten.',
    'brand.adminTools.editPasswordExpiresAt.form.success': 'Das Skript wurde erfolgreich ausgeführt.',
    'brand.adminTools.editProductSkuFromProductId.title': 'SKU mehrerer Produkte aus einer Excel-Datei bearbeiten',
    'brand.adminTools.editProductSkuFromProductId.description':
        'Laden Sie die {fileTemplate} auf Ihren Computer herunter',
    'brand.adminTools.editProductSkuFromProductId.form.error': 'Beim Starten des Skripts ist ein Fehler aufgetreten.',
    'brand.adminTools.editProductSkuFromProductId.form.success': 'Das Skript wurde erfolgreich ausgeführt.',
    'brand.adminTools.importProductInMenu.title': 'Produkte in ein bereits vorhandenes Menü importieren',
    'brand.adminTools.importProductInMenu.description': 'Laden Sie die {fileTemplate} auf Ihren Computer herunter',
    'brand.adminTools.importProductInMenu.form.error': 'Beim Starten des Skripts ist ein Fehler aufgetreten.',
    'brand.adminTools.importProductInMenu.form.success': 'Das Skript wurde erfolgreich ausgeführt.',
    'brand.adminTools.importProductFromSku.title': 'Produkte basierend auf ihrer SKU bearbeiten und importieren',
    'brand.adminTools.importProductFromSku.description1':
        'Verwenden Sie diesen {metabaseLink}, um die Produktliste Ihres Menüs zu erhalten; Sie können bestehende Produkte bearbeiten oder neue hinzufügen (SKU bei neuen Produkten nicht zwingend erforderlich).',
    'brand.adminTools.importProductFromSku.description1bis':
        'Die SKU bestehender Produkte nicht bearbeiten – sie ist der eindeutige Bezeichner des Produkts. Spaltennamen nicht ändern.',
    'brand.adminTools.importProductFromSku.description2': 'Laden Sie die {fileTemplate} auf Ihren Computer herunter',
    'brand.adminTools.importProductFromSku.form.error': 'Beim Starten des Skripts ist ein Fehler aufgetreten.',
    'brand.adminTools.importProductFromSku.form.success': 'Das Skript wurde erfolgreich ausgeführt.',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.placeholder.menuIdSource': 'menuId des Quellmenüs',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.menuIdSource': 'MenuId des Quellmenüs',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.placeholder.menuIdDestination': 'menuId des Zielmenüs',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.menuIdDestination': 'MenuId des Zielmenüs',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.placeholder.filterCategory': '(optional)',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.filterCategory': 'Kategoriefilter',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.placeholder.filterTag': '(optional)',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.filterTag': 'Tag-Filter',
    'brand.adminTools.copyProductFromMenuIdToMenuId.title': 'Produkte von einem Menü in ein anderes kopieren',
    'brand.adminTools.copyProductFromMenuIdToMenuId.description1':
        'Geben Sie die MenuId des Quellmenüs und die MenuId des Zielmenüs ein. Sie können die Produkte auch nach Kategorie und/oder Tag filtern, um nur bestimmte Produkte zu kopieren.',
    'brand.adminTools.copyProductFromMenuIdToMenuId.description2':
        'Beachten Sie, dass externe Referenzen und Schritte nicht kopiert werden',
    'brand.adminTools.copyProductFromMenuIdToMenuId.description3':
        'Bilder werden nur kopiert, wenn das Zielmenü im selben Restaurant wie das Quellmenü liegt, oder wenn das Quellmenü auf Markenebene und das Zielmenü auf Restaurantebene innerhalb derselben Marke liegt',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.error': 'Beim Starten des Skripts ist ein Fehler aufgetreten.',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.success': 'Das Skript wurde erfolgreich ausgeführt.',
    'brand.adminTools.importBackofficeUsers.title': 'Backoffice-Benutzer importieren',
    'brand.adminTools.importBackofficeUsers.description': 'Laden Sie die {fileTemplate} auf Ihren Computer herunter',
    'brand.adminTools.importBackofficeUsers.form.error': 'Beim Starten des Skripts ist ein Fehler aufgetreten.',
    'brand.adminTools.importBackofficeUsers.form.success': 'Das Skript wurde erfolgreich ausgeführt.',
    'brand.adminTools.editProductInfoFromProductId.title': 'Produkte aus einer Excel-Datei bearbeiten',
    'brand.adminTools.editProductInfoFromProductId.description1':
        'Verwenden Sie diesen {metabaseLink}, um die Produktliste Ihres Menüs zu erhalten; füllen Sie die für die Bearbeitung vorgesehenen Spalten aus und laden Sie die Datei hoch. (Spaltennamen nicht ändern)',
    'brand.adminTools.editProductInfoFromProductId.description2':
        'Laden Sie die {fileTemplate} auf Ihren Computer herunter',
    'brand.adminTools.editProductInfoFromProductId.form.error': 'Beim Starten des Skripts ist ein Fehler aufgetreten.',
    'brand.adminTools.editProductInfoFromProductId.form.success': 'Das Skript wurde erfolgreich ausgeführt.',
    'brand.adminTools.editStepInfoFromStepId.title': 'Schritte aus einer Excel-Datei bearbeiten',
    'brand.adminTools.editStepInfoFromStepId.description0':
        'Dieses Skript ermöglicht die massenhafte Änderung von Namen, Referenzen und Labels der Schritte, nicht jedoch der Produktliste.',
    'brand.adminTools.editStepInfoFromStepId.description1':
        'Verwenden Sie diesen {metabaseLink}, um die Schrittliste Ihres Menüs zu erhalten; füllen Sie die für die Bearbeitung vorgesehenen Spalten aus und laden Sie die Datei hoch. (Spaltennamen nicht ändern)',
    'brand.adminTools.editStepInfoFromStepId.form.error': 'Beim Starten des Skripts ist ein Fehler aufgetreten.',
    'brand.adminTools.editStepInfoFromStepId.form.success': 'Das Skript wurde erfolgreich ausgeführt.',
    'brand.adminTools.editProductPriceInAdminTools.title':
        'Preise von Produkten (außerhalb und innerhalb von Schritten) aus einer Excel-Datei bearbeiten',
    'brand.adminTools.editProductPriceInAdminTools.description1':
        'Verwenden Sie diesen {metabaseLink}, um die Produktliste Ihres Menüs zu erhalten; füllen Sie die Spalte "Neuer Preis" aus und laden Sie die Datei hoch. (Spaltennamen nicht ändern)',
    'brand.adminTools.editProductPriceInAdminTools.description2':
        'Laden Sie die {fileTemplate} auf Ihren Computer herunter',
    'brand.adminTools.editProductPriceInAdminTools.form.error': 'Beim Starten des Skripts ist ein Fehler aufgetreten.',
    'brand.adminTools.editProductPriceInAdminTools.form.success': 'Das Skript wurde erfolgreich ausgeführt.',
    'brand.adminTools.editProductTagFromProductId.title':
        'Einem oder mehreren Produkten aus einer Excel-Datei Tag(s) hinzufügen',
    'brand.adminTools.editProductTagFromProductId.description':
        'Laden Sie die {fileTemplate} auf Ihren Computer herunter',
    'brand.adminTools.editProductTagFromProductId.form.error': 'Beim Starten des Skripts ist ein Fehler aufgetreten.',
    'brand.adminTools.editProductTagFromProductId.form.success': 'Das Skript wurde erfolgreich ausgeführt.',
    'brand.adminTools.makeEwalletTransaction.title': 'E-Wallet-Transaktionen aus einer Excel-Datei durchführen',
    'brand.adminTools.makeEwalletTransaction.description': 'Laden Sie die {fileTemplate} auf Ihren Computer herunter',
    'brand.adminTools.makeEwalletTransaction.form.error': 'Beim Starten des Skripts ist ein Fehler aufgetreten.',
    'brand.adminTools.makeEwalletTransaction.form.success': 'Das Skript wurde erfolgreich ausgeführt.',
    'brand.adminTools.bulkUploadDualScreenImage.title':
        'Bild für Doppelbildschirm auf allen Kassen einer Marke hochladen',
    'brand.adminTools.bulkUploadDualScreenImage.description':
        'Laden Sie ein Bild (PNG oder JPG) hoch und geben Sie die brandId ein. Das Bild wird auf alle Kassen der Marke angewendet.',
    'brand.adminTools.bulkUploadDualScreenImage.brandIdLabel': 'Brand ID',
    'brand.adminTools.bulkUploadDualScreenImage.brandIdPlaceholder': 'Brand ID eingeben',
    'brand.adminTools.bulkUploadDualScreenImage.form.success': 'Das Bild wurde auf alle Kassen hochgeladen.',
    'brand.adminTools.transformGuestFile.title':
        'Ihre aus der neuen Website abgerufene Gastdatei in das Innovorder-Format umwandeln',
    'brand.adminTools.transformGuestFile.fileFormat': 'Originaldateiformat',
    'brand.adminTools.transformGuestFile.form.success': 'Die Datei wurde erfolgreich umgewandelt',
    'brand.adminTools.transformGuestFile.form.url': 'Klicken Sie hier, um die Datei herunterzuladen',
    'brand.adminTools.transformGuestFile.fileFormat.JES': 'JES',
    'brand.adminTools.transformGuestFile.fileFormat.CSI': 'CSI',
    'brand.adminTools.transformGuestFile.fileFormat.X-GIL': 'x-gil',
    'brand.adminTools.transformGuestFile.fileFormat.PI-ELECTRONICS': 'Pi Electronique',
    'brand.adminTools.generateSalesReport.title': 'IO-Verkäufe in SI Sodexo übertragen',
    'brand.adminTools.generateSalesReport.description':
        'IO-Verkäufe für ein bestimmtes Restaurant in SI Sodexo synchronisieren (wenn Sie einen Zeitraum verwenden, werden die Verkäufe für den ausgewählten Zeitraum synchronisiert)',
    'brand.adminTools.generateSalesReport.form.checkbox': 'Zeitraum verwenden',
    'brand.adminTools.generateSalesReport.form.restaurant': 'Restaurant auswählen',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.title':
        'SKU der Produkte mit externen ID-Mappings verknüpfen',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.description':
        'Erstellt Mappings zwischen internen productId und den Produkt-SKUs für ein bestimmtes Menü',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.form.restaurant': 'Restaurant',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.form.menu': 'Menü',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.form.success': 'Das Skript wurde erfolgreich ausgeführt.',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.form.error':
        'Beim Starten des Skripts ist ein Fehler aufgetreten.',
    'spotlight.search.placeholder': 'Was möchten Sie tun?',
    'spotlight.section.suggestion': 'Vorschlag',
    'spotlight.section.history': 'Verlauf',
    'spotlight.context.brand': 'Marke',
    'spotlight.context.restaurant': 'Restaurant',
    'spotlight.error.noHistory': 'Sie haben noch keine qualifizierte URL in Ihrem Verlauf',
    'orderList.title': 'Bestellungen',
    'orderList.subtitle': 'Finden Sie die Bestellungen Ihrer Kunden',
    'orderList.filters.allRestaurants': 'Alle Restaurants',
    'orderList.filters.restaurantHeader': 'Meine Restaurants',
    'orderList.filters.restaurantPlaceholder': 'Restaurant suchen',
    'orderList.filters.dateRange.lastXdays': '{days} letzte Tage',
    'orderList.filters.dateRange.custom': 'Benutzerdefiniert',
    'orderList.generation_history': 'Generierungsverlauf',
    'orderList.export': 'Export',
    'orderList.generate': 'Generieren',
    'orderList.export.title': 'Exportieren',
    'orderList.export.selectOneDay': 'Einen Tag auswählen',
    'orderList.export.selectPeriod': 'Einen Zeitraum auswählen',
    'orderList.export.format': 'Exportformat auswählen',
    'orderList.export.file.xlsx': 'Excel',
    'orderList.export.file.csv': 'CSV',
    'orderList.export.file.pdf': 'PDF',
    'orderList.export.dateRage.errorMessage': 'Sie können nicht mehr als 31 Tage auswählen',
    'orderList.export.presetDate.currentWeek': 'Aktuelle Woche',
    'orderList.export.presetDate.currentMonth': 'Aktueller Monat',
    'orderList.export.presetDate.lastMonth': 'Letzter Monat',
    'orderList.export.presetDate.chooseDate': 'Bitte wählen Sie einen Zeitraum aus',
    'orderList.export.includeOrderStates': 'Die verschiedenen Bestellstatus einbeziehen',
    'order.field.ticketNumber': 'Bonnummer',
    'order.field.status': 'Status',
    'order.field.restaurant': 'Restaurant',
    'order.field.channel': 'Kanal',
    'order.field.customerName': 'Name & Vorname',
    'order.field.customerNameMassCatering': 'Name & Vorname Gast',
    'order.field.badgeNumber': 'Ausweisnummer',
    'order.field.phone': 'Telefonnummer',
    'order.field.pricingRule': 'Tarifregime',
    'order.field.pricingRuleInOrder': 'Angewandtes Tarifregime',
    'order.field.company': 'Unternehmen',
    'order.field.orderId': 'Bestellnummer',
    'order.field.consumptionMode': 'Verzehrart',
    'order.field.orderDate': 'Bestelldatum',
    'order.field.expectedDate': 'Lieferdatum',
    'order.field.ticketDate': 'Bondatum',
    'order.field.totalWithVat': 'Gesamtbetrag inkl. MwSt.',
    'order.field.turnoverWithVat': 'Umsatz inkl. MwSt.',
    'order.field.paymentMethod': 'Zahlungsart',
    'order.field.paymentStatus': 'Zahlungsstatus',
    'order.field.paymentAmount': 'Zahlungsbetrag',
    'order.status.PAID': 'Bezahlt',
    'order.status.CANCELLED': 'Storniert',
    'order.status.VALIDATED': 'Validiert',
    'order.status.PAID_CANCELLED': 'Bezahlt (storniert)',
    'order.status.CONTRA_ENTRY': 'Gegenbuchung',
    'order.status.INCOHERENT': 'Inkohärente Bestellung',
    'order.channel.': 'Unbekannt',
    'order.channel.1': 'Kiosk',
    'order.channel.2': 'CEL',
    'order.channel.5': 'Kasse',
    'order.channel.8': 'DA',
    'order.channel.9': 'Uber Eats',
    'order.channel.10': 'Deliveroo',
    'order.channel.11': 'Just Eat',
    'order.consumptionMode.1': 'Lieferung',
    'order.consumptionMode.2': 'Zum Mitnehmen',
    'order.consumptionMode.3': 'Vor Ort',
    'order.consumptionMode.4': 'Drive',
    'order.webPaymentStatus.PAYMENT_OK': 'Bezahlt',
    'order.webPaymentStatus.PAYMENT_PENDING': 'Nicht bezahlt',
    'order.webPaymentStatus.PAYMENT_REFUSED': 'Zahlung abgelehnt',
    'order.webPaymentStatus.PAYMENT_REFUNDED': 'Erstattet',
    'order.paymentMethod.AlloResto': 'AlloResto',
    'order.paymentMethod.AmericanExpress': 'American Express',
    'order.paymentMethod.Cash': 'Bargeld',
    'order.paymentMethod.Change': 'Wechselgeld',
    'order.paymentMethod.Check': 'Scheck',
    'order.paymentMethod.CreditCard': 'EC-/Kreditkarte',
    'order.paymentMethod.CreditNote': 'Guthaben',
    'order.paymentMethod.CreditNoteIssued': 'Ausgestelltes Guthaben',
    'order.paymentMethod.Deliveroo': 'Deliveroo',
    'order.paymentMethod.ELuncheonVoucher': 'E-Ticket Restaurant',
    'order.paymentMethod.EWallet': 'E-Wallet',
    'order.paymentMethod.ExternalPayment': 'Externe Zahlung',
    'order.paymentMethod.Foodora': 'Foodora',
    'order.paymentMethod.Ingenico': 'Ingenico',
    'order.paymentMethod.LuncheonVoucher': 'Essensgutschein',
    'order.paymentMethod.Lydia': 'Lydia',
    'order.paymentMethod.Nepting': 'Nepting',
    'order.paymentMethod.OnlineCreditCard': 'Online-Bankkarte',
    'order.paymentMethod.Paygreen': 'Paygreen',
    'order.paymentMethod.RestoFlash': 'Resto Flash',
    'order.paymentMethod.Stripe': 'Stripe',
    'order.paymentMethod.Transfer': 'Überweisung',
    'order.paymentMethod.UberEats': 'Uber Eats',
    'order.paymentMethod.Unknown': 'Sonstige',
    'order.paymentMethod.Unknown2': 'Sonstige 2',
    'order.paymentMethod.Edenred': 'Edenred',
    'orderDetail.error.incoherent': 'Support kontaktieren, um die Bestellung zu regulieren',
    'orderDetail.title.1': 'Kiosk',
    'orderDetail.title.2': 'Online-Bestellung',
    'orderDetail.title.5': 'Kasse',
    'orderDetail.title.8': 'Automatische Ausgabe',
    'orderDetail.title.9': 'Uber Eats',
    'orderDetail.title.10': 'Deliveroo',
    'orderDetail.title.11': 'Just Eat',
    'orderDetail.title.contraEntry': 'Gegenbuchungsbestellung',
    'orderDetail.status.PAID': 'Zahlung',
    'orderDetail.status.VALIDATED': 'Rechnung',
    'orderDetail.status.CANCELLED': 'Storniert',
    'orderDetail.tabStatus.PAID': 'Bezahlter Verkauf',
    'orderDetail.tabStatus.VALIDATED': 'Validierter Warenkorb',
    'orderDetail.tabStatus.CANCELLED': 'Stornierung',
    'orderDetail.paymentStatus.PAID': 'Bezahlt',
    'orderDetail.paymentStatus.CANCELLED': 'Storniert',
    'orderDetail.paymentStatus.REFUNDED': 'Erstattet',
    'orderDetail.shift.default': 'Standardschicht',
    'orderDetail.header.guestNumber': 'Anzahl der Gedecke:',
    'orderDetail.header.currency': 'Währung:',
    'orderDetail.header.orderedAt': 'Bestellt um',
    'orderDetail.header.deliverAt': 'Lieferung voraussichtlich um',
    'orderDetail.header.deliverAtRange': 'Geplant für das Zeitfenster:',
    'orderDetail.header.status': 'Status',
    'orderDetail.header.payment': 'Zahlung',
    'orderDetail.header.table': 'Tisch',
    'orderDetail.kpi.date': 'Am {date, date}',
    'orderDetail.kpi.time': '{date, date, ::HHmm}',
    'orderDetail.kpi.timeRange': 'von {start, date, ::HHmm} bis {end, date, ::HHmm}',
    'orderDetail.ticketInfo': 'Bestelldetails',
    'orderDetail.comment': 'Kommentar',
    'orderDetail.userName': 'Kundenname',
    'orderDetail.taxInfo': 'MwSt.-Details',
    'orderDetail.paymentInfo': 'Zahlungsmittel',
    'orderDetail.customerInfo': 'Kundeninformationen',
    'orderDetail.deliveryInfo': 'Lieferung',
    'orderDetail.loyaltyInfo': 'Treueprogramm',
    'orderDetail.posInfo': 'Kasseninformationen',
    'orderDetail.transactionInfo': 'Transaktionsdetails',
    'orderDetail.orderPhotos': 'Der Bestellung zugeordnete Fotos',
    'orderDetail.customer.name': 'Vorname und Nachname',
    'orderDetail.customer.email': 'E-Mail',
    'orderDetail.customer.phone': 'Telefonnummer',
    'orderDetail.customer.badgeNumber': 'Ausweisnummer',
    'orderDetail.customer.pricingRule': 'Tarifregime',
    'orderDetail.customer.pricingRuleAssigned': 'Zugewiesenes Tarifregime',
    'orderDetail.customer.group': 'Gruppe',
    'orderDetail.customer.section': 'Abteilung',
    'orderDetail.customer.subSection': 'Unterabteilung',
    'orderDetail.customer.balanceInformation.ewalletBalanceBeforeOrder': 'Alter E-Wallet-Kontostand',
    'orderDetail.customer.balanceInformation.ewalletBalanceAfterOrder': 'Neuer E-Wallet-Kontostand',
    'orderDetail.Pos.restaurant': 'Restaurant',
    'orderDetail.Pos.seller': 'Bediener',
    'orderDetail.Pos.deviceName': 'Kassenname',
    'orderDetail.Pos.deviceId': 'POS-ID',
    'orderDetail.action.text': 'Bestellaktionen',
    'orderDetail.action.cancel': 'Stornieren',
    'orderDetail.action.refund': 'Erstatten',
    'orderDetail.action.cancelWithContraEntry': 'Bestellung stornieren (Gegenbuchung)',
    'orderDetail.cancel.title.reason': 'Bestellung stornieren',
    'orderDetail.cancel.title.manualPaymentMethod': 'Erstattungszahlungsart',
    'orderDetail.cancel.text1': 'Bei Bedarf können Sie die Bestellung eines Kunden stornieren.',
    'orderDetail.cancel.text2': 'Sie müssen unten einen Stornierungsgrund auswählen.',
    'orderDetail.cancel.text3': 'Wenn der Grund nicht in der Liste aufgeführt ist, klicken Sie auf "Sonstige".',
    'orderDetail.cancel.text4': 'Der von Ihnen ausgewählte Grund wird dem Kunden per E-Mail mitgeteilt.',
    'orderDetail.cancel.text5': 'Die abgezogenen Produktmengen werden wieder auf Lager gelegt.',
    'orderDetail.cancel.text6': 'Sie können die Zahlungsart auswählen, die der Erstattung zugeordnet werden soll.',
    'orderDetail.cancel.text7':
        '⚠️ Es ist notwendig, den Kunden physisch zu erstatten, um buchhalterische Abweichungen zu vermeiden.',
    'orderDetail.cancel.reason.description.label': 'Freitextfeld (optional)',
    'orderDetail.cancel.reason.placeholder': 'Stornierungsgrund auswählen',
    'orderDetail.cancel.reason.description.placeholder': 'Maximal 250 Zeichen',
    'orderDetail.cancel.manualPaymentMethod.placeholder': 'Zahlungsart auswählen',
    'orderDetail.cancel.reason.CANNOT_FULFILL_ORDER': 'Bestellung kann nicht abgeschlossen werden',
    'orderDetail.cancel.reason.ORDERING_MISTAKE': 'Bestellfehler',
    'orderDetail.cancel.reason.UNSATISFIED_CUSTOMER':
        'Unzufriedener Kunde (Mengen werden nicht zurück auf Lager gelegt)',
    'orderDetail.cancel.reason.CUSTOMER_NO_SHOW': 'Kunde ist nicht erschienen',
    'orderDetail.cancel.reason.CUSTOMER_LEAVES': 'Kunde ist gegangen',
    'orderDetail.cancel.reason.LEARNING_MODE': 'Schulung',
    'orderDetail.cancel.reason.TECHNICAL': 'Technischer Fehler',
    'orderDetail.cancel.reason.OTHER': 'Sonstige...',
    'orderDetail.cancel.manualPaymentMethod.Cash': 'Bargeld',
    'orderDetail.cancel.manualPaymentMethod.CreditCard': 'EC-/Kreditkarte',
    'orderDetail.cancel.confirm': 'Bestellung stornieren',
    'orderDetail.cancel.validate': 'Stornierung bestätigen',
    'orderDetail.ticket.itemSum': 'Artikelgesamt',
    'orderDetail.ticket.grantSum': 'Subventionsgesamt',
    'orderDetail.ticket.entranceFeeSum': 'Zutrittsgebühren gesamt',
    'orderDetail.ticket.pricingRule': 'Tarifregime: ',
    'orderDetail.ticket.discountSum': 'Rabatte gesamt',
    'orderDetail.ticket.tvaSum': 'MwSt. gesamt',
    'orderDetail.ticket.finalPrice': 'GESAMT',
    'orderDetail.ticket.discount': 'Aktionscode:',
    'orderDetail.tax.taxrate': 'MwSt.-Satz',
    'orderDetail.tax.totalExclTax': 'Netto',
    'orderDetail.tax.totalTax': 'MwSt.',
    'orderDetail.tax.totalInclTax': 'Brutto',
    'orderDetail.transaction.transactionIds': 'Transaktionskennung',
    'orderDetail.payment.quantity': 'Menge',
    'orderDetail.payment.price': 'Preis',
    'orderDetail.delivery.address': 'Adresse',
    'orderDetail.delivery.apartmentNumber': 'Wohnungsnummer',
    'orderDetail.delivery.digicode': 'Türcode',
    'orderDetail.delivery.phoneNumber': 'Telefonnummer',
    'orderDetail.delivery.additionalInfo': 'Zusätzliche Informationen',
    'orderDetail.linkedOrder.title.origin': 'Verknüpfung mit der Gegenbuchungsbestellung',
    'orderDetail.linkedOrder.title.contra_entry': 'Verknüpfung mit der stornierten Bestellung',
    'orderDetail.linkedOrder.date.origin': 'Datum der Gegenbuchungsbestellung',
    'orderDetail.linkedOrder.date.contra_entry': 'Datum der stornierten Bestellung',
    'orderDetail.contraEntryInfo.title': 'Gegenbuchungsinformationen',
    'orderDetail.contraEntryInfo.validator': 'Prüfer',
    'orderDetail.contraEntryInfo.cancellationReasonDescription': 'Freitextfeld',
    'route.ioPayTransactions': 'Transaktionen',
    'route.ioPayReports': 'Berichte',
    'route.ioPayTransfers': 'Auszahlungen',
    'route.ioPayConfiguration': 'Konfiguration',
    'route.ioPayTransferDetail': 'Auszahlungsdetails',
    'route.ioPayTransactionDetail': 'Transaktionsdetails',
    'ioPay.title': 'Adyen',
    'transactions.title': 'Transaktionen',
    'transactions.detail.title': 'Transaktionsblatt',
    'transactions.subtitle': 'Transaktionen Ihrer Kunden einsehen',
    'transaction.field.id': 'ID',
    'transaction.field.type': 'Typ',
    'transaction.field.brand': 'Marke',
    'transaction.field.customerEmail': 'E-Mail',
    'transaction.field.date': 'Datum',
    'transaction.field.paymentMethod': 'Zahlungsart',
    'transaction.field.paymentStatus': 'Zahlungsmodus',
    'transaction.field.paymentAmount': 'Zahlungsbetrag',
    'transaction.field.paymentAmount.tooltip': 'Vom Kunden gezahlter Betrag',
    'transaction.field.reversalAmount': 'Von Innovorder ausgezahlter Betrag',
    'transaction.field.reversalAmount.tooltip':
        'Ausgezahlter Betrag nach Abzug der Zahlungskommission (der Betrag kann negativ sein, wenn die Mittel nicht über Innovorder laufen und direkt auf Ihr Bankkonto überwiesen werden)',
    'transaction.field.amount': 'Transaktionsbetrag',
    'transaction.field.amount.tooltip': 'Summe der von Innovorder ausgezahlten Beträge abzüglich der Erstattungen',
    'transaction.field.fee': 'Provision',
    'transaction.field.channel': 'Kanal',
    'transaction.field.transfer': 'Auszahlung',
    'transaction.field.currency': 'Währung',
    'transaction.field.status': 'Status',
    'transaction.field.ip': 'IP',
    'transaction.field.referer': 'Referer',
    'transaction.field.userAgent': 'User Agent',
    'transaction.field.customerCompleteName': 'Name und Vorname',
    'transaction.field.email': 'E-Mail',
    'transaction.field.customerId': 'Kunden-ID',
    'transaction.field.badgeNumber': 'Ausweisnummer',
    'transaction.field.lastUpdate': 'Aktualisierungsdatum',
    'transaction.field.source': 'Quelle',
    'transaction.field.orderId': 'Bestellnummer',
    'transaction.field.error': 'Fehler',
    'transaction.field.restaurant': 'Restaurant',
    'transaction.field.paymentMethodType.WEB': 'Online-Bankkarte',
    'transaction.field.paymentMethodType.PROXIMITY': 'EC-/Kreditkarte',
    'transaction.field.paymentMethod.MEAL_VOUCHER': 'Restaurantgutschein',
    'transaction.field.paymentMethod.BANK_CARD': 'Bankkarte',
    'transaction.status.PENDING': 'In Bearbeitung',
    'transaction.status.PENDING_3DS': '3DS in Bearbeitung',
    'transaction.status.DONE': 'Erfolgreich',
    'transaction.status.FAILED': 'Abgelehnt',
    'transaction.status.ERROR': 'Fehler',
    'transaction.type.CAPTURE': 'Zahlung',
    'transaction.type.REFUND': 'Erstattung',
    'transaction.channel.WEB': 'Web',
    'transaction.channel.PROXIMITY': 'Vor Ort',
    'transaction.source.WEBORDERING': 'Online-Bestellung',
    'transaction.source.EWALLET': 'E-Wallet-Aufladung',
    'transaction.source.KIOSK': 'Kiosk',
    'transaction.source.NOTIFICATION': 'Benachrichtigung',
    'transaction.detail.card.main': 'Transaktionsdetails',
    'transaction.detail.card.finance': 'Finanzdaten',
    'transaction.detail.card.web': 'Informationen zu Webdaten',
    'transaction.detail.card.customer': 'Kundeninformationen',
    'transaction.detail.card.order': 'Zugehörige Bestellung',
    'transaction.detail.card.paymentMethod': 'Zahlungsmittel',
    'transfers.title': 'Auszahlungen',
    'transfers.subtitle': 'Auszahlungen auf Ihr Konto',
    'configuration.iopay.title': 'Adyen-Konfiguration',
    'configuration.iopay.subtitle':
        'Hier finden Sie alle juristischen Personen, die Sie für Ihr Unternehmen erstellt haben. Wir haben für Sie eine klare und prägnante Übersicht Ihrer Restaurants und E-Wallets zusammengestellt, um deren Konfiguration zu erleichtern.',
    'configuration.error.unaccessible': 'Nicht gefunden oder unzureichende Berechtigungen',
    'transfer.field.id': 'ID',
    'transfer.field.ref': 'Referenz',
    'transfer.field.configurationName': 'Händler',
    'transfer.field.amount': 'Auszahlungsbetrag',
    'transfer.field.transactionCount': 'Anzahl der Transaktionen',
    'transfer.field.status': 'Status',
    'transfer.field.executedAt': 'Ausführungsdatum',
    'transfer.status.PENDING': 'In Bearbeitung',
    'transfer.status.SUCCESS': 'Bestätigt',
    'transfer.status.SENT_OUT': 'Gesendet',
    'transfer.status.FAILED': 'Fehlgeschlagen',
    'transfer.kpi.date': '{date, date} {date, time, ::HHmm}',
    'transfer.detail.title': 'Auszahlungsdetails',
    'transfer.transactions.title': 'Transaktionen der Auszahlung',
    'legalEntity.field.entity': 'Juristische Person',
    'legalEntity.field.siret': 'SIRET',
    'legalEntity.field.city': 'Stadt',
    'legalEntity.field.status': 'Status',
    'legalEntity.field.associatedRestaurants': 'Zugehörige Restaurants',
    'legalEntity.field.actions': 'Aktionen',
    'legalEntity.create.title': 'Juristische Person erstellen',
    'legalEntity.status.1': 'KYC-Fehler',
    'legalEntity.status.2': 'Zu vervollständigen',
    'legalEntity.status.3': 'Bearbeitung läuft',
    'legalEntity.status.4': 'OK',
    'legalEntity.action.addRestaurant': 'Restaurant hinzufügen',
    'legalEntity.action.addEwallet': 'E-Wallet hinzufügen',
    'legalEntity.action.completeKyc': 'KYC vervollständigen',
    'legalEntity.action.updateKyc': 'KYC aktualisieren',
    'legalEntity.wizard.step1.title': 'Erstellung einer neuen juristischen Person',
    'legalEntity.wizard.step1.legalName': 'Rechtlicher Name des Unternehmens',
    'legalEntity.wizard.step1.legalName.placeholder':
        'Bitte geben Sie den rechtlichen Namen des Unternehmens genau so ein, wie er im SIRET eingetragen ist',
    'legalEntity.wizard.step1.legalName.tooltip': 'Rechtlicher Name des Unternehmens, genau wie im SIRET eingetragen',
    'legalEntity.wizard.step1.organizationType': 'Organisationstyp',
    'legalEntity.wizard.step1.organizationType.placeholder': 'Bitte wählen Sie Ihren Organisationstyp aus',
    'legalEntity.wizard.step1.siret': 'SIRET',
    'legalEntity.wizard.step1.siret.placeholder': 'Bitte geben Sie Ihre SIRET-Nummer ein',
    'legalEntity.wizard.step1.siret.tooltip': 'SIRET des Unternehmens',
    'legalEntity.wizard.step1.addressStreet': 'Adresse der juristischen Person',
    'legalEntity.wizard.step1.addressStreet.placeholder': 'Bitte geben Sie die Adresse der juristischen Person ein',
    'legalEntity.wizard.step1.addressStreet2': 'Adresszusatz (optional)',
    'legalEntity.wizard.step1.addressStreet2.placeholder': 'Bitte geben Sie den Adresszusatz ein, falls erforderlich',
    'legalEntity.wizard.step1.addressZipcode': 'Postleitzahl',
    'legalEntity.wizard.step1.addressZipcode.placeholder': 'Bitte geben Sie Ihre Postleitzahl ein',
    'legalEntity.wizard.step1.addressCity': 'Stadt',
    'legalEntity.wizard.step1.addressCity.placeholder': 'Bitte geben Sie Ihre Stadt ein',
    'legalEntity.wizard.step1.industryCode': 'Branchencode',
    'legalEntity.wizard.step1.contactEmail': 'Kontakt-E-Mail',
    'legalEntity.wizard.step1.contactEmail.placeholder':
        'Bitte geben Sie die E-Mail-Adresse ein, die mit dieser juristischen Person verknüpft ist',
    'legalEntity.wizard.step1.iban': 'IBAN',
    'legalEntity.wizard.step1.iban.placeholder': 'Bitte geben Sie die IBAN der juristischen Person ein',
    'legalEntity.wizard.step1.iban.tooltip': 'IBAN der juristischen Person',
    'legalEntity.wizard.step2.title': 'Hinzufügen eines neuen Restaurants',
    'legalEntity.wizard.step2.titleMassCatering': 'Hinzufügen eines neuen Restaurants oder E-Wallets',
    'legalEntity.wizard.step2.chooseRestaurant': 'Restaurant auswählen',
    'legalEntity.wizard.step2.chooseRestaurantMassCatering': 'Restaurant oder E-Wallet auswählen',
    'legalEntity.wizard.step2.completeFieldsTitle': 'Auszufüllende Felder',
    'legalEntity.wizard.step2.conecsTitle': 'CONECS-Kennungen',
    'legalEntity.wizard.step2.conecsTitleOptional': '(optional)',
    'legalEntity.wizard.step2.conecsTitleOptional.tooltip':
        'Geben Sie die CONECS-Kennungen (ID) ein, um die CONECS-Zahlungsmethode für dieses Restaurant bei Vor-Ort-Zahlungen zu aktivieren',
    'legalEntity.wizard.step2.ewallet': 'E-Wallet',
    'legalEntity.wizard.step2.selectRestaurant': 'Restaurant',
    'legalEntity.wizard.step2.selectRestaurantMassCatering': 'Restaurant oder E-Wallet',
    'legalEntity.wizard.step2.selectRestaurant.placeholder': 'Bitte wählen Sie ein Restaurant aus',
    'legalEntity.wizard.step2.phoneNumber': 'Telefonnummer',
    'legalEntity.wizard.step2.phoneNumber.placeholder':
        'Bitte geben Sie die Telefonnummer ein, die diesem Restaurant zugeordnet werden soll',
    'legalEntity.wizard.step2.shopperStatement': 'Titel auf dem Kontoauszug',
    'legalEntity.wizard.step2.shopperStatement.placeholder':
        'Bitte geben Sie den Titel ein, der auf dem Kontoauszug erscheint',
    'legalEntity.wizard.step2.shopperStatement.tooltip': 'Bezeichnung auf dem Kontoauszug des Endkunden',
    'legalEntity.wizard.step2.restaurantAddressStreet': 'Restaurantadresse',
    'legalEntity.wizard.step2.restaurantAddressStreet.placeholder': 'Bitte geben Sie die Restaurantadresse ein',
    'legalEntity.wizard.step2.restaurantAddressStreet2': 'Adresszusatz (optional)',
    'legalEntity.wizard.step2.restaurantAddressStreet2.placeholder':
        'Bitte geben Sie den Adresszusatz ein, falls erforderlich',
    'legalEntity.wizard.step2.restaurantAddressZipcode': 'Postleitzahl des Restaurants',
    'legalEntity.wizard.step2.restaurantAddressZipcode.placeholder':
        'Bitte geben Sie die Postleitzahl des Restaurants ein',
    'legalEntity.wizard.step2.restaurantAddressCity': 'Stadt',
    'legalEntity.wizard.step2.restaurantAddressCity.placeholder': 'Bitte geben Sie die Stadt des Restaurants ein',
    'legalEntity.wizard.step2.restaurantIban': 'IBAN',
    'legalEntity.wizard.step2.restaurantIban.placeholder': 'Bitte geben Sie die IBAN für den Geldtransfer ein',
    'legalEntity.wizard.step2.restaurantIban.tooltip':
        'Geben Sie die CONECS-Kennungen (ID) ein, um die CONECS-Zahlungsmethode für dieses Restaurant bei Vor-Ort-Zahlungen zu aktivieren',
    'legalEntity.wizard.step2.conecsId': 'CONECS MID',
    'legalEntity.wizard.step2.conecsId.placeholder':
        'Bitte geben Sie die CONECS MID ein, die auf Ihrer Domizilierungskarte steht',
    'legalEntity.wizard.step2.conecsAssociatedSiret': 'Mit dem CONECS-Vertrag verknüpfte SIRET',
    'legalEntity.wizard.step2.conecsAssociatedSiret.placeholder':
        'Bitte geben Sie die mit dem CONECS-Vertrag verknüpfte SIRET ein',
    'legalEntity.organizationType.1': 'Privatunternehmen',
    'legalEntity.organizationType.2': 'Öffentliches Unternehmen',
    'legalEntity.organizationType.3': 'Eingetragene Partnerschaft',
    'legalEntity.organizationType.4': 'Gemeinnützige Organisation oder Wohltätigkeitsverband',
    'legalEntity.organizationType.5': 'Regierungsorganisation',
    'legalEntity.organizationType.6': 'Eingetragener Verein als juristische Person',
    'legalEntity.industryCode.specialFoodServices': 'Spezialisierte Gastronomiedienste',
    'legalEntity.industryCode.fullServiceRestaurants': 'Restaurants mit Vollservice',
    'legalEntity.industryCode.limitedServiceRestaurants': 'Restaurants mit eingeschränktem Service (Schnellrestaurant)',
    'legalEntity.industryCode.cafeteriasGrillBuffets': 'Kantinen, Grill-Buffets und Buffets',
    'legalEntity.industryCode.snacksNonalcoholicBeverages': 'Snack-Bars und alkoholfreie Getränkebars',
    'legalEntity.industryCode.bakeries': 'Bäckereien',
    'billing.title': 'Mein Abrechnungsbereich',
    'billing.subtitle': 'Willkommen, dieser Bereich wurde erstellt, um die Rechnungsverwaltung zu vereinfachen.',
    'billing.description':
        'Hier finden Sie die chronologisch nach Zahlungsdienst sortierten Rechnungen. Es ist nun einfach, aktuelle Zahlungen einzusehen, Rechnungen herunterzuladen und den Rechnungsverlauf mit einem Klick zu verfolgen.',
    'billing.information.edit': 'Abrechnungsinformationen bearbeiten',
    'billing.noIssuedInvoices': 'Keine ausgestellten Rechnungen',
    'billing.table.creationDate': 'Erstellungsdatum',
    'billing.table.amount': 'Betrag',
    'billing.table.status': 'Status',
    'billing.table.service': 'Dienst',
    'billing.table.invoiceNumber': 'Rechnungsnummer',
    'billing.table.invoiceName': 'Rechnungsname',
    'billing.table.dueDate': 'Fälligkeitsdatum',
    'billing.table.downloadPDF': 'PDF herunterladen',
    'billing.editConfiguration.selectEntityStep.title': 'Juristische Personen',
    'billing.editConfiguration.selectEntityStep.subtitle':
        'Eine juristische Person auswählen, bei der die Abrechnungsinformationen geändert werden sollen',
    'billing.editConfiguration.selectEntityStep.legalEntity': 'Juristische Personen',
    'billing.editConfiguration.selectEntityStep.legalEntity.placeHolder': 'Bitte aus der Liste auswählen',
    'billing.editConfiguration.selectEntityStep.noLabel': 'Juristische Person ohne Namen',
    'billing.editConfiguration.configureBillingStep.title': 'Abrechnungsinformationen',
    'billing.editConfiguration.configureBillingStep.beneficiaryName': 'Name des Begünstigten',
    'billing.editConfiguration.configureBillingStep.beneficiaryEmail': 'Mit der Rechnung verknüpfte E-Mail-Adresse',
    'billing.editConfiguration.configureBillingStep.beneficiaryAddress': 'Adresse des Begünstigten',
    'billing.editConfiguration.configureBillingStep.beneficiaryAddress2': 'Zusätzliche Informationen',
    'billing.editConfiguration.configureBillingStep.beneficiaryZipCode': 'Postleitzahl',
    'billing.editConfiguration.configureBillingStep.beneficiaryCity': 'Stadt',
    'billing.editConfiguration.configureBillingStep.recipients': 'Rechnungsempfänger',
    'billing.editConfiguration.configureBillingStep.recipients.placeholder': 'E-Mail-Adressen der Empfänger',
    'billing.editConfiguration.configureBillingStep.recipients.createLabel':
        'E-Mail-Adresse "{email}" zu den Empfängern hinzufügen',
    'billing.editConfiguration.configureBillingStep.genericErrorMessage':
        'Beim Erstellen oder Ändern der Konfigurationsinformationen ist ein Fehler aufgetreten',
    'billing.invoices.download': 'Herunterladen',
    'billing.invoices.status.1': 'Zu zahlen',
    'billing.invoices.status.2': 'Bezahlt',
    'billing.invoices.psp.4': 'Stripe',
    'billing.invoices.name.4': 'Einheitliche Stripe-Rechnung',
    'reports.title': 'Adyen-Berichte',
    'reports.subtitle':
        'Sehen Sie die auf Ihr Bankkonto überwiesenen Transaktionen ein, mit Transaktionsdetails für jede Überweisung. Dieser Bericht ermöglicht Ihnen eine buchhalterische Zuverlässigkeitsprüfung der E-Wallet-Transaktionen mit Adyen.',
    'reports.text': 'Einen oder mehrere Berichtstyp(en) generieren',
    'reports.choosePeriod': 'Zeitraum auswählen',
    'reports.chooseReport': 'Einen oder mehrere Berichtstyp(en) auswählen',
    'reports.outgoingTransfers': 'Auszahlungen',
    'reports.reportType': 'BERICHTSTYP(EN)',
    'reports.error.missingDates': 'Bitte wählen Sie zwei Daten aus',
    'reports.error.missingReportType': 'Bitte wählen Sie einen Bericht aus',
    'reports.error.missingBrand': 'Kein mit dem aktuellen Benutzer verknüpftes Unternehmen',
    'pricingRevaluation.tableCard.title': 'Preisneubewertung',
    'pricingRevaluation.tableCard.subtitle':
        'Geben Sie den gewünschten Neubewertungssatz an, ob er auf Optionen und Ergänzungen angewendet werden soll, wählen Sie dann die neu zu bewertenden Menüs aus und klicken Sie auf die Schaltfläche "Bestätigen".',
    'pricingRevaluation.input.placeholder': 'Neubewertungssatz',
    'consumptionMode.MODE_DELIVERY': 'Lieferung',
    'consumptionMode.MODE_TAKE_AWAY': 'Zum Mitnehmen',
    'consumptionMode.MODE_SIT_IN': 'Vor Ort',
    'consumptionMode.MODE_DRIVE': 'Drive',
    'paymentMethods.tableCard.title': 'Verwalten und konfigurieren',
    'paymentMethods.tableCard.subtitle': 'Ihre Zahlungsmethoden',
    'paymentMethods.tab.pos': 'Kasse(n)',
    'paymentMethods.tab.web': 'Online-Bestellung',
    'paymentMethods.tab.kiosk': 'Kiosk(e)',
    'paymentMethods.tab.kiosk.integration.title': 'Sofortzahlungen',
    'paymentMethods.tab.kiosk.integration.desc1':
        'Die Kartenzahlung an Kiosken setzt voraus, dass das Restaurant über ein Ingenico-Konto verfügt.',
    'paymentMethods.tab.kiosk.integration.desc2':
        'Weitere Sofortzahlungsmethoden sind verfügbar, wenn Sie die Authentifizierung an den Kiosken aktivieren.',
    'paymentMethods.tab.kiosk.payment.title': 'Zahlungen an der Abholung',
    'paymentMethods.tab.kiosk.payment.desc':
        'Informieren Sie die Benutzer über die vom Restaurant an der Theke akzeptierten Zahlungsmethoden.',
    'paymentMethods.tab.kiosk.payment': 'Zahlungen',
    'paymentMethods.tab.kiosk.payment.accepted': 'akzeptiert',
    'paymentMethods.tab.kiosk.payment.refused': 'abgelehnt',
    'paymentMethods.consumptionMode': 'Verzehrmodi auswählen',
    'paymentMethods.externalId': 'Externer Code',
    'configure.ingenico': 'Ingenico konfigurieren',
    'configure.nepting': 'Nepting konfigurieren',
    'configure.stripe': 'Stripe konfigurieren',
    'configure.edenred': 'Edenred konfigurieren',
    'configure.iopay': 'Adyen konfigurieren',
    'configure.paygreen': 'Paygreen konfigurieren',
    'configure.ewallet': 'E-Wallet konfigurieren',
    'configure.yavin': 'IOPay konfigurieren',
    'configure.yavin.neptingConfigured': 'IOPay kann nicht konfiguriert werden, da Nepting verwendet wird.',
    'configure.nepting.yavinConfigured': 'Nepting kann nicht konfiguriert werden, da IOPay verwendet wird.',
    'configure.stripe.iopayConfigured': 'Stripe kann nicht konfiguriert werden, da Adyen verwendet wird.',
    'configure.iopay.stripeConfigured': 'Adyen kann nicht konfiguriert werden, da Stripe verwendet wird.',
    'customer.form.modalDescription': 'Bitte füllen Sie die Pflichtfelder aus *',
    'customer.form.firstName': 'Vorname *',
    'customer.form.lastName': 'Nachname *',
    'customer.form.badgeNumber': 'AUSWEIS NR. {index} *',
    'customer.form.badgeType': 'Ausweistyp',
    'customer.form.badge.default': 'Als Hauptausweis festlegen',
    'customer.form.badgeType.placeholder': 'Bitte geben Sie den Ausweistyp ein',
    'customer.form.addBadge': 'Ausweis hinzufügen',
    'customer.form.email': 'E-Mail-Adresse *',
    'customer.form.phoneNumber': 'Telefonnummer (optional)',
    'customer.form.arrivalDate': 'Ankunftsdatum (optional)',
    'customer.form.departureDate': 'Abreisedatum (optional)',
    'customer.form.password': 'Passwort *',
    'customer.form.confirmPassword': 'Passwort bestätigen *',
    'customer.form.clientInfoSection': 'Allgemeine Gastinformationen',
    'customer.form.pricingRuleSection': 'Konfiguration der Tarifregeln',
    'customer.form.accountPaymentTypeLabel': 'Kundenkontotyp *',
    'customer.form.accountPaymentTypePlaceHolder': 'Bitte wählen Sie einen Kundenkontotyp aus',
    'customer.form.guestGroupIdLabel': 'Gruppe *',
    'customer.form.guestGroupIdPlaceHolder': 'Bitte wählen Sie eine Gruppe aus',
    'customer.form.pricingRuleCodeLabel': 'Tarifregime-Code *',
    'customer.form.pricingRuleCodePlaceHolder': 'Bitte wählen Sie ein Tarifregime aus',
    'customer.form.tariffCode': 'TARIFCODE (OPTIONAL)',
    'customer.form.studentNumber': 'GASTNUMMER (OPTIONAL)',
    'customer.form.pricingRuleInfo': 'Ihr Tarifregime-Code erscheint nicht in der Liste? Bitte erstellen Sie ihn ',
    'customer.form.groupInfo': 'Um Ihre Gruppen zu definieren, gehen Sie zur Seite Marke > Hierarchisierung ',
    'customer.form.sectionInfo': 'Um Ihre Abteilungen zu definieren, gehen Sie zur Seite Marke > Hierarchisierung ',
    'customer.form.subSectionInfo':
        'Um Ihre Unterabteilungen zu definieren, gehen Sie zur Seite Marke > Hierarchisierung ',
    'customer.form.here': 'hier',
    'customer.form.section': 'ABTEILUNG (OPTIONAL)',
    'customer.form.subSection': 'UNTERABTEILUNG (OPTIONAL)',
    'customer.form.selectOptions.cash': 'Barzahlung',
    'customer.form.selectOptions.prepayment': 'Vorauszahlung',
    'customer.form.selectOptions.postpayment_bankdebit': 'Nachzahlung: Gehaltsabzug',
    'customer.form.selectOptions.postpayment_guest': 'Nachzahlung: Gäste',
    'brand.customers.action.import': 'Importieren',
    'brand.customers.action.export': 'Exportieren',
    'brand.customers.page.title': 'Kunden',
    'brand.customers.page.description':
        'Hier finden Sie die vollständige Liste der bei Ihrer Marke registrierten Kunden.',
    'customer.modal.import.title': 'Kunden importieren',
    'customer.modal.import.firstPart': '{fileTemplate} auf Ihren Computer herunterladen',
    'customer.modal.import.secondPart': 'Datei mit den Kundendaten ausfüllen',
    'customer.modal.import.thirdPart': 'Datei hochladen, um Ihre Kunden zu importieren',
    'customer.modal.import.report.title': 'Importbericht',
    'customer.modal.import.report.result': 'Ergebnis',
    'customer.modal.import.report.success': 'Erfolg',
    'customer.modal.import.report.error': 'Fehler',
    'customer.modal.import.report.message': '{created} erstellt, {updated} aktualisiert, {unchanged} unverändert',
    'customer.modal.import.warning':
        "Achtung! Die Spalten 'Tarifcode', 'Subventionscode', 'Zulassungscode' und 'Tarifregime-Code' sind veraltet und werden beim Import ignoriert. Bitte verwenden Sie die Tarifregime-Tabelle, um diese Informationen zu konfigurieren.",
    'customer.modal.import.addNew.title': 'Neue Kunden hinzufügen',
    'customer.modal.import.addNew.step1': '{link} auf Ihren Computer herunterladen',
    'customer.modal.import.addNew.step1.link': 'Vorlagedatei',
    'customer.modal.import.addNew.step2': 'Datei mit den Daten Ihrer neuen Kunden ausfüllen',
    'customer.modal.import.addNew.step3': 'Die ausgefüllte Datei unten hochladen',
    'customer.modal.import.update.title': 'Bestehende Kunden aktualisieren',
    'customer.modal.import.update.step1': '{link} auf Ihren Computer herunterladen',
    'customer.modal.import.update.step1.link': 'die aktuelle Kundendatenbasis',
    'customer.modal.import.update.step1.loading': 'Wird geladen...',
    'customer.modal.import.update.step2': 'Die Daten der zu aktualisierenden Kunden ändern',
    'customer.modal.import.update.step3': 'Die geänderte Datei unten hochladen',
    'customer.modal.import.update.warning':
        'Hinweis: Die Kundenkennung muss einem vorhandenen Kunden entsprechen, damit die Aktualisierung durchgeführt wird.',
    'customer.modal.import.options.title': 'Importoptionen',
    'customer.modal.import.options.multiBadge': 'Multi-Ausweis-Import',
    'customer.modal.import.options.autoImportGuestHierarchy':
        'Automatischer Import der Hierarchie (Gruppen, Abteilungen, Unterabteilungen)',
    'customer.modal.import.error.noResponse': 'Import fehlgeschlagen – keine Serverantwort',
    'customer.modal.import.error.invalidResponse': 'Ungültige Serverantwort',
    'customer.modal.import.error.fileTooLarge': 'Die Datei ist zu groß (max. 20 MB)',
    'customer.modal.import.loading.reading': 'Datei wird gelesen...',
    'customer.modal.import.loading.importing': 'Import läuft...',
    'customer.modal.import.result.lineError': 'Zeile {lineNumber}{nameDisplay}: {error}',
    'customer.modal.import.result.fieldError': 'Die Felder ({fields}) wurden nicht geändert (Zeile {line})',
    'customer.modal.import.result.genericError': 'Ein Fehler ist aufgetreten',
    'customer.modal.import.result.created': 'Erstellte Kunden: {count}',
    'customer.modal.import.result.updated': 'Aktualisierte Kunden: {count}',
    'customer.modal.import.result.unchanged': 'Nicht geänderte/nicht erstellte Kunden: {count}',
    'customer.modal.import.result.errors': 'Fehler',
    'customer.modal.import.result.warnings': 'Warnungen',
    'customer.modal.import.result.otherWarning.PRICING_RULE': 'Einige Tarifregeln existieren nicht im System: ',
    'customer.modal.import.result.otherWarning.ENTRANCE_FEE': 'Einige Zulassungen existieren nicht im System: ',
    'customer.modal.import.result.otherWarning.EMPTY_GUEST_GROUP': 'Einige Gäste haben eine leere Gruppe (Zeilen: ',
    'customer.modal.import.result.otherWarning.UNEXISTING_GUEST_GROUP': 'Einige Gastgruppen existieren nicht (Zeilen: ',
    'customer.modal.import.result.otherWarning.UNAUTHORIZED_PRICING_RULE':
        'Einige Tarifregeln sind für die Gruppe nicht autorisiert (Zeilen: ',
    'customer.modal.import.result.restrictedFieldsInfo':
        'Die Felder "Passwort", "PIN-Code" und "Kontostand" können nur aktualisiert werden, wenn der Kunde noch keine Transaktion durchgeführt hat.',
    'customer.create.modalTitle': 'Neuen Gast erstellen',
    'customer.update.modalTitle': 'Gast bearbeiten',
    'customer.tab.info': 'Informationen',
    'customer.tab.ewallet': 'E-Wallet',
    'customer.tab.student': 'Gemeinschaftsverpflegung',
    'customer.tab.orders': 'Bestellverlauf',
    'route.customerPricingPolicy': 'Preispolitik',
    'customer.pricingPolicy.defaultTitle': 'Standardrichtlinie',
    'customer.pricingPolicy.defaultDescription':
        'Die Standard-Preispolitik wird auf jeden Kunden angewendet, der sein Konto über das Online-Bestellmodul erstellt.',
    'customer.pricingPolicy.customTitle': 'Benutzerdefinierte Richtlinie',
    'customer.pricingPolicy.entranceFee': 'Zutrittsgebühr',
    'customer.pricingPolicy.pricingPolicy': 'Tarifregime',
    'customer.pricingPolicy.group': 'Gruppe',
    'customer.pricingPolicy.groupPlaceholder': 'MEINE GRUPPE',
    'customer.pricingPolicy.domainName': 'Domainname',
    'customer.pricingPolicy.delete': 'Löschen',
    'customer.pricingPolicy.noEntranceFee': 'Keine Zutrittsgebühr',
    'customer.pricingPolicy.noPricingRule': 'Keine Tarifregel',
    'customer.pricingPolicy.noGroup': 'Keine Gruppe',
    'customer.pricingPolicy.enableWhitelisting': 'Registrierung auf deklarierte Domains beschränken',
    'customer.pricingPolicy.enableWhitelistingInfo':
        'Wenn diese Option aktiviert ist, ist die Online-Registrierung nur für deklarierte Domains erlaubt',
    'customer.pricingPolicy.save': 'Speichern',
    'customer.student.info.title': 'Informationen',
    'customer.student.info.desctiption': 'Informationen zum Modus Gemeinschaftsverpflegung.',
    'customer.student.info.account.type': 'Ausweistyp',
    'customer.student.info.group': 'Gruppe',
    'customer.student.info.section': 'Abteilung',
    'customer.student.info.sub.section': 'Unterabteilung',
    'customer.student.info.badge.number': 'Ausweisnummer',
    'customer.student.info.pricing.code': 'Tarifcode',
    'customer.student.info.student.number': 'Gastnummer',
    'customer.student.pricing.rules.title': 'Tarifregeln',
    'customer.student.pricing.rules.desctiption':
        'Sie können jedem Kunden spezifische Tarifregeln zuweisen. Ein Kunde kann einen Subventionscode und/oder Zulassungscode ODER einen Tarifregime-Code haben (eine Kombination aus Zulassungsgebühren und/oder Subventionen).',
    'customer.student.pricing.rules.deprecated':
        '⚠️ Die Felder Zulassungscode und Subventionscode sind nun veraltet und wurden durch das Feld Tarifregime-Code ersetzt (der Zulassungen und Subventionen zusammenfasst). {moreInfo}',
    'customer.student.pricing.rules.more_info': 'Weitere Informationen',
    'customer.student.pricing.rules.grant.code': 'Subventionscode',
    'customer.student.pricing.rules.entrance.fee.code': 'Zulassungscode',
    'customer.student.pricing.rules.code': 'Tarifregime-Code',
    'customer.student.overdraft.title': 'Autorisierter E-Wallet-Überziehungsrahmen',
    'customer.student.overdraft.desctiption':
        'Sie können den maximalen autorisierten Überziehungsrahmen eines Kunden für die Nutzung seines E-Wallets individuell anpassen.',
    'customer.student.overdraft.price.label': 'Autorisierter E-Wallet-Überziehungsrahmen',
    'customer.student.overdraft.disabled': 'Der Standard-E-Wallet-Überziehungsrahmen ist diesem Kunden zugewiesen.',
    'customer.student.badge.title': 'Hauptausweis des Gastes sperren',
    'customer.student.badge.description': 'Sie können den Hauptausweis vorübergehend sperren.',
    'customer.student.badge.table.default': 'Hauptausweis',
    'customer.student.badge.table.number': 'Ausweisnummer',
    'customer.student.badge.table.type': 'Typ',
    'customer.student.badge.table.status': 'Status',
    'customer.student.badge.table.action': 'Aktion',
    'customer.student.badge.table.status.active': '✓ Aktiviert',
    'customer.student.badge.table.status.blocked': '✕ Gesperrt',
    'customer.student.add.badge': '+ Ausweis hinzufügen',
    'customer.student.badge.form.add': 'Ausweis hinzufügen',
    'customer.student.badge.form.update': 'Ausweis bearbeiten',
    'customer.student.badge.form.default': 'Als Hauptausweis festlegen',
    'customer.ordersList.title': 'Bestellungen',
    'customer.ordersList.subtitle': 'Bestellungen Ihres Kunden einsehen',
    'customer.ordersList.downloadTickets': 'Tickets herunterladen',
    'customer.ordersList.exportStarted': 'Ticketexport läuft. Bitte warten...',
    'customer.ordersList.exportSuccess': 'Tickets erfolgreich exportiert!',
    'customer.ordersList.exportFailed': 'Ticketexport fehlgeschlagen. Bitte versuchen Sie es erneut.',
    'customer.ordersList.exportNoTicketsForDates': 'Keine Tickets für die ausgewählten Daten.',
    'customer.ordersList.downloadChoice.all': 'Alle Tickets',
    'customer.ordersList.downloadChoice.selectedRange': 'Nur die ausgewählten Daten',
    'order.field.downloadTicket': 'Herunterladen',
    'pricingRevaluation.options.exceeding': 'Auf Überziehungen anwenden',
    'pricingRevaluation.options.options': 'Auf Optionen anwenden',
    'pricingRevaluation.options.updateInPlace': 'Vernetzter Kühlmenü/Tablettscan',
    'pricingRevaluation.options.updateInPlace.tooltip':
        'Wenn die Checkbox aktiviert ist, wird die Neubewertung direkt auf das Originalmenü angewendet, um die IDs zu erhalten (eine Kopie des Menüs ohne Neubewertung wird erstellt). \nWenn die Checkbox deaktiviert ist, wird die Neubewertung auf eine Kopie des Menüs angewendet (neue IDs) und das Originalmenü wird nicht geändert.',
    'pricingRevaluation.table.menu.name': 'Menüname',
    'pricingRevaluation.table.menu.isActive': 'Aktives Menü',
    'pricingRevaluation.table.menu.channels': 'Kanäle',
    'pricingRevaluation.table.menu.selected': 'Ausgewählt',
    'pricingRevaluation.table.emptyMessage': 'Keine Menüs für dieses Restaurant gefunden',
    'pricingRevaluation.table.search': 'Menüs suchen',
    'pos_layout.name': 'POS-Tastenplan',
    'pos_layout.page.title': 'POS-Tastenplan',
    'pos_layout.page.description':
        'Organisieren Sie Ihren Tastenplan und stellen Sie ihn auf dem oder den zugehörigen POS-Geräten bereit.',
    'pos_layout.sort': 'Neu anordnen',
    'pos_layout.sort.random': 'Zufällig',
    'pos_layout.sort.by_name': 'Nach Name',
    'pos_layout.sort.by_price': 'Nach Preis',
    'pos_layout.tabletSize': 'Tabletgröße',
    'pos_layout.inches': 'Zoll',
    'pos_layout.publishDescription':
        'Möchten Sie das Menü und den Tastenplan wirklich speichern und auf dem/den zugehörigen POS-Gerät(en) veröffentlichen?',
    'pos_layout.assignPos': 'POS zuordnen',
    'pos_layout.modal.warning': 'Achtung',
    'pos_layout.modal.publish.description':
        'Die folgenden Kategorien des Tastenplans haben keine zugehörigen Produkte: \n• {categories} \nMöchten Sie die Veröffentlichung dieses Tastenplans bestätigen?',
    'pos_layout.modal.save.description':
        'Die folgenden Kategorien des Tastenplans haben keine zugehörigen Produkte: \n• {categories} \nMöchten Sie das Speichern dieses Tastenplans bestätigen?',
    'pos_layout.customPrice': 'Freier Preis',
    'pos_layout.functions.create.title': 'Funktionstaste hinzufügen',
    'pos_layout.functions.edit.title': 'Funktionstaste bearbeiten',
    'pos_layout.functions.type': 'Tastentyp',
    'pos_layout.functions.type.placeholder': 'Typ auswählen',
    'pos_layout.functions.type.webview': 'Weblink / URL',
    'pos_layout.functions.name': 'Tastenname',
    'pos_layout.functions.url': 'Zielweblink/-URL',
    'pos_layout.functions.submit': 'Speichern',
    'pos_layout.functions.verifyLink': 'Link überprüfen',
    'pos_layout.functions.widthPercent': 'Breite',
    'pos_layout.functions.heightPercent': 'Höhe',
    'pos_device.role.independent': 'Unabhängig',
    'pos_device.role.master': 'Hauptgerät',
    'pos_device.role.slave': 'Abhängig',
    'pos_device.role.independent.plural': 'Unabhängige',
    'pos_device.role.master.plural': 'Hauptgeräte',
    'pos_device.role.slave.plural': 'Abhängige',
    'action.action': 'Aktion',
    'action.edit': 'Bearbeiten',
    'action.duplicate': 'Duplizieren',
    'action.copy': 'Kopieren',
    'action.export': 'Exportieren',
    'action.publish': 'Veröffentlichen',
    'action.delete': 'Löschen',
    'action.hide': 'Ausblenden',
    'customers.page.title': 'Kunden',
    'customers.page.description': 'Ihre Kunden einsehen',
    'customers.id': 'ID',
    'customers.name': 'Kunde',
    'customers.email': 'E-Mail',
    'customers.phone': 'Telefonnummer',
    'customers.totalSpentAmount': 'Gesamtausgaben',
    'customers.orderCount': 'Anzahl der Bestellungen',
    'customers.averageCart': 'Durchschnittlicher Warenkorb',
    'customers.lastOrder': 'Letzte Bestellung',
    'customers.frequency': 'Häufigkeit',
    'customers.status': 'Status',
    'customers.ewalletBalance': 'E-Wallet-Kontostand',
    'customers.archivedAt': 'Archiviert am',
    'customers.disabledAt': 'Deaktiviert am',
    'customers.showArchivedCustomers': 'Archivierte Kunden anzeigen',
    'customers.showDisabledCustomers': 'Deaktivierte Kunden anzeigen',
    'customers.options': 'Optionen',
    'customers.domainNames': 'Domain-Namen',
    'customers.selectDomainNames': 'Domain-Namen auswählen',
    'customers.groups': 'Gruppen',
    'customers.selectGroups': 'Gruppen auswählen',
    'menu.name': 'Menüname',
    'menu.categories': 'Kategorien',
    'menu.products': 'Produkte',
    'menu.functions': 'Funktionen',
    'menu.page.title': 'Menüs',
    'menu.page.description': 'Erstellen und verwalten Sie Ihre Menüs',
    'menu.table.associatedChannels': 'Zugehörige Kanäle',
    'menu.action.newMenu': '+ Neues Menü',
    'menu.action.manualImportCrous': 'Crous-Import erzwingen',
    'menu.action.seeOperations': 'Vorgänge anzeigen',
    'menu.action.changeColor': 'Farbe ändern',
    'menu.action.editProduct': 'Produkt bearbeiten',
    'menu.action.editCategory': 'Kategorie bearbeiten',
    'menu.action.editFunction': 'Funktion bearbeiten',
    'menu.action.import': 'Menü importieren',
    'menu.action.noImport': 'Ich möchte keine Datei importieren',
    'menu.modal.manualImportCrous.title': 'Manueller Import des CROUS-Katalogs',
    'menu.modal.manualImportCrous.description':
        'Sind Sie sicher, dass Sie einen manuellen Import des CROUS-Katalogs für dieses Restaurant starten möchten?',
    'menu.action.aiMenuScan': 'KI-Scan (Beta)',
    'menu.modal.aiMenuScan.title': 'Ihr neues Menü digitalisieren (Beta)',
    'menu.modal.aiMenuScan.description.part1': 'Importieren Sie Ihr neues Menü als PDF oder Bild',
    'menu.modal.aiMenuScan.description.part2': "Klicken Sie auf 'Excel-Menü generieren'",
    'menu.modal.aiMenuScan.description.part3':
        'Die Excel-Datei des neuen Menüs mit den verfügbaren Informationen wird automatisch heruntergeladen',
    'menu.modal.aiMenuScan.action.cancel': 'Abbrechen',
    'menu.modal.aiMenuScan.action.generate': 'Excel-Menü generieren',
    'menu.modal.bannersDeactivated':
        '{count, plural, one {# Werbebanner wurde deaktiviert} other {# Werbebanner wurden deaktiviert}}',
    'menu.modal.create.importMenu': 'Menü importieren',
    'menu.modal.create.createMenu': 'Menü erstellen',
    'menu.modal.error.wrongName': 'Bitte geben Sie einen gültigen Namen ein',
    'menu.modal.create.import.excel.tab': 'Excel',
    'menu.modal.create.import.json.tab': 'JSON',
    'menu.modal.create.import.pos.tab': 'Kasse',
    'menu.modal.create.import.excel.title': 'Neues Menü hinzufügen',
    'menu.modal.create.import.excel.description.firstPart': 'Laden Sie die {fileTemplate} auf Ihren Computer herunter',
    'menu.modal.create.import.excel.description.secondPart':
        'Füllen Sie die Vorlage mit den Produktinformationen Ihres neuen Menüs aus',
    'menu.modal.create.import.excel.description.thirdPart':
        'Importieren Sie Ihre neue Datei durch Klicken auf die Schaltfläche unten',
    'menu.modal.create.import.pos.title': 'Vorhandenes Menü importieren',
    'menu.modal.create.import.pos.description.firstPart':
        'Wählen Sie eine Innovorder-Kasse aus, deren Menü Sie importieren möchten',
    'menu.modal.create.import.json.title': 'Vorhandenes Menü importieren',
    'menu.modal.create.import.json.description.firstPart':
        'Stellen Sie sicher, dass Ihre Datei im JSON-Format vorliegt',
    'menu.modal.create.import.json.description.secondPart':
        'Importieren Sie Ihre neue Datei durch Klicken auf die Schaltfläche unten',
    'menu.modal.duplicate.title': 'Menü duplizieren',
    'menu.modal.delete.title': 'Menü löschen',
    'menu.modal.delete.description': 'Sind Sie sicher, dass Sie das Menü „{menuName}" löschen möchten ?',
    'menu.modal.copy.title': 'Menü kopieren',
    'menu.modal.publish.title': 'Menü veröffentlichen',
    'menu.modal.publish.autoPublish': 'Kioske nach der Bestätigung neu laden',
    'menu.modal.publish.devicePublish': 'Menüs auf folgenden POS veröffentlichen:',
    'menu.modal.publish.deliverooPublish': 'Menüs auf folgenden Deliveroo-Marken veröffentlichen:',
    'menu.modal.publish.ubereatsPublish': 'Menüs auf folgenden UberEats-Marken veröffentlichen:',
    'menu.modal.publish.duplicateBarCode':
        '\n- Der Barcode {barCode} ist für folgende Produkte doppelt vorhanden: {products}',
    'menu.modal.error.name': 'Geben Sie einen Namen in das entsprechende Feld ein',
    'menu.modal.error.channels': 'Die Synchronisierungsoption mit den zugehörigen Kassen muss deaktiviert werden',
    'menu.modal.menu.name': 'Menüname',
    'menu.modal.message.defaultIncompatibleDisclaimer':
        'Sie können nur Master- oder unabhängige Kassen mit einer Mindestversion von 7.0 verknüpfen',
    'menu.modal.message.versionIncompatibleDisclaimer':
        'Sie können nur Kassen mit einer Mindestversion von {values} verknüpfen',
    'menu.modal.message.roleIncompatibleDisclaimer': 'Sie können keine {values}-Kassen verknüpfen',
    'menu.modal.channels.shouldSyncPos': 'Synchronisierung mit den Kassen',
    'menu.modal.channels.isSyncFromPosEnabled': 'Menü bei Änderungen von den zugehörigen Kassen aktualisieren',
    'menu.modal.channels.selectActive': 'Menü auf folgenden Kanälen aktivieren',
    'menu.modal.channels.associatedChannels': 'Zugehörige Kanäle',
    'menu.modal.channels.pos.selectActive': 'Kassen auswählen, die dem Menü zugeordnet werden sollen',
    'menu.modal.channels.deliveroo.selectActive': 'Deliveroo-Marken auswählen, die dem Menü zugeordnet werden sollen',
    'menu.modal.channels.ubereats.selectActive': 'UberEats-Marken auswählen, die dem Menü zugeordnet werden sollen',
    'menu.modal.channels.pos.notFound': 'Es wurde keine Kasse gefunden.',
    'menu.modal.channels.associatePos': 'Kassen zuordnen',
    'menu.modal.channels.associateDeliveroo': 'Deliveroo-Marken zuordnen',
    'menu.modal.channels.associateUberEats': 'UberEats-Marken zuordnen',
    'menu.modal.channels.editMenu': 'Menü bearbeiten',
    'menu.modal.channels.createMenu': 'Menü erstellen',
    'menu.modal.channels.selectPos': 'Kassen auswählen',
    'menu.modal.channels.selectDeliveroo': 'Deliveroo-Marken auswählen',
    'menu.modal.channels.selectUberEats': 'UberEats-Marken auswählen',
    'menu.modal.externalId': 'Externer Code',
    'menu.modal.warn.shift.title': 'Gefährliche Aktion',
    'menu.modal.warn.shift.text':
        'Die Bearbeitung eines Menüs während eines laufenden Betriebs kann das Kundenerlebnis an den zugehörigen Kiosken beeinträchtigen.',
    'menu.modal.warn.shift.button': 'OK',
    'menu.importPOS.cancel': 'Nicht jetzt',
    'menu.importPOS.title': 'Import fehlender Kassenmenüs ins Backoffice',
    'menu.importPOS.step1.title': 'Neu: Kassemenüs hier mit einem Klick hinzufügen!',
    'menu.importPOS.step1.bullet.1': 'Einfachere und tiefere Verwaltung des Tastenplans und der Menüs',
    'menu.importPOS.step1.bullet.2':
        'Die Möglichkeit, den Tastenplan im Voraus vorzubereiten und mit einem Klick zu aktivieren',
    'menu.importPOS.step1.bullet.3':
        'Die Möglichkeit, dasselbe Menü für Kasse, Kiosk und Online-Bestellung zu verwenden',
    'menu.importPOS.step1.info':
        'Nur Kassen ab Version 7, die als unabhängig oder Master konfiguriert sind, können ihr Menü im Backoffice hinterlegen',
    'menu.importPOS.step2.pos': 'Im Backoffice importierte Kassen',
    'menu.importPOS.step2.switch': 'Menü bei künftigen Änderungen von der zugehörigen Kasse aktualisieren',
    'menu.importPOS.step3.title': 'Alles erledigt!',
    'menu.importPOS.step3.subtitle': 'Sie können Ihre Kassen jetzt direkt aus dem Backoffice verwalten!',
    'menu.importPOS.step3.link': 'Zur Dokumentation',
    'menu.importPOS.step3.info1': 'Klicken Sie auf das gewünschte Menü, um es anzuzeigen und zu bearbeiten',
    'menu.importPOS.step3.info2':
        'Sie können ein Menü duplizieren, um Ihre nächste Karte vorzubereiten, oder für jedes Menü die zugehörigen Kassen und weiteren Verbrauchsmodi anpassen',
    'menu.importPOS.step3.info3':
        'Solange Sie ein Menü nicht veröffentlichen, bleibt es auf den zugehörigen Kassen unverändert.\n<strong>Sie müssen daher die Aktion „Veröffentlichen" ausführen, damit die im Backoffice vorgenommenen Menüänderungen auf den Kassen aktualisiert werden.</strong>\nDies kann über die Optionen jedes Menüs auf der Menüseite oder über die Seite des Tastenplans erfolgen.',
    'menuoperation.page.title': 'Menü-Vorgänge',
    'menuoperation.page.description': 'Hier finden Sie die Menü-Vorgänge für Ihr Restaurant',
    'menuoperation.type': 'Typ',
    'menuoperation.type.update': 'Aktualisierung',
    'menuoperation.type.publish': 'Veröffentlichung',
    'menuoperation.type.propagation': 'Weitergabe',
    'menuoperation.message.from': 'Von',
    'menuoperation.message.from.brandMenu': 'Vom Markenmenü:',
    'menuoperation.message.to': 'An',
    'menuoperation.errorModal.title': 'Veröffentlichungsbericht',
    'menuoperation.errorModal.message': 'Die Veröffentlichung konnte nicht abgeschlossen werden.',
    'menuoperation.errorModal.checklist.intro': 'Bitte überprüfen Sie folgende Punkte, bevor Sie erneut bestätigen:',
    'menuoperation.errorModal.checklist.requiredFields': 'Alle Pflichtfelder des Produkts sind ausgefüllt',
    'menuoperation.errorModal.checklist.requiredMenuImage': 'Das Menü besitzt ein Bild',
    'menuoperation.errorModal.checklist.noSubCategories': 'Das Menü hat keine Unterkategorien',
    'menuoperation.errorModal.checklist.imageFormats':
        'Die Bilder entsprechen den erforderlichen Formaten (zwischen 320x320px und 6000x6000px)',
    'menuoperation.errorModal.checklist.syncSettings': 'Die Synchronisierungseinstellungen sind korrekt konfiguriert',
    'menuoperation.errorModal.checklist.stepDepthLimit':
        'Das Tiefenlimit der Schritte wird nicht überschritten (maximal 2 Ebenen für Deliveroo).',
    'menuoperation.actions': 'Aktionen',
    'menuoperation.action.download': 'Vorheriges Menü',
    'menuoperation.action.download.before': 'Ausgangsmenü',
    'menuoperation.action.download.after': 'Endmenü',
    'menuoperation.download.error.title': 'Download fehlgeschlagen',
    'menuoperation.download.error':
        'Das archivierte Menü kann nicht heruntergeladen werden. Bitte versuchen Sie es später erneut.',
    'menu.tags.title': 'Tags',
    'menu.tags.table.name': 'Name',
    'menu.tags.create.link': 'Neuen Tag erstellen',
    'menu.tags.create.error.alreadyTaken': 'Dieser Tag existiert bereits',
    'menu.tags.edit.title': 'Tag bearbeiten',
    'menu.tags.create.title': 'Tag erstellen',
    'menu.tags.form.color.label': 'Farbe',
    'menu.tags.delete.confirm': 'Sind Sie sicher, dass Sie {count} Tag(s) löschen möchten?',
    'menu.functions.title': 'Funktionen',
    'menu.functions.subtitle': 'Hinzufügen, Bearbeiten und Zuweisen von Funktionen zu Ihrem Tastenplan',
    'menu.functions.table.name': 'Name',
    'menu.functions.table.type': 'Typ',
    'menu.functions.table.status': 'Status',
    'menu.functions.table.action': 'Aktion',
    'menu.functions.status.active': 'Aktiv',
    'menu.functions.status.inactive': 'Inaktiv',
    'menu.functions.noData': 'Keine Funktion erstellt',
    'menu.functions.delete.confirm': 'Sind Sie sicher, dass Sie {count} Funktion(en) löschen möchten?',
    'menu.steps.title': 'Schritte',
    'menu.steps.add.title': 'Neuer Schritt',
    'menu.steps.duplicate': 'Duplizieren',
    'menu.steps.convert': 'Konvertieren',
    'menu.steps.delete.confirm': 'Sind Sie sicher, dass Sie {count} Schritt(e) löschen möchten?',
    'menu.steps.convert.toCustomization.confirm':
        'Nach der Konvertierung müssen die Details und Optionen Ihres Anpassungsschritts konfiguriert werden. Möchten Sie fortfahren?',
    'menu.steps.convert.toCrossSelling.confirm':
        'Durch die Konvertierung des Schritts werden die Informationen zu Mindest-/Höchstauswahl und aktivierten Optionen nicht übernommen. Möchten Sie fortfahren?',
    'menu.steps.bulkConvertError':
        'Um eine Massenkonvertierung durchführen zu können, müssen alle Schritte vom gleichen Typ sein (Zusatzverkauf oder Anpassung)',
    'menu.steps.column.name': 'Name',
    'menu.steps.column.choices': 'Mögliche Auswahlen',
    'menu.steps.column.min': 'Min',
    'menu.steps.column.max': 'Max',
    'menu.steps.column.stepRef': 'Referenz',
    'menu.steps.column.parentsProducts': 'Anzahl der übergeordneten Produkte',
    'menu.steps.edit.title': 'Schritt bearbeiten',
    'menu.steps.editCustomization.title': 'Anpassungsschritt bearbeiten',
    'menu.steps.editCrossSelling.title': 'Zusatzverkaufsschritt bearbeiten',
    'menu.steps.createCustomization.title': 'Anpassung erstellen',
    'menu.steps.createCrossSelling.title': 'Zusatzverkauf erstellen',
    'menu.steps.convert.title': 'Achtung',
    'menu.steps.column.type': 'Typ',
    'menu.steps.typeName.1': 'Anpassung',
    'menu.steps.typeName.2': 'Zusatzverkauf',
    'menu.steps.form.ticketLabel': 'Bon-Bezeichnung',
    'menu.steps.form.minChoice': 'Mindestauswahl',
    'menu.steps.form.maxChoice': 'Höchstauswahl',
    'menu.steps.form.stepRef': 'Referenz',
    'menu.steps.form.maxChoice.error.greaterThanMin': 'Muss größer als das Minimum sein',
    'menu.steps.form.isDescriptionDisplayEnabled': 'Beschreibungen anzeigen',
    'menu.steps.form.options': 'Optionen',
    'menu.steps.form.isExcessAllowed': 'Überschreitung',
    'menu.steps.form.isGroupEnabled': 'Gruppierung',
    'menu.steps.form.isImageDisplayEnabled': 'Bilder anzeigen',
    'menu.steps.form.isQuantitySelectionEnabled': 'Menge',
    'menu.steps.form.isWeightStrategyEnabled': 'Gewichte verwenden',
    'menu.steps.form.stepProduct': 'Auswahlliste',
    'menu.steps.form.stepProduct.add': 'Auswahl hinzufügen',
    'menu.steps.form.stepProduct.orderByName': 'Nach Name sortieren',
    'menu.steps.form.stepProduct.orderByPrice': 'Nach Preis sortieren',
    'menu.steps.form.stepProduct.setForAllOption': 'Werte übertragen',
    'menu.steps.form.stepProduct.name': 'Name',
    'menu.steps.form.stepProduct.price': 'Preis',
    'menu.steps.form.stepProduct.excessPrice': 'Überschreitungspreis',
    'menu.steps.form.stepProduct.weight': 'Stückgewicht',
    'menu.steps.form.stepProduct.group': 'Gruppe',
    'menu.steps.form.stepProduct.maxQuantity': 'Höchstmenge',
    'menu.steps.form.stepProduct.posIsSelectedByDefault': 'Standardmäßig ausgewählt (POS)',
    'menu.steps.form.stepProduct.posMinProductQuantity': 'Mindestmenge (POS)',
    'menu.steps.form.stepProduct.posDefaultProductQuantity': 'Standardmenge (POS)',
    'menu.steps.form.stepProduct.displayPOSFields': 'POS-Attribute anzeigen',
    'menu.steps.form.stepProduct.import': 'Importieren',
    'menu.steps.form.stepProduct.importWithPrice': 'Mit Preis importieren',
    'menu.steps.form.stepProduct.importWithoutPrice': 'Ohne Preis importieren',
    'menu.steps.propagate.title': 'Schritte weitergeben',
    'menu.categories.title': 'Kategorien',
    'menu.categories.subtitle': 'Kategorien Ihres Menüs bearbeiten',
    'menu.categories.addCategory': 'Kategorie erstellen',
    'menu.categories.noData': 'Keine Kategorie im Menü.',
    'menu.categories.addProduct': 'Produkt hinzufügen',
    'menu.categories.createProduct': 'Produkt erstellen',
    'menu.categories.deleteCategory': 'Löschen',
    'menu.categories.removeProduct': 'Entfernen',
    'menu.categories.deleteCategory.confirm':
        'Sind Sie sicher, dass Sie diese Kategorie löschen möchten?\nSie wird nicht mehr verfügbar sein und ihre untergeordneten Elemente (Produkte und Unterkategorien) werden verwaist.',
    'menu.categories.create.title': 'Kategorie erstellen',
    'menu.categories.edit.title': 'Kategorie bearbeiten',
    'menu.categories.products': '{productCount, plural, =0 {kein Produkt} one {# Produkt} other {# Produkte}}',
    'menu.categories.create.error.alreadyTaken': 'Diese Kategorie existiert bereits',
    'menu.products.title': 'Produkte',
    'menu.products.table.image': 'Bild',
    'menu.products.table.name': 'Name',
    'menu.products.table.categories': 'Kategorien',
    'menu.products.table.price': 'Preis',
    'menu.products.table.vat': 'MwSt.',
    'menu.products.table.sku': 'SKU',
    'menu.products.table.tags': 'Tags',
    'menu.products.reload.kiosk': 'Neu laden',
    'menu.products.create.link': 'Produkt erstellen',
    'menu.products.massEdit': 'Massenbearbeitung',
    'menu.products.duplicate': 'Duplizieren',
    'menu.products.copy': 'Weitergeben',
    'menu.products.copy.title': 'Produkte weitergeben',
    'menu.products.copy.form.restaurants.title': 'Ich wähle meine Zielrestaurants aus',
    'menu.products.copy.form.restaurants.label': 'Ziele',
    'menu.products.copy.form.restaurants.tooltip':
        'Wählen Sie die Restaurants der Marke aus, die die Weitergabe des Produkts und/oder seiner Schritte erhalten sollen.',
    'menu.products.copy.form.restaurants.tooltip.title': 'Ich wähle meine Zielrestaurants aus',
    'menu.products.copy.form.restaurants.tooltip.example':
        'Aus dem Markenmenü entscheiden Sie sich, das Dessert Brownie nur an Restaurants A und B weiterzugeben → nur diese Restaurants erhalten dieses neue Produkt.',
    'menu.products.copy.form.updateIgnoreAttributes.title':
        'Bei der Weitergabe möchte ich folgende Eigenschaften nicht überschreiben:',
    'menu.products.copy.form.updateIgnoreAttributes.tooltip':
        'Bei der Weitergabe eines Produkts der Marke an ein Restaurant, in dem es bereits vorhanden ist (einzeln oder über einen Schritt), können Sie bestimmte Eigenschaften dieses Einzelprodukts beibehalten: Tag, übergeordnete Kategorie, Bild, Preis, MwSt., Name und Beschreibung.',
    'menu.products.copy.form.updateIgnoreAttributes.tooltip.title':
        'Bestimmte Eigenschaften bei der Weitergabe eines bereits vorhandenen Produkts beibehalten',
    'menu.products.copy.form.updateIgnoreAttributes.tooltip.example':
        'Das Einzelprodukt Cookie existiert bereits im Restaurant mit einem individuellen Bild und einem spezifischen Preis → Wenn Sie „Bild" und „Preis" ankreuzen, werden diese Werte beibehalten, auch nach der Weitergabe von der Marke.\n\n👉 Für neue Produkte werden alle Eigenschaften der Marke automatisch weitergegeben.',
    'menu.products.copy.form.updateIgnoreAttributes.subtitle.products':
        'Produkte, die bereits in den Zielrestaurantmenüs vorhanden sind',
    'menu.products.copy.form.updateIgnoreAttributes.subtitle.steps':
        'Schritte, die bereits in den Zielrestaurantmenüs vorhanden sind',
    'menu.products.copy.form.updateIgnoreAttributes.steps.tooltip.title':
        'Bestimmte Eigenschaften bei der Weitergabe eines bereits vorhandenen Schritts beibehalten',
    'menu.products.copy.form.updateIgnoreAttributes.steps.tooltip.description':
        'Bei der Weitergabe eines Schritts der Marke an ein Restaurant, in dem er bereits vorhanden ist, können Sie bestimmte Eigenschaften dieses Schritts beibehalten: Produktpreis im Schritt, Höchstmenge pro Produkt (wenn die Option „Menge" aktiviert ist) und Überschreitungspreis.',
    'menu.products.copy.form.updateIgnoreAttributes.steps.tooltip.example':
        'Im Restaurant hat der Schritt „Dessert wählen" einen Cookie für 2 € mit einer Höchstmenge von 3.\nDie Marke gibt im Schritt einen Cookie für 1 € mit einer Höchstmenge von 1 weiter.\n→ Wenn Sie „Produktpreis" und „Höchstmenge" beibehalten, behält das Restaurant Cookie für 2 € und Höchstmenge 3.\n\n👉 Für neue Schritte werden alle Eigenschaften der Marke automatisch weitergegeben.',
    'menu.products.copy.form.updateIgnoreAttributes.placeholder':
        'Bei der Weitergabe möchte ich folgende Eigenschaften nicht überschreiben',
    'menu.products.copy.form.attribute.price': 'Preis',
    'menu.products.copy.form.attribute.vat': 'MwSt.',
    'menu.products.copy.form.attribute.name': 'Name',
    'menu.products.copy.form.attribute.description': 'Beschreibung',
    'menu.products.copy.form.attribute.categories': 'Übergeordnete Kategorien',
    'menu.products.copy.form.attribute.tags': 'Tags',
    'menu.products.copy.form.attribute.imageId': 'Bild',
    'menu.products.copy.form.attribute.exceedPrice': 'Überschreitungspreis',
    'menu.products.copy.form.attribute.maxProductQuantity': 'Höchstmenge',
    'menu.products.copy.form.publishAfterCopy.title': 'Bei der Weitergabe möchte ich:',
    'menu.products.copy.form.publishAfterCopy.tooltip': 'Menüs automatisch auf den zugehörigen Kassen veröffentlichen',
    'menu.products.copy.form.publishAfterCopy.tooltip.title': 'Automatische Veröffentlichung',
    'menu.products.copy.form.publishAfterCopy.tooltip.example':
        'Wenn aktiviert, werden die Menüs automatisch auf allen Kassen veröffentlicht, die den Zielrestaurants zugeordnet sind.',
    'menu.products.copy.form.publishAfterCopy': 'Menüs automatisch auf den zugehörigen Kassen veröffentlichen',
    'menu.products.copy.form.publishAfterCopy.disclaimer':
        '⚠️ Achtung, die neu weitergegebenen Produkte müssen dem Tastenplan noch hinzugefügt werden',
    'menu.products.copy.form.strategy.title': 'Weitergabestrategie für bereits in den Zielmenüs vorhandene Schritte',
    'menu.products.copy.form.strategy.tooltip':
        'Die im Restaurant bereits vorhandenen Schritte werden durch die im Markenmenü konfigurierten ersetzt (einschließlich Produkte und Preise).',
    'menu.products.copy.form.strategy.tooltip.title': 'Strategie: Vorhandene Schritte aktualisieren',
    'menu.products.copy.form.strategy.tooltip.example':
        'Restaurant A hat den Schritt „Dessert wählen" mit Pain perdu, Früchte, Cookie (2 €).\nDie Marke gibt weiter: Cookie (1 €), Brownie (2 €) → Restaurant A hat nun Cookie (1 €), Brownie (2 €).\n\n👉 Das Einzelprodukt Cookie wird aktualisiert, das Einzelprodukt Brownie wird erstellt und Pain perdu wird aus dem Schritt entfernt.',
    'menu.products.copy.form.strategy.replace':
        'Vorhandene Schritte im/in den Restaurantmenü(s) durch die weitergegebenen Schritte des Markenmenüs ersetzen',
    'menu.products.copy.form.strategy.replace.tooltip.title': 'Strategie: Vorhandene Schritte aktualisieren',
    'menu.products.copy.form.strategy.replace.tooltip.description':
        'Die im Restaurant bereits vorhandenen Schritte werden durch die im Markenmenü konfigurierten ersetzt (einschließlich Produkte und Preise).',
    'menu.products.copy.form.strategy.replace.tooltip.example':
        'Restaurant A hat den Schritt „Dessert wählen" mit Pain perdu, Früchte, Cookie (2 €).\nDie Marke gibt weiter: Cookie (1 €), Brownie (2 €) → Restaurant A hat nun Cookie (1 €), Brownie (2 €).\n\n👉 Das Einzelprodukt Cookie wird aktualisiert, das Einzelprodukt Brownie wird erstellt und Pain perdu wird aus dem Schritt entfernt.',
    'menu.products.copy.form.strategy.update_and_keep_existing':
        'Vorhandene Schritte im/in den Restaurantmenü(s) aktualisieren und bestehende Produkte beibehalten, die nicht im Schritt des Markenmenüs vorhanden sind',
    'menu.products.copy.form.strategy.update_and_keep_existing.tooltip.title':
        'Strategie: Aktualisieren und vorhandene Produkte beibehalten',
    'menu.products.copy.form.strategy.update_and_keep_existing.tooltip.description':
        'Die Schritte des Restaurants werden mit denen der Marke aktualisiert, aber bereits vorhandene Produkte, die im Markenmenü fehlen, werden beibehalten.',
    'menu.products.copy.form.strategy.update_and_keep_existing.tooltip.example':
        'Restaurant A hat den Schritt „Dessert wählen" mit Pain perdu (1 €), Früchte (2 €), Cookie (2 €).\nDie Marke gibt weiter: Cookie (1 €), Brownie (2 €) → Restaurant A hat nun Pain perdu (1 €), Früchte (2 €), Cookie (1 €), Brownie (2 €).\n\n👉 Das Einzelprodukt Cookie wird aktualisiert, das Einzelprodukt Brownie wird erstellt und Pain perdu bleibt im Schritt erhalten.',
    'menu.products.copy.form.strategy.keep_existing': 'Bereits in den Zielmenüs vorhandene Schritte nicht ändern',
    'menu.products.copy.form.strategy.keep_existing.tooltip.title': 'Strategie: Vorhandene Schritte nicht ändern',
    'menu.products.copy.form.strategy.keep_existing.tooltip.description':
        'Die im Restaurant bereits vorhandenen Schritte werden bei der Weitergabe nicht geändert.',
    'menu.products.copy.form.strategy.keep_existing.tooltip.example':
        'Restaurant A hat den Schritt „Dessert wählen" mit Pain perdu (1 €), Früchte (2 €), Cookie (2 €).\nDie Marke gibt weiter: Cookie (1 €), Brownie (2 €) → Restaurant A behält Pain perdu (1 €), Früchte (2 €), Cookie (2 €).\n\n👉 Das Einzelprodukt Cookie wird aktualisiert und das Einzelprodukt Brownie wird erstellt.',
    'menu.products.copy.form.channel.title': 'Ich wähle meine Zielkanäle aus',
    'menu.products.copy.form.channel.tooltip':
        'Wählen Sie die Kanäle (z. B. Kasse, Online-Bestellung (CEL), Kiosk) aus, auf die die Weitergabe des Produkts und/oder seiner Schritte angewendet werden soll.',
    'menu.products.copy.form.channel.tooltip.title': 'Ich wähle meine Zielkanäle aus',
    'menu.products.copy.form.channel.tooltip.example':
        'Sie geben das Dessert Brownie weiter, wählen aber nur Kiosk → das Produkt ist nur in den Kiosk-Menüs der ausgewählten Restaurants sichtbar.',
    'menu.products.copy.form.channel.web': 'Online- oder Tischbestellung',
    'menu.products.copy.form.channel.kiosk': 'Kiosk',
    'menu.products.copy.form.channel.pos': 'Kassen',
    'menu.products.copy.form.channel.marketplace': 'Marketplace (UberEats/Deliveroo)',
    'menu.products.copy.form.channel.null': 'Nicht zugeordnet',
    'menu.products.copy.form.other.strategies.title': 'Erstellung neuer Produkte',
    'menu.products.copy.form.other.strategies.tooltip':
        'Bei der Weitergabe neuer Produkte gibt die Marke im Schritt einen Cookie für 2 € mit einer Höchstmenge von 3 weiter. Wenn Sie „Produktpreis" und „Höchstmenge" beibehalten, behält das Restaurant Cookie für 2 € und Höchstmenge 3. → Wenn Sie „Produktpreis" und „Höchstmenge" beibehalten, behält das Restaurant Cookie für 2 € und Höchstmenge 3.',
    'menu.products.copy.form.other.strategies.tooltip.title': 'Erstellung neuer Produkte',
    'menu.products.copy.form.other.strategies.tooltip.example':
        'Bei der Weitergabe neuer Produkte gibt die Marke im Schritt einen Cookie für 2 € mit einer Höchstmenge von 3 weiter. Wenn Sie „Produktpreis" und „Höchstmenge" beibehalten, behält das Restaurant Cookie für 2 € und Höchstmenge 3.\n→ Wenn Sie „Produktpreis" und „Höchstmenge" beibehalten, behält das Restaurant Cookie für 2 € und Höchstmenge 3.',
    'menu.products.copy.form.other.strategies.tags': 'Fehlende Produkt-Tags spontan erstellen',
    'menu.products.copy.form.other.strategies.categories': 'Fehlende Produktkategorien spontan erstellen',
    'menu.products.copy.form.posMenus.title': 'Aktive Kassenmenüs',
    'menu.products.copy.form.posMenus.description':
        'Diese Tabelle zeigt nur Restaurants an, bei denen mehrere Kassenmenüs aktiv sind. Wenn nur ein Kassenmenü aktiv ist, erfolgt die Weitergabe standardmäßig auf dieses Menü.',
    'menu.products.copy.form.posMenus.tooltip':
        'Wählen Sie die Kassenmenüs aus, auf die Sie die Produkte für jedes Restaurant weitergeben möchten.',
    'menu.products.copy.form.posMenus.tooltip.title': 'Auswahl der Kassenmenüs',
    'menu.products.copy.form.posMenus.tooltip.example':
        'Wenn ein Restaurant mehrere Kassenmenüs hat, können Sie wählen, auf eines oder mehrere bestimmte Menüs weiterzugeben.',
    'menu.products.copy.form.posMenus.column.restaurant': 'Restaurantname',
    'menu.products.copy.form.posMenus.column.menus': 'Aktive(s) Menü(s)',
    'menu.products.copy.form.posMenus.empty': 'Keine Kassenmenüs für die ausgewählten Restaurants verfügbar',
    'menu.products.copy.form.posMenus.placeholder': 'Menüs auswählen...',
    'menu.products.copy.form.posMenus.warning':
        '⚠️ Achtung, standardmäßig sind alle aktiven Menüs eines Restaurants für die Produktweitergabe ausgewählt.',
    'menu.products.copy.form.marketplaceMenus.title': 'Aktive Marketplace-Menüs',
    'menu.products.copy.form.marketplaceMenus.description':
        'Diese Tabelle zeigt nur Restaurants an, bei denen mehrere Marketplace-Menüs aktiv sind. Wenn nur ein Marketplace-Menü aktiv ist, erfolgt die Weitergabe standardmäßig auf dieses Menü.',
    'menu.products.copy.form.marketplaceMenus.tooltip':
        'Wählen Sie die Marketplace-Menüs aus, auf die Sie die Produkte für jedes Restaurant weitergeben möchten.',
    'menu.products.copy.form.marketplaceMenus.tooltip.title': 'Auswahl der Marketplace-Menüs',
    'menu.products.copy.form.marketplaceMenus.tooltip.example':
        'Wenn ein Restaurant mehrere Marketplace-Menüs hat, können Sie wählen, auf eines oder mehrere bestimmte Menüs weiterzugeben.',
    'menu.products.copy.form.marketplaceMenus.column.restaurant': 'Restaurantname',
    'menu.products.copy.form.marketplaceMenus.column.menus': 'Aktive(s) Menü(s)',
    'menu.products.copy.form.marketplaceMenus.empty':
        'Keine Marketplace-Menüs für die ausgewählten Restaurants verfügbar',
    'menu.products.copy.form.marketplaceMenus.placeholder': 'Menüs auswählen...',
    'menu.products.copy.form.marketplaceMenus.warning':
        '⚠️ Achtung, standardmäßig sind alle aktiven Menüs eines Restaurants für die Produktweitergabe ausgewählt.',
    'menu.products.copy.form.publishAfterCopy.marketplace.title': 'Bei der Weitergabe möchte ich:',
    'menu.products.copy.form.publishAfterCopy.marketplace':
        'Menüs automatisch auf den zugehörigen Marketplaces veröffentlichen',
    'menu.products.copy.form.publishAfterCopy.marketplace.disclaimer':
        'Die Menüs werden auf den Marketplaces der zugehörigen Restaurants veröffentlicht.',
    'menu.products.copy.form.disclaimer':
        '⚠️ Achtung, dieses/diese Produkt(e) wird/werden auf alle ausgewählten Restaurants in allen ihren Menüs kopiert. Überprüfen Sie vor dem Speichern Name, Beschreibung, Bild, MwSt. und Preis.',
    'menu.copy.validate.title': 'Überprüfung der weiterzugebenden Produkte / Schritte',
    'menu.copy.validate.success':
        'Alle weiterzugebenden Produkte/Schritte haben eine konfigurierte SKU / Schrittreferenz',
    'menu.copy.validate.warning': 'SKU nicht in der Produktdatei des Markenmenüs eingetragen',
    'menu.copy.validate.error': 'SKU doppelt vorhanden oder Schrittreferenz nicht im Markenmenü eingetragen',
    'menu.copy.validate.step.missing.identifier.detail': 'Schrittreferenz beim Schritt nicht eingetragen',
    'menu.copy.validate.product.missing.identifier.detail': 'SKU beim Produkt nicht eingetragen',
    'menu.copy.validate.step.duplicate.identifier.detail':
        'Konflikt bei der Referenz <b>{identifier}</b> zwischen den Schritten',
    'menu.copy.validate.product.duplicate.identifier.detail':
        'Konflikt beim SKU <b>{identifier}</b> zwischen den Produkten',
    'menu.products.overwrite': 'Kontrollkästchen links aktivieren, um Felder zu bearbeiten',
    'menu.products.overwriteRelations':
        'Kontrollkästchen links aktivieren, um alles zu ersetzen, anstatt Elemente hinzuzufügen',
    'menu.products.error.alreadyTaken': 'Dieses Produkt existiert bereits',
    'menu.products.error.billingCodeRequired': 'Die automatische Abrechnung erfordert das Ausfüllen dieses Felds',
    'menu.products.add.title': 'Produkt hinzufügen',
    'menu.products.edit.title': 'Produkt bearbeiten',
    'menu.products.propagate.title': 'Produkte weitergeben',
    'menu.products.create.title': 'Produkt erstellen',
    'menu.products.delete.confirm': 'Sind Sie sicher, dass Sie {count} Produkt(e) löschen möchten?',
    'menu.products.form.price': 'Preis inkl. MwSt.',
    'menu.product.form.pricePerkg': 'Preis inkl. MwSt. / kg',
    'menu.products.form.priceType': 'Preistyp',
    'menu.products.form.priceType.placeholder': 'Preistyp',
    'menu.products.form.priceType.fixed': 'Festpreis',
    'menu.products.form.priceType.customizablePrice': 'Produkt mit freiem Preis',
    'menu.products.form.priceType.customizablePriceAndLabel': 'Produkt mit freiem Preis und Bezeichnung',
    'menu.products.form.measurementUnit': 'Gemessen in',
    'menu.products.form.measurementUnit.placeholder': 'Gemessen in',
    'menu.products.form.measurementUnit.unit': 'Einheit',
    'menu.products.form.measurementUnit.kg': 'kg',
    'menu.products.form.kg.channelRestriction': 'Produkte in kg sind am Kiosk-Kanal nicht verfügbar.',
    'menu.products.form.availability': 'Verfügbarkeit nach Kanal',
    'menu.products.form.webAvailability': 'Web',
    'menu.products.form.kioskAvailability': 'Kiosk',
    'menu.products.form.servingCount': 'Anzahl der Gedecke',
    'menu.products.form.barCode': 'Barcode',
    'menu.products.form.ticketLabel': 'Produktionsbezeichnung',
    'menu.products.form.ticketLabel.checkbox': 'Eine andere Produktionsbezeichnung als den Produktnamen verwenden',
    'menu.products.form.noVat': 'Produkt ohne MwSt.',
    'menu.products.form.vat': 'Standard-MwSt.',
    'product.vatGroup': 'MwSt.-Gruppe',
    'product.vatGroup.withHint': 'MwSt.-Gruppe (vor Ort / zum Mitnehmen / Lieferung)',
    'product.selectVatGroup': 'MwSt.-Gruppe auswählen',
    'product.vatGroup.noOperationZone': 'Keine Betriebszone für dieses Restaurant konfiguriert',
    'product.vatGroup.eatIn': 'Vor Ort',
    'product.vatGroup.takeAway': 'Zum Mitnehmen',
    'product.vatGroup.delivery': 'Lieferung',
    'product.vatGroup.hint':
        'Um die MwSt. nach Verbrauchsmodus zu ändern, bearbeiten Sie bitte das Feld „MwSt.-Gruppe (vor Ort / zum Mitnehmen / Lieferung)"',
    'menu.products.form.image.placeholder': 'Bild',
    'menu.products.form.externalId': 'Externer Code',
    'menu.products.form.sku': 'SKU',
    'menu.products.form.sku.placeholder': 'SKU auswählen',
    'menu.products.form.sku.noOption': 'Eine neue SKU kann nur auf Markenebene erstellt werden',
    'menu.products.form.createSku': 'SKU „{value}" erstellen',
    'menu.products.form.replaceSkuAll':
        'SKU „{currentSku}" durch „{value}" ersetzen (für alle Produkte mit derselben SKU)',
    'menu.products.form.replaceSkuThisProduct': 'SKU „{currentSku}" durch „{value}" ersetzen (nur für dieses Produkt)',
    'menu.products.form.createTag': 'Tag „{value}" erstellen',
    'menu.products.form.billingCode': 'Rechnungscode',
    'menu.products.form.purchasePrice': 'Vertragspreis',
    'menu.products.form.description': 'Beschreibung',
    'menu.products.form.description.tooLong': 'Die Beschreibung darf 1500 Zeichen nicht überschreiten',
    'menu.products.form.additionalInformation': 'Zusätzliche Informationen',
    'menu.products.form.section.options': 'Optionen',
    'menu.products.form.section.quantity': 'Lagerverwaltung',
    'menu.products.form.section.externalData': 'Externe Daten',
    'menu.products.form.currentQuantitySwitch': 'Lagerverwaltung für das Produkt aktivieren',
    'menu.products.form.defaultQuantitySwitch': 'Tägliche Lagerbestandsrücksetzung',
    'menu.products.form.currentQuantityInput': 'Bestand',
    'menu.products.form.defaultQuantityInput': 'Bestand zu Tagesbeginn',
    'menu.products.form.defaultQuantityHint':
        'Jeden Tag zwischen 4 und 5 Uhr morgens wird der Bestand auf den Standardwert zurückgesetzt',
    'menu.products.form.isEligibleLuncheon': 'Berechtigt für Essensmarken',
    'menu.products.form.isFinalProduct': 'Endprodukt',
    'menu.products.form.subsidizable': 'Subventionierbares Produkt',
    'menu.products.form.admissible': 'Zulässiges Produkt',
    'menu.products.form.shouldMultiplyEntranceFeesAndGrants':
        'Zulassung/Subvention wird bei jedem Hinzufügen zum Warenkorb multipliziert',
    'menu.products.form.shouldMultiplyEntranceFeesAndGrants.tooltip':
        'Wenn diese Option aktiviert ist, werden die Zulassungen (und Subventionen) in der Bestellung multipliziert, wenn das Produkt mehrfach in den Warenkorb gelegt wird oder wenn ein anderes Produkt mit derselben Option in den Warenkorb gelegt wird. Die Multiplikation erfolgt innerhalb des Tageslimits und der im Tarif festgelegten Obergrenze.',
    'menu.products.form.excludedFromUrssaf': 'Nicht im URSSAF-Minimum zählen',
    'menu.products.form.section.pos': 'Kassenspezifische Attribute',
    'menu.products.form.minQuantity': 'Mindestmenge',
    'menu.products.form.alwaysAskForCustomization': 'Immer nach Schritten fragen',
    'menu.products.form.discountable': 'Rabatte auf das Produkt erlauben',
    'menu.products.form.isDeposit': 'Pfandprodukt',
    'menu.products.form.posPrice': 'Pfandbetrag',
    'menu.products.form.vatSitIn': 'MwSt. vor Ort',
    'menu.products.form.vatDelivery': 'MwSt. Lieferung',
    'menu.products.form.vatTakeAway': 'MwSt. zum Mitnehmen',
    'menu.products.form.section.kitchenOptions': 'Optionen für den Küchenbildschirm',
    'menu.products.form.isMenu': 'Ist ein Menü',
    'menu.products.form.is_customization': 'Ist eine Anpassung',
    'menu.products.form.isProducible': 'In der Zusammenfassung anzeigen',
    'menu.products.form.no_kitchen': 'Nicht auf dem Küchenbildschirm anzeigen',
    'menu.products.form.section.consumptionMode': 'Produktverfügbarkeit nach Verbrauchsmodus',
    'menu.products.form.consumptionModeType.mode_sit_in': 'Vor Ort',
    'menu.products.form.consumptionModeType.mode_delivery': 'Lieferung',
    'menu.products.form.consumptionModeType.mode_take_away': 'Zum Mitnehmen',
    'menu.products.form.consumptionModeType.mode_drive': 'Drive',
    'menu.products.form.tags': 'Tags',
    'menu.products.form.tags.placeholder': 'Tags suchen und zuordnen',
    'menu.products.form.steps': 'Schritte',
    'menu.products.form.steps.page': 'Seite {pageNumber}',
    'menu.products.form.steps.addToNewPage': 'Zu einer neuen Seite hinzufügen',
    'menu.products.form.steps.addEachToNewPage': 'Jeden Schritt zu einer neuen Seite hinzufügen',
    'menu.products.form.steps.addToPage': 'Seite, zu der der Schritt hinzugefügt werden soll',
    'menu.products.form.steps.addEmptyPage': 'Seite hinzufügen',
    'menu.products.form.categories': 'Übergeordnete Kategorien',
    'menu.products.form.productType': 'Typ',
    'menu.products.form.productType.placeholder': 'Produkttyp',
    'menu.products.form.productType.product': 'Produkt',
    'menu.products.form.productType.deposit': 'Pfand',
    'menu.products.form.categories.placeholder': 'Übergeordnete Kategorien suchen',
    'menu.products.form.externalReference': 'Externe Referenz',
    'menu.products.form.externalReference.placeholder': 'Referenzname',
    'menu.products.form.externalReference.name': 'Name',
    'menu.products.form.externalReference.value': 'Wert',
    'menu.products.form.machineCode': 'Nayax-Maschinencode des Produkts',
    'menu.products.form.steps.add': 'Schritt hinzufügen',
    'menu.products.form.steps.addPage': 'Schritt hierher ziehen, um eine neue Seite zu erstellen',
    'menu.products.form.steps.column.name': 'Name',
    'menu.products.form.steps.column.type': 'Typ',
    'menu.products.form.steps.column.choices': 'Mögliche Auswahlen',
    'menu.products.form.steps.column.position': 'Seite',
    'menu.products.form.steps.column.subPosition': 'Position',
    'menu.products.form.steps.column.min': 'Min',
    'menu.products.form.steps.column.max': 'Max',
    'menu.products.form.steps.column.parentsProducts': 'Anzahl der übergeordneten Produkte',
    'menu.products.form.steps.cross-selling.add': 'Zusatzverkauf hinzufügen',
    'menu.products.form.steps.customization.add': 'Anpassung hinzufügen',
    'menu.products.form.steps.type.cross-selling': 'Zusatzverkauf',
    'menu.products.form.steps.type.customization': 'Anpassung',
    'reportGenerationsHistory.title': 'Generierungsverlauf',
    'reportGenerationsHistory.subtitle': 'Hier finden Sie den Verlauf Ihrer Export-Generierungen.',
    'reportGenerationsHistory.tableCard.title': 'Exporte',
    'reportGenerationsHistory.tableCard.subtitle': 'Liste der Exporte',
    'reportGenerationsHistory.tableCard.actionLabel': 'Seite aktualisieren',
    'reportGenerationsHistory.emptyMessage': 'Ihr Generierungsverlauf ist leer',
    'reportGenerationsHistory.tableHeader.createdAt': 'Datum',
    'reportGenerationsHistory.tableHeader.fileName': 'Dateiname',
    'reportGenerationsHistory.tableHeader.reportType': 'Status',
    'reportGenerationsHistory.tableHeader.status': 'Fortschritt',
    'reportGenerationsHistory.tableHeader.action': 'Herunterladen',
    'reportGenerationsHistory.tableRow.reportType.pre_invoicing': 'Vorrechnungslegung',
    'reportGenerationsHistory.tableRow.reportType.orders': 'Bestellungen',
    'reportGenerationsHistory.tableRow.reportType.badge_balance': 'Badge-Bewegungen',
    'reportGenerationsHistory.tableRow.reportType.sales_summary': 'Finanzübersicht',
    'reportGenerationsHistory.tableRow.reportType.collective_catering_sales_summary':
        'Finanzübersicht nach Verwaltungsmodus',
    'reportGenerationsHistory.tableRow.reportType.ewallet_stats_by_users': 'Badge-Guthaben nach Kunde',
    'reportGenerationsHistory.tableRow.reportType.collective_catering_sales_summary_exclude_tax':
        'Finanzübersicht nach Verwaltungsmodus (netto)',
    'reportGenerationsHistory.tableRow.reportType.ewallet': 'E-Wallet',
    'reportGenerationsHistory.tableRow.reportType.accounting': 'Buchhaltung',
    'reportGenerationsHistory.tableRow.reportType.monthly_sales_report': 'Monatlicher Verkaufsbericht',
    'reportGenerationsHistory.tableRow.generationStatus.succeed': 'Abgeschlossen',
    'reportGenerationsHistory.tableRow.generationStatus.in_progress': 'In Bearbeitung',
    'reportGenerationsHistory.tableRow.generationStatus.failed': 'Fehlgeschlagen',
    'reportGenerationsHistory.tableRow.action.download': 'Herunterladen',
    'report.emptyMessage': 'Kein Ergebnis',
    'report.title.monthly_sales_report': 'Monatlicher Verkaufsbericht',
    'report.selectDateRangeButton.text': 'Vom {startDate} bis {endDate}',
    'report.calendarModal.dateRage.errorMessage': 'Sie können nicht mehr als {maxRangeInDays} Tage auswählen',
    'report.calendarModal.title': 'Zeitraum auswählen',
    'report.calendarModal.submit': 'Bestätigen',
    'report.filtersButton.text': 'Filter',
    'report.filtersModal.title': 'Filter auswählen',
    'report.filtersModal.submit': 'Filtern',
    'report.filtersModal.form.restaurantLabel': 'Restaurants',
    'report.filtersModal.form.devicesLabel': 'Kassen',
    'report.filtersModal.form.sourcesLabel': 'Bestellkanäle',
    'report.filtersModal.form.tagsLabel': 'Tags',
    'report.filtersModal.form.consumptionModesLabel': 'Verbrauchsmodi',
    'report.filtersModal.form.sellersLabel': 'Verkäufer',
    'report.filtersModal.form.vatsLabel': 'MwSt.',
    'report.filtersModal.form.categoriesLabel': 'Kategorien',
    'report.filtersModal.form.loyaltyLabel': 'Nur mit Treuepunkten bezahlte Bestellungen anzeigen',
    'report.filtersModal.form.only_parentsLabel': 'Übergeordnete Kategorien anzeigen',
    'report.filtersModal.saveAs.placeholder': 'Speichern unter ...',
    'report.filtersModal.saveAs.save': 'Speichern und Anwenden',
    'report.exportButton.text': 'Exportieren',
    'report.exportResultModal.title': 'CSV-Export',
    'report.exportResultModal.resultSuccess': 'Die Export-Generierung läuft',
    'report.exportResultModal.stayInPage': 'Auf dieser Seite bleiben',
    'report.exportResultModal.redirectToGenerationHistory': 'Laufende Exporte anzeigen',
    'report.exportResultModal.resultFail': 'A problem has occurred, please try again in a few moments',
    'report.savedFiltersDropdown.placeholder': 'Gespeicherte Filter',
    'report.savedFiltersDropdown.deleteModal.title': 'Achtung',
    'report.savedFiltersDropdown.deleteModal.description': 'Sind Sie sicher, dass Sie löschen möchten?',
    'salesSummary.tableCard.title': 'Neuen Export generieren',
    'salesSummary.tableCard.subtitle': 'Wählen Sie Ihre Kriterien und Filter aus und klicken Sie auf „Generieren".',
    'salesSummary.form.choosePeriod': 'Zeitraum auswählen',
    'salesSummary.form.reportType': 'Berichtsformat',
    'salesSummary.form.reportType.collectiveCateringSalesSummary': 'Finanzübersicht nach Verwaltungsmodus',
    'salesSummary.form.reportType.collectiveCateringSalesSummaryExclTax':
        'Finanzübersicht nach Verwaltungsmodus (netto)',
    'salesSummary.form.reportType.salesSummary': 'Finanzübersicht',
    'salesSummary.form.restaurants': 'Restaurants',
    'salesSummary.form.groups': 'Gruppen',
    'salesSummary.form.pricingRules': 'Tarifmodell',
    'salesSummary.form.accountedOrders': 'Verbuchte Bestellungen',
    'salesSummary.form.accountedOrders.all': 'Bestellungen + Gegenbuchungen',
    'salesSummary.form.accountedOrders.ordersOnly': 'Bestellungen',
    'salesSummary.form.accountedOrders.contraEntriesOnly': 'Gegenbuchungen',
    'salesSummary.exportResultModal.title': 'Export-Generierung',
    'shift.default': 'Standard',
    'shift.allDays': 'Alle Tage',
    'shift.period': 'Vom {start} bis {end}',
    'shift.days.MON': 'Montag',
    'shift.days.TUE': 'Dienstag',
    'shift.days.WED': 'Mittwoch',
    'shift.days.THU': 'Donnerstag',
    'shift.days.FRI': 'Freitag',
    'shift.days.SAT': 'Samstag',
    'shift.days.SUN': 'Sonntag',
    'shift.amount.required': 'Der Betrag ist erforderlich',
    'shift.amount.positive': 'Der Betrag muss positiv sein',
    'shift.threshold.positive': 'Der Schwellenwert muss positiv sein',
    'shift.ceiling.required': 'Erforderlich für eine prozentuale Subvention',
    'shift.vat.required': 'Die MwSt. ist erforderlich',
    'shift.vat.positive': 'Die MwSt. muss positiv sein',
    'brandHistory.tableCard.title': 'Verlauf',
    'brandHistory.tableCard.subtitle': 'Suchen Sie nach Aktionen, die an der Marke durchgeführt wurden',
    'brandHistory.emptyMessage': 'Kein Verlauf gefunden',
    'brandHistory.searchPlaceholder': 'Im Verlauf suchen',
    'brandHistory.entityType': 'Entitätstyp',
    'brandHistory.entityType.GRANT': 'Subvention',
    'brandHistory.entityType.ENTRANCE_FEE': 'Zulassung',
    'brandHistory.entityType.PRICING_RULE': 'Tarifmodell',
    'brandHistory.entityType.PRODUCT': 'Produkt',
    'brandHistory.entityType.STEP': 'Schritt',
    'brandHistory.entityType.CATEGORY': 'Kategorie',
    'brandHistory.entityType.MENU': 'Menü',
    'brandHistory.entityType.MODULE': 'Modul',
    'brandHistory.entityType.CUSTOMER': 'Kunde',
    'brandHistory.entityType.CUSTOMERS_IMPORT': 'Kundenimport',
    'brandHistory.entityType.CUSTOMERS_UPDATE': 'Kundenänderung',
    'brandHistory.entityType.USER': 'Benutzer',
    'brandHistory.entityType.CHANNEL': 'Kanal',
    'brandHistory.entityType.CONSUMPTION_MODE': 'Verbrauchsmodus',
    'brandHistory.entityType.ORDER': 'Bestellung',
    'brandHistory.entityType.BRAND': 'Marke',
    'brandHistory.entityType.RESTAURANT': 'Restaurant',
    'brandHistory.entityName': 'Entitätsname',
    'brandHistory.restaurant': 'Restaurant',
    'brandHistory.user': 'Benutzer',
    'brandHistory.action': 'Aktion',
    'brandHistory.eventDate': 'Datum',
    'brandHistory.action.create': 'Erstellung',
    'brandHistory.action.open': 'Öffnung',
    'brandHistory.action.activate': 'Aktivierung',
    'brandHistory.action.duplicate': 'Duplizierung',
    'brandHistory.action.delete': 'Löschung',
    'brandHistory.action.close': 'Schließung',
    'brandHistory.action.deactivate': 'Deaktivierung',
    'brandHistory.action.cancel': 'Stornierung',
    'brandHistory.action.update': 'Änderung',
    'brandHistory.action.import': 'Import',
    'brandHistory.action.unknown': 'Unbekannt',
    'brandHistory.modal.title': 'Bericht der durchgeführten Aktionen',
    'brandHistory.modal.actions': 'Aktionsbericht',
    'brandHistory.modal.logs': 'Protokollbericht',
    'brandHistory.modal.informations': 'Zugehörige Informationen',
    'brandHistory.modal.entityName': 'Entitätsname',
    'brandHistory.modal.user': 'Benutzer: ',
    'brandHistory.modal.date': 'Änderungsdatum: ',
    'brandHistory.modal.close': 'Schließen',
    'brandHistory.modal.empty': 'Hier ist nichts zu finden 😰',
    'crossSelling.name': 'Name der Cross-Selling-Seite',
    'crossSelling.page.title': 'Cross-Selling',
    'crossSelling.page.description': 'Erstellen und verwalten Sie Ihre Cross-Selling-Seiten',
    'crossSelling.action.newCrossSelling': '+ Neue Cross-Selling-Seite',
    'crossSelling.modal.duplicate.title': 'Cross-Selling-Seite duplizieren',
    'crossSelling.modal.create.title': 'Ihre Cross-Selling-Seite erstellen',
    'crossSelling.modal.delete.title': 'Cross-Selling-Seite löschen',
    'crossSelling.modal.delete.description':
        'Sind Sie sicher, dass Sie die Seite „{crossSellingName}" löschen möchten ?',
    'crossSelling.modal.error.name': 'Geben Sie einen Namen in das entsprechende Feld ein',
    'crossSelling.modal.menu.name': 'Name der Cross-Selling-Seite',
    'crossSelling.page.create.title': 'Cross-Selling-Seite erstellen',
    'crossSelling.page.update.title': 'Cross-Selling-Seite „{crossSellingName}" bearbeiten',
    'crossSelling.page.create.description': 'Konfiguration der Cross-Selling-Seite',
    'crossSelling.page.update.description': 'Konfiguration der Cross-Selling-Seite',
    'crossSelling.products.image': 'Bild',
    'crossSelling.products.name': 'Name',
    'crossSelling.products.price': 'Preis',
    'crossSelling.products.vat': 'MwSt.',
    'crossSelling.products.tags': 'Tags',
    'crossSelling.products.sku': 'SKU',
    'crossSelling.products.menuName': 'Menü',
    'crossSelling.products.menuState': 'Menüstatus',
    'crossSelling.products.restaurantName': 'Restaurant',
    'crossSelling.products.add': 'Produkte hinzufügen',
    'crossSelling.products.menuState.enabled': 'Aktiviert',
    'crossSelling.products.menuState.disabled': 'Deaktiviert',
    'tableLayout.name': 'Tischplanname',
    'tableLayout.page.title': 'Tischpläne',
    'tableLayout.page.description': 'Erstellen und verwalten Sie Ihre Tischpläne',
    'tableLayout.table.associatedPos': 'Zugehörige Kassen',
    'tableLayout.action.newTableLayout': '+ Neuer Tischplan',
    'tableLayout.modal.create.title': 'Tischplan erstellen',
    'tableLayout.modal.edit.title': 'Tischplan „{tableLayoutName}" bearbeiten',
    'tableLayout.modal.delete.title': 'Tischplan löschen',
    'tableLayout.modal.delete.description':
        'Sind Sie sicher, dass Sie den Tischplan „{tableLayoutName}" löschen möchten ?',
    'tableLayout.modal.publish.title': 'Tischplan veröffentlichen',
    'tableLayout.modal.publish.description':
        'Sind Sie sicher, dass Sie den Tischplan „{tableLayoutName}" veröffentlichen möchten ?',
    'tableLayout.modal.error.name': 'Geben Sie einen Namen in das entsprechende Feld ein',
    'room.name': 'Saalname',
    'room.page.title': 'Säle',
    'room.page.description': 'Erstellen und verwalten Sie Ihre Säle',
    'room.action.newRoom': '+ Neuer Saal',
    'room.action.publish': 'Tischplan veröffentlichen',
    'room.modal.create.title': 'Saal erstellen',
    'room.modal.edit.title': 'Saal „{roomName}" bearbeiten',
    'room.modal.view.title': 'Saal „{roomName}"',
    'room.modal.single': 'Tisch hinzufügen',
    'room.modal.single.placeholder': 'Haupttisch',
    'room.modal.multiple': 'Mehrere Tische hinzufügen',
    'room.modal.multiple.placeholder1': '1',
    'room.modal.multiple.placeholder2': '10',
    'room.modal.layout': 'Tische anordnen',
    'room.modal.delete.title': 'Saal löschen',
    'room.modal.delete.description': 'Sind Sie sicher, dass Sie den Saal „{roomName}" löschen möchten ?',
    'room.modal.error.name': 'Geben Sie einen Namen in das entsprechende Feld ein',
    'room.modal.error.new_table_name': 'Geben Sie einen Tischnamen oder eine Tischnummer ein',
    'room.modal.error.fill_start_and_end': 'Geben Sie einen Startwert und einen Endwert ein (größer als der Startwert)',
    'room.modal.error.max_count_table': 'Sie können nicht mehr als {maxCount} Tische pro Saal haben.',
    'pos.configuration': 'Konfiguration',
    'pos.devices': 'Kassen',
    'pos.access': 'Rollen und Berechtigungen',
    'pos.access.users': 'Benutzer',
    'pos.access.roles': 'Rollen',
    'pos.access.groups': 'Gruppen',
    'pos.users.page.title': 'Kassenbediener',
    'pos.roles.page.title': 'Kassenrollen und -berechtigungen',
    'pos.groups.page.title': 'Kassenzugriffsgruppen',
    'pos.users.page.description': 'Kassenbediener legen fest, welche Benutzer mit der Kasse interagieren können.',
    'pos.roles.page.description':
        'Kassenrollen ermöglichen die Definition von Berechtigungsgruppen für Kassenbediener.',
    'pos.groups.page.description':
        'Die Zugriffsgruppen verwalten die Benutzer und deren Zuordnung zu den Kassen des Restaurants',
    'pos.users.action.newUser': 'Neuen Bediener anlegen',
    'posUser.name.form.label': 'Bedienername',
    'posUser.name.form.placeholder': 'Kassenbenutzer-Name',
    'posUser.pinCode.form.label': 'PIN-Code des Bedieners',
    'posUser.pinCode.form.placeholder': 'PIN-Code des Kassenbedieners',
    'posUser.role.form.label': 'Rolle des Bedieners',
    'posGroup.name.form.label': 'Gruppenname',
    'posGroup.name.form.placeholder': 'Namen der Zugriffsgruppe eingeben',
    'posGroup.users.form.label': 'Bediener',
    'posGroup.users.form.placeholder': 'Zugehörige Bediener auswählen',
    'posGroup.devices.form.label': 'Kassen',
    'posGroup.devices.form.placeholder': 'Zugehörige Kassen auswählen',
    'posUser.create.form.title': 'Neuen Kassenbediener anlegen',
    'posGroup.create.form.title': 'Neue Zugriffsgruppe anlegen',
    'posGroup.edit.form.title': 'Zugriffsgruppe bearbeiten',
    'posUser.edit.form.title': 'Kassenbediener bearbeiten: ',
    'posUser.form.description': 'Geben Sie die Informationen Ihres Kassenbedieners ein.',
    'posGroup.form.description': 'Geben Sie die Informationen Ihrer Kassenzugriffsgruppe ein.',
    'posUser.form.creation': 'Kassenbediener anlegen',
    'posUser.form.edit': 'Kassenbediener bearbeiten',
    'posUser.form.update': 'Kassenbediener bearbeiten',
    'posRole.form.title': 'Kassenrolle',
    'posRole.form.description': 'Auf dieser Seite können Sie die Berechtigungen Ihrer Kassenrolle aktualisieren',
    'posRole.form.creation': 'Kassenrolle anlegen',
    'posRole.form.update': 'Kassenrolle bearbeiten',
    'posGroup.form.creation': 'Zugriffsgruppe anlegen',
    'posGroup.form.update': 'Zugriffsgruppe bearbeiten',
    'posRole.form.rolePermissions': 'Berechtigungen für die Rolle',
    'posRole.form.name.title': 'Rollenname',
    'posRole.form.name.placeholder': 'Rolle',
    'pos.groups.action.create': 'Neue Gruppe anlegen',
    'permissions.permissions': 'Berechtigungen',
    'assiciated.devices': 'Zugehörige Kassen',
    'assiciated.operators': 'Zugehörige Bediener',
    'posRole.Operator': 'Bediener',
    'posRole.Manager': 'Manager',
    'posRole.Owner': 'Inhaber',
    'posRole.Auditor': 'Prüfer',
    'posRole.Treasurer': 'Kassierer',
    'posRole.Support': 'Support',
    'posRole.Trainer': 'Ausbilder',
    'posRole.InCharge': 'Verantwortlicher',
    'posRole.OperatorSupervisor': 'Betreuender Bediener',
    'posRole.AssistantOperator': 'Bedienerassistent',
    'posRole.AssistantToTheRegionalManager': 'Manager-Assistent',
    'posRole.CustomOperator1': 'Benutzerdefinierter Bediener 1',
    'posRole.CustomOperator2': 'Benutzerdefinierter Bediener 2',
    'posRole.CustomOperator3': 'Benutzerdefinierter Bediener 3',
    'channels.page.title': 'Kanalliste',
    'channels.page.description':
        'Die Bestellkanäle ermöglichen es Ihnen, Funktionen wie Online-Bestellung, Bestellung über ein Selbstbedienungsterminal am Point of Sale oder die Verwaltung von Kundenbindungsprogrammen anzubieten.',
    'channels.installed': 'Anwendung installiert',
    'channels.button.configure': 'Konfigurieren',
    'channels.button.disable': 'Deaktivieren',
    'channels.button.enable': 'Aktivieren',
    'channels.kiosk.name': 'Terminal',
    'channels.kiosk.description': 'Gestalten Sie das Erlebnis am Point of Sale auf die bestmögliche Weise neu.',
    'channels.web.name': 'Online-Bestellung',
    'channels.web.description': 'Ein neuer Verkaufspunkt über Ihre eigene Website.',
    'channels.reception.name': 'Empfang',
    'channels.reception.description': 'Eine dedizierte Oberfläche für Ihre Web- und Terminalbestellungen.',
    'channels.pos.name': 'POS',
    'channels.pos.description': 'Ihr einfaches und in Ihre Umgebung integriertes Kassensystem.',
    'channels.kds.name': 'Kitchen display',
    'channels.kds.description': 'Optimieren Sie Ihre Küche noch weiter mit einer perfekten Organisation.',
    'channels.loyalty.name': 'Kundenbindung',
    'channels.loyalty.description': 'Binden Sie Ihre Kunden und bringen Sie sie wieder in den Point of Sale.',
    'channels.ewallet_kiosk.name': 'E-Wallet-Aufladestation',
    'channels.ewallet_kiosk.description': 'Der neue Kanal zum schnellen Aufladen Ihres E-Wallets.',
    'channels.vending_machine.name': 'Automat',
    'channels.vending_machine.description':
        'Bieten Sie E-Wallet-Zahlung an Ihren Kaffeemaschinen und Getränkeautomaten an.',
    'accessFlags.CAN_ACCESS_BRAND_HISTORY': 'Kann auf die Verlaufsseite der Marke zugreifen',
    'accessFlags.CAN_ACCESS_CUSTOMERS_SECTION': 'Kann auf die Kundenseite zugreifen',
    'accessFlags.CAN_ACCESS_GRANTS_AND_ENTRANCE_FEES_SECTION':
        'Kann auf den Reiter Subventionen und Eintrittsgelder zugreifen',
    'accessFlags.CAN_ACCESS_IO_PAY': 'Kann auf das Zahlungsmodul zugreifen',
    'accessFlags.CAN_ARCHIVE_CUSTOMERS': 'Kann Kunden archivieren',
    'accessFlags.CAN_CREATE_ORDERS_WITH_NEGATIVE_AMOUNT': 'Kann Bestellungen mit negativem Betrag erstellen',
    'accessFlags.CAN_CREATE_ORDERS_WITH_NEGATIVE_BALANCE':
        'Kann Bestellungen erstellen, die das Gästeguthaben in den negativen Bereich bringen',
    'accessFlags.CAN_CREDIT_POST_PAYMENT_CUSTOMERS_EWALLET': 'Kann das E-Wallet eines Gastes per Nachzahlung aufladen',
    'accessFlags.CAN_EDIT_AREAS': 'Kann Lieferzonen bearbeiten',
    'accessFlags.CAN_EDIT_AUTO_BILLING_REFERENTIAL': 'Automatische Abrechnung: kann das Referenzwerk ändern',
    'accessFlags.CAN_EDIT_CUSTOMERS_CREDENTIALS': 'Kann Kundenanmeldedaten bearbeiten',
    'accessFlags.CAN_EXPORT_CUSTOMERS_CSV': 'Kann Kundendaten exportieren und E-Wallets belasten/gutschreiben',
    'accessFlags.CAN_FORCE_DEFAULT_CREDENTIALS_CHANGE':
        'Kann neue Kunden zwingen, ihre standardmäßig bereitgestellten Anmeldedaten zu ändern',
    'accessFlags.CAN_MANAGE_BO_USERS': 'Kann Backoffice-Benutzer verwalten',
    'accessFlags.CAN_MANAGE_BRAND_EWALLET_OVERDRAFT':
        'Kann den genehmigten Überziehungsrahmen auf Markenebene verwalten',
    'accessFlags.CAN_MANAGE_CUSTOMER_EWALLET_OVERDRAFT':
        'Kann den genehmigten Überziehungsrahmen auf Kundenebene verwalten',
    'accessFlags.CAN_ONLY_EDIT_PRICE_AND_PRODUCT_NAME':
        'Kann nur Preis und Name der zugehörigen Produkte und Schritte bearbeiten',
    'accessFlags.CAN_SYNC_SALES': 'Kann Verkäufe synchronisieren',
    'accessFlags.CAN_EDIT_TABLE_LAYOUT': 'Kann Tischpläne bearbeiten',
    'accessFlags.CAN_CREATE_ORDER_WITH_CUSTOM_PRICE': 'Kann Bestellungen mit einem individuellen Preis erstellen',
    'accessFlags.CAN_CREATE_ORDER_WITH_CUSTOM_PRICE_FOR_ALL_PRODUCTS':
        'Kann Bestellungen mit einem individuellen Preis für alle Produkte erstellen',
    'accessFlags.MENU_CATEGORY_CREATE_OR_DELETE': 'Kann Kategorien erstellen oder löschen',
    'accessFlags.MENU_CATEGORY_EDIT': 'Kann Kategorien bearbeiten',
    'accessFlags.MENU_CREATE_OR_DELETE': 'Kann Menüs erstellen oder löschen',
    'accessFlags.MENU_EDIT': 'Kann Menüs bearbeiten',
    'accessFlags.MENU_PRODUCT_CREATE_OR_DELETE': 'Kann Produkte erstellen oder löschen',
    'accessFlags.MENU_PRODUCT_EDIT': 'Kann Produkte bearbeiten',
    'accessFlags.MENU_PRODUCT_EDIT_PRICE_ONLY': 'Bearbeitung auf den Produktpreis beschränken',
    'accessFlags.MENU_PRODUCT_EDIT_PRICE_BLOCKED_ONLY': 'Nur die Bearbeitung des Produktpreises sperren',
    'accessFlags.MENU_STEP_CREATE_OR_DELETE': 'Kann Schritte erstellen oder löschen',
    'accessFlags.MENU_STEP_EDIT': 'Kann Schritte bearbeiten',
    'accessFlags.MENU_TAG_CREATE_OR_DELETE': 'Kann Tags erstellen oder löschen',
    'accessFlags.MENU_TAG_EDIT': 'Kann Tags bearbeiten',
    'accessFlags.CAN_CHANGE_OWN_PASSWORD': 'Kann eigenes Passwort ändern',
    'accessFlags.CAN_CANCEL_ORDER_WITH_CONTRA_ENTRY': 'Kann eine Bestellung stornieren (Gegenbuchung)',
    'accessFlags.CAN_CREATE_SKU': 'Kann SKUs erstellen',
    'accessFlagsGroups.customers': 'Kundenverwaltung',
    'accessFlagsGroups.financial': 'Finanzverwaltung / E-Wallet',
    'accessFlagsGroups.orders': 'Bestellverwaltung',
    'accessFlagsGroups.catalog': 'Katalogverwaltung',
    'accessFlagsGroups.subsidies': 'Subventionen & Zulassungen',
    'accessFlagsGroups.configuration': 'Restaurantkonfiguration',
    'accessFlagsGroups.administration': 'Administration & Konto',
    'accessFlagsGroups.others': 'Weitere Berechtigungen',
    'accessFlagsSubsections.categories': 'Kategorien',
    'accessFlagsSubsections.menus': 'Menüs',
    'accessFlagsSubsections.products': 'Produkte',
    'accessFlagsSubsections.steps': 'Schritte',
    'accessFlagsSubsections.tags': 'Tags',
    'accessFlagsControl.expandAll': 'Alle aufklappen',
    'accessFlagsControl.collapseAll': 'Alle zuklappen',
    'accessFlagsControl.permission': 'Berechtigung',
    'accessFlagsControl.permissions': 'Berechtigungen',
    'userRestaurants.noRestaurants': 'Kein Restaurant verfügbar',
    'brandUsers.email': 'E-Mail',
    'brandUsers.lastConnection': 'Letzte Verbindung',
    'brandUsers.login': 'Anmeldung',
    'brandUsers.loginAs': 'Anmelden als',
    'brandUsers.loginAsBrandGroup': 'Multi-Marken-Konto (nicht anmeldbar)',
    'brandUsers.newUser': '+ Neuer Benutzer',
    'brandRestaurants.newRestaurant': '+ Neues Restaurant',
    'brandRestaurants.create.restaurantInfo': 'Restaurantinformationen',
    'brandRestaurants.create.restaurantName': 'Restaurantname',
    'brandRestaurants.create.phone': 'Telefonnummer',
    'brandRestaurants.create.address': 'Adresse',
    'brandRestaurants.create.locale': 'Sprache',
    'brandRestaurants.create.currency': 'Währung',
    'brandRestaurants.create.operationZone': 'Betriebszone',
    'brandRestaurants.create.operationZone.skip': 'Überspringen – später konfigurieren',
    'brandRestaurants.create.operationZoneConfigure': 'Konfiguration der Betriebszone',
    'brandRestaurants.create.operationZone.selectProvider': 'Konformitätsmodus auswählen',
    'brandRestaurants.create.operationZone.currencyMismatch':
        'Diese Zone verwendet eine andere Währung als die Marke. Eine neue Marke ist erforderlich, um in dieser Währung zu operieren.',
    'brandRestaurants.create.manager': 'Geschäftsführer',
    'brandRestaurants.create.selectExistingUser': 'Bestehenden Benutzer auswählen',
    'brandRestaurants.create.createNewUser': 'Neuen Benutzer anlegen',
    'brandRestaurants.create.skipManager': 'Diesen Schritt überspringen',
    'brandRestaurants.create.letUserChoosePassword': 'Den Benutzer sein Passwort selbst wählen lassen',
    'brandRestaurants.create.done.title': 'Fertig!',
    'brandRestaurants.create.done.message': 'Sie sind bereit, {name} zu konfigurieren',
    'brandRestaurants.create.done.configure': 'Konfigurieren',
    'user.create.title': 'Neuen Benutzer anlegen',
    'user.create.firstName': 'Vorname',
    'user.create.lastName': 'Nachname',
    'user.create.phone': 'Telefonnummer',
    'user.create.email': 'E-Mail',
    'user.create.password': 'Passwort',
    'user.create.confirmPassword': 'Passwort bestätigen',
    'user.create.letUserChoosePassword': 'Den Benutzer sein Passwort selbst wählen lassen',
    'user.create.error.phone.length': 'Die Telefonnummer muss 10 Ziffern enthalten.',
    'user.create.error.phone.valid': 'Diese Nummer ist ungültig',
    'user.create.error.password.min': 'Ungültiges Passwort (mindestens 12 Zeichen)',
    'user.create.error.passwordConfirm.sameAsPassword': 'Die beiden Passwörter müssen identisch sein',
    'brands.restaurantscount': 'Anzahl der Restaurants',
    'brands.favorite': 'Favorit',
    'brands.create': '+ Neue Marke',
    'brands.form.title': 'Neue Marke anlegen',
    'brands.form.brandInfo': 'Markeninformationen',
    'brands.form.brandInfo.title': 'Markenname',
    'brands.form.selectUser': 'Markenverantwortlichen auswählen',
    'brands.form.selectUser.title': 'Markenverantwortlichen anlegen',
    'brands.form.canals': 'Bestellkanäle der Marke auswählen',
    'brands.form.canals.title': 'Kanäle verwalten',
    'brands.form.brandName': 'Name',
    'brands.form.region': 'Region und Sprache',
    'brands.form.currency': 'Währung',
    'brands.form.firstName': 'Vorname *',
    'brands.form.lastName': 'Nachname *',
    'brands.form.phoneNumber': 'Telefonnummer *',
    'brands.form.email': 'E-Mail *',
    'brands.form.password': 'Passwort *',
    'brands.form.confirmPassword': 'Passwort bestätigen *',
    'brands.form.error.phone.valid': 'Diese Nummer ist ungültig',
    'brands.form.error.password.min': 'Ungültiges Passwort (mindestens 12 Zeichen)',
    'brands.form.error.passwordConfirm.sameAsPassword': 'Die beiden Passwörter müssen identisch sein',
    'posPermissions.accessPermissions': 'Zugriffsberechtigungen',
    'posPermissions.otherPermissions': 'Weitere Berechtigungen',
    'posPermissions.ACCESS_CATALOG_SCREEN': 'Katalog',
    'posPermissions.ACCESS_CUSTOMERS_SCREEN': 'Kunden',
    'posPermissions.ACCESS_CUSTOMISATION_SCREEN': 'Optionen',
    'posPermissions.ACCESS_E_WALLET_SCREEN': 'E-Wallet',
    'posPermissions.ACCESS_MANAGE_CASH_FLOAT_SCREEN': 'Kassenfonds',
    'posPermissions.ACCESS_MANAGE_DISCOUNT_SCREEN': 'Aktionen',
    'posPermissions.ACCESS_MANAGE_RUNNER_SCREEN': 'Lieferfahrer',
    'posPermissions.ACCESS_MANAGE_TABLES_SCREEN': 'Tischplan',
    'posPermissions.ACCESS_NEW_ORDER_SCREEN': 'Neue Bestellung',
    'posPermissions.ACCESS_ORDERS_FOLLOW_UP_SCREEN': 'Bestellverfolgung',
    'posPermissions.ACCESS_PARAMETER_SCREEN': 'Einstellungen',
    'posPermissions.ACCESS_PRINTER_SCREEN': 'Drucker',
    'posPermissions.ACCESS_RAZ_SCREEN': 'Berichte',
    'posPermissions.ACCESS_TICKET_SCREEN': 'Belege',
    'posPermissions.ACCESS_USER_SCREEN': 'Benutzer',
    'posPermissions.APPLY_DISCOUNT': 'Aktion anwenden',
    'posPermissions.CANCEL_ORDER': 'Bestellung stornieren',
    'posPermissions.CANCEL_VALIDATED_ORDER_ITEM': 'Ein bestätigtes Produkt einer Bestellung stornieren',
    'posPermissions.CREATE_GROUP': 'Gruppe anlegen',
    'posPermissions.CREATE_PRODUCT': 'Produkt anlegen',
    'posPermissions.DELETE_DEFAULT_PRINTER': 'Standarddrucker löschen',
    'posPermissions.DISCONNECT': 'Eine Kasse trennen',
    'posPermissions.ENTER_DISCOUNT_WHEN_PLACING_AN_ORDER': 'Rabatt bei der Bestellaufnahme eingeben',
    'posPermissions.EXPORT_ARCHIVE': 'Archive exportieren',
    'posPermissions.FORCE_ORDER_SHIFT': 'Den Service einer Bestellung erzwingen',
    'posPermissions.GENERATE_ARCHIVE': 'Steuerliche Archive erzeugen',
    'posPermissions.JUSTIFY_ORDERS': 'Bestellungen begründen',
    'posPermissions.LINK_A_BADGE': 'Ausweis verknüpfen',
    'posPermissions.MODIFY_FEATURE_OPTIONS': 'Optionen ändern',
    'posPermissions.MODIFY_FUNCTION_FROM_GRID': 'Funktion per langem Druck ändern',
    'posPermissions.MODIFY_GROUP_FROM_GRID': 'Gruppe per langem Druck ändern',
    'posPermissions.MODIFY_ORDER_ITEM_PRICE': 'Preis eines Produkts im Warenkorb ändern',
    'posPermissions.MODIFY_PASSWORD': 'Passwort ändern',
    'posPermissions.MODIFY_PRODUCT_FROM_GRID': 'Produktdatenblatt anzeigen',
    'posPermissions.MODIFY_SKU_BILLING_CODE_PURCHASE_PRICE': 'Produktcode, Abrechnung und Abrechnungspreis ändern',
    'posPermissions.MODIFY_PRODUCT_PRICE': 'Preis im Produktdatenblatt ändern',
    'posPermissions.MODIFY_PRODUCT_OTHER_INFO': 'Weitere Eigenschaften im Produktdatenblatt ändern',
    'posPermissions.MODIFY_TICKET': 'Beleg ändern',
    'posPermissions.MODIFY_TICKET_GROUPS': 'Beleggruppen ändern',
    'posPermissions.MODIFY_TICKET_ORDER_PLACES': 'Bestellart der Belege ändern',
    'posPermissions.MODIFY_TICKET_ORDER_STATUS': 'Bestellstatus der Belege ändern',
    'posPermissions.MODIFY_TICKET_QUANTITY': 'Belegmengen ändern',
    'posPermissions.MODIFY_VALIDATED_ORDER_ITEM': 'Ein bestätigtes Produkt einer Bestellung ändern',
    'posPermissions.OFFER_PRODUCT_FOR_FREE': 'Ein Produkt gratis anbieten',
    'posPermissions.OPEN_CASH_DRAWER': 'Kassenschublade öffnen',
    'posPermissions.PRINT_VALID_TICKET': 'Bestätigte Belege drucken',
    'posPermissions.REFUND_CLIENT': 'Kunden erstatten',
    'posPermissions.REMOVE_PRODUCT_FROM_CATALOG': 'Produkt aus dem Katalog entfernen',
    'posPermissions.REOPEN_ORDER': 'Bestellung erneut öffnen',
    'posPermissions.SEARCH_CLIENT': 'Kunden manuell suchen',
    'posPermissions.SHOW_APPLY_PRICING_RULE_BUTTON':
        'Schaltfläche "Erzwungene Mahlzeit" auf dem Bildschirm für neue Durchgänge anzeigen',
    'posPermissions.SYNC_ARCHIVE': 'Archive synchronisieren',
    'posPermissions.VIEW_AUDIT_TRAIL': 'Prüfpfad anzeigen',
    'posPermissions.VIEW_FEATURE_OPTIONS': 'Optionen anzeigen',
    'posPermissions.VIEW_ORDER_AUDIT': 'Bestellprüfungen anzeigen',
    'posPermissions.VIEW_REVENUE_IN_FOLLOW_UP': 'Umsatz in den Berichten anzeigen',
    'posPermissions.VIEW_TICKET_AUDIT': 'Belegprüfungen anzeigen',
    'posPermissions.VIEW_TICKET_TEMPLATE': 'Belegvorlagen anzeigen',
    'posPermissions.MODIFY_TICKET_PRINTER': 'Belegdrucker ändern',
    'posPermissions.VALIDATE_EPT_PAYMENT_OPERATIONS': 'EC-Terminal-Vorgänge bestätigen',
    'multiBrand.user': 'Benutzer',
    'badgeReader.empty': 'Kein Ausweislesegerät konfiguriert',
    'badgeReader.notConfigured':
        'Es scheint, dass Sie kein Ausweislesegerät konfiguriert haben. Bitte besuchen Sie unseren',
    'badgeReader.help': 'Hilfebereich.',
    'badgeReader.create': 'Ausweislesegerät anlegen',
    'badgeReader.table.title': 'Ausweislesegeräte',
    'badgeReader.table.name': 'Gerätename',
    'badgeReader.table.deviceUuid': 'Geräte-UUID',
    'badgeReader.table.driver': 'Gerätetechnologie',
    'badgeReader.table.driverConfigs': 'Technologievariablen',
    'badgeReader.table.readingConditions': 'Leseregeln',
    'badgeReader.table.keyboardLayout': 'Keyboard layout',
    'badgeReader.driverConfigs':
        'Baudrate = <b>{baudRate}</b> {br}Bits = <b>{dataBits}</b> {br}Parity = <b>{parity}</b> {br}Stop Bits = <b>{stopBits}</b>',
    'badgeReader.readingCondition.number': 'Bedingung #{index}:',
    'badgeReader.readingCondition.stringLength': '• Wenn Länge = {stringLength} Zeichen',
    'badgeReader.readingCondition.convertBefore.none': '• Keine Konvertierung',
    'badgeReader.readingCondition.convertBefore.hex-dec': '• Konvertierung in Dezimal = {stringLength}',
    'badgeReader.readingCondition.convertBefore.hex-ascii': '• Konvertierung in ASCII = {stringLength}',
    'badgeReader.readingCondition.convertBefore.dec-hex': '• Konvertierung in Hexadezimal = {stringLength}',
    'badgeReader.readingCondition.convertBefore.remove-zero': '• Nullen entfernen',
    'badgeReader.readingCondition.convertBefore.hex-inverter': '• Zeichen umkehren',
    'badgeReader.readingCondition.convertBefore.prefix': '• Präfix mit Zeichen {prefix} bis zu {substrLength} Zeichen',
    'badgeReader.readingCondition.substrPositionStart': '• Lesen ab Zeichen {substrPositionStart}',
    'badgeReader.readingCondition.substrLength': '• Lesen von {substrLength} Zeichen',
    'badgeReader.readingCondition.convertAfter.none': '• Diese {substrLength} Zeichen nicht konvertieren',
    'badgeReader.readingCondition.convertAfter.hex-dec': '• Diese Dezimalzeichen in {convertAfter} konvertieren',
    'badgeReader.readingCondition.convertAfter.dec-hex': '• Diese Hexadezimalzeichen in {convertAfter} konvertieren',
    'badgeReader.readingCondition.convertAfter.hex-ascii': '• Diese ASCII-Zeichen in {convertAfter} konvertieren',
    'badgeReader.readingCondition.convertAfter.remove-zero': '• Nullen entfernen',
    'badgeReader.readingCondition.convertAfter.hex-inverter': '• Diese {substrLength} Zeichen umkehren',
    'badgeReader.delete.confirmation': 'Sind Sie sicher, dass Sie löschen möchten?',
    'badgeReader.delete.warning': 'Achtung',
    'badgeReader.cancel.confirmation': 'Sind Sie sicher, dass Sie die Konfiguration abbrechen möchten?',
    'badgeReader.cancel.warning': 'Achtung',
    'badgeReader.driver.keyboard': 'Tastaturausgabe',
    'badgeReader.driver.serial': 'Serielles Protokoll (RS232)',
    'badgeReader.driver.toqla': 'Toqla',
    'badgeReader.keyboardLayout.QWERTY': 'QWERTY',
    'badgeReader.keyboardLayout.AZERTY': 'AZERTY',
    'badgeReader.convertion.none': 'Keine Konvertierung',
    'badgeReader.convertion.hex-dec': 'Hexadezimal nach Dezimal',
    'badgeReader.convertion.hex-ascii': 'Hexadezimal nach ASCII',
    'badgeReader.convertion.dec-hex': 'Dezimal nach Hexadezimal',
    'badgeReader.step.information': 'Gerät anlegen',
    'badgeReader.step.driverConfigs': 'Technologievariablen',
    'badgeReader.step.readingCondition': 'Leseregeln',
    'badgeReader.form.name': 'Gerätename',
    'badgeReader.form.deviceId': 'USB-Kennung des Lesegeräts',
    'badgeReader.form.deviceUuid': 'Geräte-UUID',
    'badgeReader.form.driver': 'Gerätetechnologie',
    'badgeReader.form.driverConfigBaudRate': 'Baudrate',
    'badgeReader.form.driverConfigDataBits': 'Bits',
    'badgeReader.form.driverConfigParity': 'Parity',
    'badgeReader.form.driverConfigStopBits': 'Stop Bits',
    'badgeReader.form.keyboardLayout': 'Tastaturlayout',
    'badgeReader.form.readingCondition.order': 'Bedingung Nr.',
    'badgeReader.form.readingCondition.stringLength': 'Länge',
    'badgeReader.form.readingCondition.convertBefore': 'Konvertierung vorher?',
    'badgeReader.form.readingCondition.substrPositionStart': 'Start / Präfix',
    'badgeReader.form.readingCondition.substrLength': 'Länge',
    'badgeReader.form.readingCondition.convertAfter': 'Konvertierung nachher?',
    'badgeReader.step.readingCondition.add': 'Hinzufügen +',
    'badgeReader.form.convertion.none': 'Deaktiviert',
    'badgeReader.form.convertion.hex-dec': 'Hex > Dez',
    'badgeReader.form.convertion.dec-hex': 'Dez > Hex',
    'badgeReader.form.convertion.remove-zero': 'Nullen entfernen',
    'badgeReader.form.convertion.qwerty-azerty': 'Qwerty > Azerty',
    'badgeReader.form.convertion.hex-inverter': 'Hexadezimal bitweise invertiert',
    'badgeReader.form.convertion.prefix': 'Präfix',
    'badgeReader.form.convertion.hex-ascii': 'Hex > ASCII',
    'posDevice.catalogHistory.title': 'Katalogverlauf',
    'posDevice.catalogHistory.table.hash': 'Hash',
    'posDevice.catalogHistory.table.date': 'Erstellungsdatum',
    'posDevice.catalogHistory.table.actions': 'Aktionen',
    'posDevice.catalogHistory.button.download': 'Herunterladen',
    'passwordUpdate.title': 'Passwort aktualisieren',
    'passwordUpdate.currentPassword': 'Altes Passwort',
    'passwordUpdate.newPassword': 'Neues Passwort',
    'passwordUpdate.confirmPassword': 'Neues Passwort bestätigen',
    'passwordUpdate.update': 'Speichern',
    'passwordUpdate.passwordMismatch': 'Das neue Passwort und die Bestätigung stimmen nicht überein.',
    'passwordUpdate.passwordMinLength': 'Das Passwort muss mindestens 12 Zeichen enthalten.',
    'passwordUpdate.success': 'Passwort erfolgreich aktualisiert',
    'notification.guestHierarchy.title': 'Neu',
    'notification.guestHierarchy.content': 'Die Einstellung der Kontohierarchie entwickelt sich weiter.',
    'notification.guestHierarchy.link': 'Klicken Sie hier, um mehr zu erfahren',
    'guestHierarchyTraining.page1.title': 'Willkommen bei der Verwaltung der Kundenparcours',
    'guestHierarchyTraining.page1.content':
        'Die Verwaltung der Kundenparcours ermöglicht eine strikte Konfiguration der Gästekonten im Back-Office (BO). Sie basiert auf einer Hierarchie <b>Gruppe → Abschnitt → Unterabschnitt</b> und der Zuweisung von <b>Tariftarifen</b> zu diesen Elementen. Diese Strukturierung gewährleistet eine optimierte und konsistente Verwaltung.',
    'guestHierarchyTraining.page2.title': 'Auf die Hierarchisierung zugreifen',
    'guestHierarchyTraining.page2.content':
        'Öffnen Sie den neuen Reiter <b>Hierarchisierung</b>. Dieser Bereich ermöglicht es, Gruppen, Abschnitte und Unterabschnitte zu <b>erstellen und zu bearbeiten</b>.',
    'guestHierarchyTraining.page3.title': 'Eine Gruppe erstellen oder bearbeiten',
    'guestHierarchyTraining.page3.content':
        '• Gehen Sie zu <b>Hierarchisierung > Gruppen.</b> {br}• Klicken Sie auf <b>"Gruppe erstellen"</b> oder bearbeiten Sie eine bestehende. {br}• Eine Gruppe hat eine <b>eindeutige Bezeichnung</b> (1) {br}• Legen Sie die <b>erlaubten Tariftarife</b> für die dieser Gruppe zugeordneten Gäste fest (2)',
    'guestHierarchyTraining.page4.title': 'Einen Abschnitt erstellen oder bearbeiten',
    'guestHierarchyTraining.page4.content':
        '• Gehen Sie zu <b>Hierarchisierung > Abschnitte.</b> {br}• Klicken Sie auf <b>"Abschnitt erstellen"</b> oder bearbeiten Sie einen bestehenden. {br}• Weisen Sie einen Abschnitt einer <b>bestehenden Gruppe</b> zu. (1) {br}• Eine eindeutige Bezeichnung ist erforderlich. (2) {br} • Legen Sie die <b>erlaubten Tariftarife</b> für die diesem Abschnitt zugeordneten Gäste fest (3)',
    'guestHierarchyTraining.page5.title': 'Einen Unterabschnitt erstellen oder bearbeiten',
    'guestHierarchyTraining.page5.content':
        '• Gehen Sie zu <b>Hierarchisierung > Unterabschnitte.</b> {br}• Klicken Sie auf <b>"Unterabschnitt erstellen"</b> oder bearbeiten Sie einen bestehenden. {br}• Weisen Sie einen Unterabschnitt einem <b>bestehenden Abschnitt</b> zu. (1 und 2) {br}• Eine eindeutige Bezeichnung ist erforderlich. (3) {br} • Legen Sie die <b>erlaubten Tariftarife</b> für die diesem Unterabschnitt zugeordneten Gäste fest (4)',
    'guestHierarchyInfo.title': 'Gäste anlegen',
    'guestHierarchyInfo.content':
        'Bei der Erstellung eines Gastes werden die angebotenen Tariftarife automatisch nach der ausgewählten Gruppe, dem Abschnitt oder dem Unterabschnitt gefiltert.',
    'loyalty.features.title': 'Aktivierte Funktionen',
    'loyalty.features.MultiRewardSelection': 'Mehrfache Prämienauswahl',
    'loyalty.features.Promocode': 'Aktionscodes',
    'loyalty.features.Deals': 'Deals',
    'loyalty.features.PointPayment': 'Bezahlung mit Punkten',
    'splio.title': 'Integration – Kundenbindung Splio',
    'splio.integrationEnabled': 'Integration aktiviert seit {date}',
    'splio.description':
        'Geben Sie den API-Schlüssel in das folgende Feld ein, um Ihr Splio-Programm mit Ihrem Restaurant und Ihren Innovorder-Produkten zu verknüpfen.\nDiesen API-Schlüssel erhalten Sie in Ihrer Splio-Oberfläche.',
    'splio.apiKey.placeholder': 'Geben Sie Ihren Splio-API-Schlüssel ein',
    'splio.apiKey': 'Splio-API-Schlüssel',
    'splio.programId': 'Kundenbindungsprogramm',
    'splio.allowCustomerRewardUsage': 'Die Nutzung von Prämien durch Kunden erlauben',
    'splio.formLink': 'Links zum Anmeldeformular',
    'splio.optIn': 'OptIn für den Marketing-Newsletter',
    'splio.memberIdentifier': 'Kennung für die Kontoerstellung',
    'splio.useCasualTone': 'Informelle Anrede aktivieren',
    'splio.authenticationMethods': 'Erlaubte Kundenbindungs-Authentifizierungsmethoden',
    'splio.registerMethods': 'Erlaubte Kundenbindungs-Registrierungsmethoden',
    'splio.methods.email': 'E-Mail',
    'splio.methods.phone': 'Telefon',
    'splio.methods.externalId': 'Kundenbindungskennung',
    'splio.update.success': 'Splio-Integration erfolgreich aktualisiert',
    'splio.subscriptionToMarketingNewsletter': 'Newsletter-Anmeldung (Marketing)',
    'splio.subscriptionToLoyaltyNewsletter': 'Newsletter-Anmeldung (Kundenbindung)',
    'splio.deleteModal.title': 'Splio-Integration löschen',
    'splio.deleteModal.text': 'Sind Sie sicher, dass Sie die Splio-Integration löschen möchten?',
    'splio.error.formLinkInvalid': 'Ungültiger Formularlink',
    'splio.error.changeProvider':
        'Für dieses Restaurant ist bereits eine Kundenbindungsintegration konfiguriert. Bitte löschen Sie diese zuerst',
    'pickupPoint.page.title': 'Abholpunkte',
    'pickupPoint.page.description': 'Erstellen und verwalten Sie Ihre Abholpunkte',
    'pickupPoint.action.create': 'Abholpunkt anlegen',
    'pickupPoint.modal.createPickupPoint': 'Abholpunkt anlegen',
    'pickupPoint.modal.editPickupPoint': 'Abholpunkt bearbeiten',
    'pickupPoint.modal.deletePickupPoint': 'Abholpunkt löschen',
    'pickupPoint.modal.delete.title': 'Abholpunkt löschen',
    'pickupPoint.modal.delete.description': 'Sind Sie sicher, dass Sie den Abholpunkt "{name}" löschen möchten?',
    'pickupPoint.modal.pickupPoint.name': 'Name',
    'pickupPoint.modal.pickupPoint.address': 'Adresse',
    'pickupPoint.modal.pickupPoint.additionalAddressInfo': 'Adresszusatz',
    'pickupPoint.modal.pickupPoint.name.placeholder': 'Name des Abholpunkts',
    'pickupPoint.modal.pickupPoint.address.placeholder': 'Adresse des Abholpunkts',
    'pickupPoint.modal.pickupPoint.additionalAddressInfo.placeholder': 'Adresszusatz des Abholpunkts',
    'pickupPoint.modal.warn.shift.title': 'Achtung',
    'pickupPoint.modal.warn.shift.text':
        'Stellen Sie sicher, dass keine Bestellung in Bearbeitung ist, bevor Sie diesen Abholpunkt löschen. Nach dem Löschen ist er für Kunden nicht mehr sichtbar und laufende Bestellungen gehen verloren.',
    'pickupPoint.modal.warn.shift.button': 'Verstanden',
    'como.title': 'Integration – Kundenbindung Como',
    'como.description':
        'Geben Sie den API-Schlüssel in das folgende Feld ein, um Ihr Como-Programm mit Ihrem Restaurant und Ihren Innovorder-Produkten zu verknüpfen.\nDiesen API-Schlüssel erhalten Sie in Ihrer Como-Oberfläche.',
    'como.apiKey': 'Como-API-Schlüssel',
    'como.integrationEnabled': 'Integration aktiviert seit {date}',
    'como.apiKey.placeholder': 'Geben Sie Ihren Como-API-Schlüssel ein',
    'como.formLink': 'Links zum Anmeldeformular',
    'como.useCasualTone': 'Informelle Anrede aktivieren',
    'como.authenticationMethods': 'Erlaubte Kundenbindungs-Authentifizierungsmethoden',
    'como.registerMethods': 'Erlaubte Kundenbindungs-Registrierungsmethoden',
    'como.methods.email': 'E-Mail',
    'como.methods.phone': 'Telefon',
    'como.methods.externalId': 'Kundenbindungskennung',
    'como.error.formLinkInvalid': 'Ungültiger Formularlink',
    'como.update.success': 'Como-Integration erfolgreich aktualisiert',
    'como.deleteModal.title': 'Como-Integration löschen',
    'como.deleteModal.text': 'Sind Sie sicher, dass Sie die Como-Integration löschen möchten?',
    'como.error.changeProvider':
        'Für dieses Restaurant ist bereits eine Kundenbindungsintegration konfiguriert. Bitte löschen Sie diese zuerst',
    'como.error.invalidApiKey': 'Der eingegebene API-Schlüssel ist ungültig.',
    'zerosix.title': 'Integration – Kundenbindung Zerosix',
    'zerosix.description':
        'Geben Sie den API-Schlüssel in das folgende Feld ein, um Ihr Zerosix-Programm mit Ihrem Restaurant und Ihren Innovorder-Produkten zu verknüpfen.\nDiesen API-Schlüssel erhalten Sie in Ihrer Zerosix-Oberfläche.',
    'zerosix.apiKey': 'Zerosix-API-Schlüssel',
    'zerosix.integrationEnabled': 'Integration aktiviert seit {date}',
    'zerosix.apiKey.placeholder': 'Geben Sie Ihren Zerosix-API-Schlüssel ein',
    'zerosix.formLink': 'Links zum Anmeldeformular',
    'zerosix.useCasualTone': 'Informelle Anrede aktivieren',
    'zerosix.authenticationMethods': 'Erlaubte Kundenbindungs-Authentifizierungsmethoden',
    'zerosix.registerMethods': 'Erlaubte Kundenbindungs-Registrierungsmethoden',
    'zerosix.methods.email': 'E-Mail',
    'zerosix.methods.phone': 'Telefon',
    'zerosix.methods.externalId': 'Kundenbindungskennung',
    'zerosix.error.formLinkInvalid': 'Ungültiger Formularlink',
    'zerosix.update.success': 'Zerosix-Integration erfolgreich aktualisiert',
    'zerosix.deleteModal.title': 'Zerosix-Integration löschen',
    'zerosix.deleteModal.text': 'Sind Sie sicher, dass Sie die Zerosix-Integration löschen möchten?',
    'zerosix.error.changeProvider':
        'Für dieses Restaurant ist bereits eine Kundenbindungsintegration konfiguriert. Bitte löschen Sie diese zuerst',
    'zerosix.error.invalidApiKey': 'Der eingegebene API-Schlüssel ist ungültig.',
    'restaurantInfo.title': 'Restaurantinformationen',
    'restaurantInfo.information.title': 'Über das Restaurant',
    'restaurantInfo.name': 'Restaurantname',
    'restaurantInfo.address': 'Restaurantadresse',
    'restaurantInfo.contactName': 'Kontaktname',
    'restaurantInfo.contactEmail': 'E-Mail-Adresse',
    'restaurantInfo.contactPhone': 'Telefonnummer',
    'restaurantInfo.externalId': 'Externe Kennung',
    'restaurantInfo.tag': 'Restaurant-Tag',
    'restaurantInfo.families': 'Restaurant-Familien',
    'restaurantInfo.searchFamilies': 'Familie suchen',
    'restaurantInfo.image': 'Restaurantbild',
    'restaurantInfo.legal.title': 'Rechtliche Informationen',
    'restaurantInfo.legal.description':
        'Diese Informationen dienen zur Erstellung der allgemeinen Geschäftsbedingungen und des Impressums der Bestellkanäle',
    'restaurantInfo.legal.socialReason': 'Firmenname',
    'restaurantInfo.legal.organizationType': 'Organisationstyp',
    'restaurantInfo.legal.capital': 'Stammkapital',
    'restaurantInfo.legal.commerceRegistryCity': 'Stadt der Handelsregistereintragung',
    'restaurantInfo.legal.siren': 'Siren',
    'restaurantInfo.legal.taxNumber': 'Umsatzsteuer-Identifikationsnummer',
    'restaurantInfo.legal.industryClassificationCode': 'NAF-Code',
    'restaurantInfo.legal.publicationDirectorName': 'Name des Verantwortlichen für den Inhalt',
    'restaurantInfo.legal.publicationDirectorFunction': 'Funktion des Verantwortlichen für den Inhalt',
    'restaurantInfo.legal.webmasterName': 'Name des Webmasters',
    'restaurantInfo.legal.webmasterEmail': 'E-Mail des Webmasters',
    'restaurantInfo.ewalletMinimum.title':
        'Konfiguration des auf dem Scan-Tablett zulässigen Mindest-E-Wallet-Guthabens',
    'restaurantInfo.ewalletMinimum.inputTitle': 'MINDESTBETRAG',
    'restaurantInfo.ewalletMinimum.caseZero':
        'Um kein Mindestguthaben für den Ausweis festzulegen, geben Sie 0 in das Feld ein und speichern Sie.',
    'restaurantInfo.delete.title': 'Restaurant löschen',
    'restaurantInfo.delete.description': 'Dieses Restaurant existiert seit dem',
    'restaurantInfo.delete.button': 'Dieses Restaurant löschen',
    'restaurantInfo.save.error': 'Beim Speichern ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    'restaurantInfo.delete.error': 'Ein Fehler ist aufgetreten. Bitte beginnen Sie Ihre Konfiguration erneut.',
    'restaurantInfo.delete.confirmTitle': 'Restaurant löschen',
    'restaurantInfo.delete.confirmDescription':
        'Sind Sie sicher, dass Sie dieses Restaurant löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
    'restaurantInfo.schedule.title': 'Erlaubte Abholzeiten',
    'restaurantInfo.schedule.manualEdit': 'Manuelle Bearbeitung',
    'restaurantInfo.schedule.autoEdit': 'Automatische Bearbeitung',
    'restaurantInfo.schedule.autoEditDescription': 'Ermöglicht das schnelle Erstellen von Zeitfenstern.',
    'restaurantInfo.schedule.description':
        'Sie können verschiedene erlaubte Abholzeiten für Ihr Restaurant konfigurieren. Diese Zeitfenster entsprechen den Öffnungszeiten Ihres Restaurants, während derer Ihre Kunden ihre Online-Bestellungen abholen können.',
    'restaurantInfo.schedule.open': 'Geöffnet',
    'restaurantInfo.schedule.closed': 'Geschlossen',
    'restaurantInfo.schedule.day.mon': 'Mo',
    'restaurantInfo.schedule.day.tue': 'Di',
    'restaurantInfo.schedule.day.wed': 'Mi',
    'restaurantInfo.schedule.day.thu': 'Do',
    'restaurantInfo.schedule.day.fri': 'Fr',
    'restaurantInfo.schedule.day.sat': 'Sa',
    'restaurantInfo.schedule.day.sun': 'So',
    'restaurantInfo.schedule.mass.startHour': 'Startzeit',
    'restaurantInfo.schedule.mass.endHour': 'Endzeit',
    'restaurantInfo.schedule.mass.granularity': 'Intervall',
    'restaurantInfo.schedule.mass.15min': '15 Min.',
    'restaurantInfo.schedule.mass.30min': '30 Min.',
    'restaurantInfo.schedule.mass.1h': '1 Stunde',
    'restaurantInfo.schedule.mass.overwrite': 'Bestehende Zeiten überschreiben',
    'restaurantInfo.schedule.mass.apply': 'Anwenden',
    'restaurantInfo.schedule.mass.noDays': 'Wählen Sie mindestens einen Tag aus.',
    'restaurantInfo.schedule.mass.midnight': 'Mitternacht',
    'order.customer.loyalty.anonymous': 'Anonym {email}',
    'route.vatRatesMatrix': 'MwSt.-Referenzwerk',
    'vatRatesMatrix.title': 'Globales MwSt.-Referenzwerk',
    'vatRatesMatrix.subtitle':
        'Einzige Quelle der Wahrheit für die Besteuerung aller Innovorder-Produkte. Änderungen werden automatisch auf neue Produkte übertragen.',
    'vatRatesMatrix.vatGroup': 'MwSt.-Familie',
    'vatRatesMatrix.codeLabel': 'Code',
    'vatRatesMatrix.eatIn': 'Vor Ort',
    'vatRatesMatrix.takeAway': 'Zum Mitnehmen',
    'vatRatesMatrix.delivery': 'Lieferung',
    'vatRatesMatrix.exportCsv': 'CSV exportieren',
    'vatRatesMatrix.exportError': 'Beim CSV-Export ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    'vatRatesMatrix.filterByZone': 'Nach Zone filtern',
    'vatRatesMatrix.filterByGroup': 'Nach Familie filtern',
    'vatRatesMatrix.filterByMode': 'Nach Modus filtern',
    'vatRatesMatrix.loading': 'Wird geladen...',
    'vatRatesMatrix.error': 'Fehler beim Laden der Daten.',
    'vatRatesMatrix.family.FOOD': 'Lebensmittel',
    'vatRatesMatrix.family.NON_ALCOHOL': 'Alkoholfrei',
    'vatRatesMatrix.family.ALCOHOL': 'Alkohol',
    'vatRatesMatrix.family.NORMAL': 'Normal',
    'vatRatesMatrix.family.NONE': 'Keine',
    'route.promotionalBanners': 'Werbebanner',
    'promotionalBanner.page.title': 'Bannerverwaltung',
    'promotionalBanner.page.subtitle': 'Erstellen und verwalten Sie Ihre Werbebanner zur Anzeige auf Ihrem Terminal.',
    'promotionalBanner.page.emptyState':
        'Erstellen Sie einen Werbebanner, um Ihre Produkte und Kategorien auf Ihrem Terminal zu bewerben.',
    'promotionalBanner.page.emptyStateCta': 'Banner erstellen',
    'promotionalBanner.page.noActiveMenu.title': 'Kein aktives Terminalmenü',
    'promotionalBanner.page.noActiveMenu.desc':
        '👉 Aktivieren Sie ein Terminalmenü, um auf die Bannerkonfiguration zugreifen zu können.',
    'promotionalBanner.page.noActiveMenu.cta': 'Meine Menüs verwalten',
    'promotionalBanner.action.create': 'Banner erstellen',
    'promotionalBanner.action.edit': 'Bearbeiten',
    'promotionalBanner.action.view': 'Anzeigen',
    'promotionalBanner.action.delete': 'Löschen',
    'promotionalBanner.action.activate': 'Aktivieren',
    'promotionalBanner.action.deactivate': 'Deaktivieren',
    'promotionalBanner.table.listTitle': 'Liste der Werbebanner',
    'promotionalBanner.modal.createTitle': 'Banner erstellen',
    'promotionalBanner.modal.editTitle': 'Banner bearbeiten',
    'promotionalBanner.modal.viewTitle': 'Banner anzeigen',
    'promotionalBanner.modal.close': 'Schließen',
    'promotionalBanner.modal.name': 'Name',
    'promotionalBanner.modal.channel': 'Kanal',
    'promotionalBanner.modal.image': 'Bild',
    'promotionalBanner.modal.linkType': 'Linktyp',
    'promotionalBanner.modal.linkTarget': 'Ziel',
    'promotionalBanner.modal.activateAndSave': 'Aktivieren und speichern',
    'promotionalBanner.modal.saveAsDraft': 'Als Entwurf speichern',
    'promotionalBanner.modal.updateBanner': 'Banner aktualisieren',
    'promotionalBanner.modal.deactivateBanner': 'Banner deaktivieren',
    'promotionalBanner.modal.imageSizeError': 'Das Bild darf 5 MB nicht überschreiten',
    'promotionalBanner.modal.nameHelper': 'Dieser Name ist nur im Backoffice sichtbar.',
    'promotionalBanner.modal.nameLabel': 'Bannername',
    'promotionalBanner.modal.channelLabel': 'Zielkanal',
    'promotionalBanner.modal.channelKiosk': 'Terminal',
    'promotionalBanner.modal.channelKioskDesc': 'Anzeige des Banners zu Beginn des Bestellvorgangs am Terminal.',
    'promotionalBanner.modal.channelWeb': 'CEL',
    'promotionalBanner.modal.channelWebDesc': 'Anzeige im Online-Bestellvorgang.',
    'promotionalBanner.modal.channelWebDisabled': 'Demnächst verfügbar.',
    'promotionalBanner.modal.imageLabel': 'Bannerbild',
    'promotionalBanner.modal.imageSpecs': 'JPG, PNG, WebP · Max. 5 MB · Format 3:1',
    'promotionalBanner.modal.image.error.ratio': 'Das Format muss 3:1 sein',
    'promotionalBanner.modal.imageFileDescription': '{name} · 1920×500px',
    'promotionalBanner.modal.linkTypeLabel': 'Linktyp',
    'promotionalBanner.modal.linkNone': 'Kein Link',
    'promotionalBanner.modal.linkNoneDesc': 'Ist informativ und nicht anklickbar.',
    'promotionalBanner.modal.linkProduct': 'Produkt',
    'promotionalBanner.modal.linkProductDesc': 'Leitet beim Anklicken zur Produktseite weiter.',
    'promotionalBanner.modal.linkCategory': 'Kategorie',
    'promotionalBanner.modal.linkCategoryDesc': 'Leitet beim Anklicken zur Kategorie weiter.',
    'promotionalBanner.modal.activateBanner': 'Banner aktivieren',
    'promotionalBanner.modal.replace': 'Ersetzen',
    'promotionalBanner.modal.searchCategory': 'Kategorie suchen...',
    'promotionalBanner.modal.searchProduct': 'Produkt nach Name oder SKU suchen...',
    'promotionalBanner.table.name': 'Name',
    'promotionalBanner.table.status': 'Status',
    'promotionalBanner.table.source': 'Quelle',
    'promotionalBanner.table.linkType': 'Linktyp',
    'promotionalBanner.table.actions': 'Aktionen',
    'promotionalBanner.table.sourceRestaurant': 'Restaurant',
    'promotionalBanner.table.sourceBrand': 'Marke',
    'promotionalBanner.table.linkNone': 'Kein Link',
    'promotionalBanner.table.linkCategory': 'Kategorie',
    'promotionalBanner.table.linkProduct': 'Produkt',
    'promotionalBanner.table.statusActive': 'Aktiv',
    'promotionalBanner.table.statusInactive': 'Inaktiv',
    'promotionalBanner.table.linkDeleted': 'gelöscht',
    'promotionalBanner.confirm.title': 'Ein Service ist derzeit aktiv',
    'promotionalBanner.confirm.message': 'Diese Aktion lädt alle Terminals neu und unterbricht laufende Bestellungen.',
    'promotionalBanner.confirm.confirm': 'Bestätigen',
    'promotionalBanner.confirm.cancel': 'Abbrechen',
    'promotionalBanner.delete.title': 'Banner löschen',
    'promotionalBanner.delete.description': 'Sind Sie sicher, dass Sie diesen Banner löschen möchten?',
    'promotionalBanner.confirm.message.bulk':
        'Diese Aktion lädt die Terminals von {count} Restaurants neu und unterbricht laufende Bestellungen.',
    'promotionalBanner.action.duplicate': 'Duplizieren',
    'promotionalBanner.duplicate.fallback.title': 'Banner ohne Link dupliziert',
    'promotionalBanner.duplicate.fallback.product':
        'Die Kopie von „{sourceName}" wurde ohne Link erstellt: Die SKU wurde nicht in Ihrem aktiven Terminalmenü gefunden.',
    'promotionalBanner.duplicate.fallback.category':
        'Die Kopie von „{sourceName}" wurde ohne Link erstellt: Die Kategorie wurde nicht in Ihrem aktiven Terminalmenü gefunden.',
    'promotionalBanner.duplicate.fallback.dismiss': 'Verstanden',
    'route.brand.promotionalBanners': 'Werbebanner',
    'brandPromotionalBanner.page.title': 'Marken-Werbebanner',
    'brandPromotionalBanner.page.subtitle': 'Konfigurieren und verteilen Sie Banner auf die Restaurants der Marke.',
    'brandPromotionalBanner.page.empty': 'Noch kein Banner vorhanden.',
    'brandPromotionalBanner.action.create': 'Banner erstellen',
    'brandPromotionalBanner.table.name': 'Name',
    'brandPromotionalBanner.table.status': 'Status',
    'brandPromotionalBanner.table.source': 'Quelle',
    'brandPromotionalBanner.table.link': 'SKU oder Kategorie',
    'brandPromotionalBanner.table.activeRestaurants': '{count} aktive Restaurants',
    'brandPromotionalBanner.table.actions': 'Aktionen',
    'brandPromotionalBanner.modal.createTitle': 'Markenbanner erstellen',
    'brandPromotionalBanner.modal.editTitle': 'Banner bearbeiten',
    'brandPromotionalBanner.modal.name.label': 'Bannername',
    'brandPromotionalBanner.modal.image.label': 'Bild',
    'brandPromotionalBanner.modal.image.hint': 'Format 3:1, max. 5 MB',
    'brandPromotionalBanner.modal.image.error.ratio': 'Das Format muss 3:1 sein',
    'brandPromotionalBanner.modal.image.error.size': 'Das Bild überschreitet 5 MB',
    'brandPromotionalBanner.modal.channel.label': 'Kanal',
    'brandPromotionalBanner.modal.channel.comingSoon': 'Demnächst verfügbar',
    'brandPromotionalBanner.modal.link.label': 'Linktyp',
    'brandPromotionalBanner.modal.link.none': 'Kein Link',
    'brandPromotionalBanner.modal.link.product': 'Produkt (SKU)',
    'brandPromotionalBanner.modal.link.category': 'Kategorie',
    'brandPromotionalBanner.modal.link.product.hint':
        'Wenn die SKU nicht im aktiven Terminalmenü eines Restaurants gefunden wird, wird der Banner in diesem Restaurant ohne Link angezeigt.',
    'brandPromotionalBanner.modal.link.category.hint':
        'Wenn die Kategorie nicht im aktiven Terminalmenü eines Restaurants gefunden wird, wird der Banner in diesem Restaurant ohne Link angezeigt.',
    'brandPromotionalBanner.modal.restaurants.label': 'Zielrestaurants',
    'brandPromotionalBanner.modal.restaurants.empty': 'Wählen Sie mindestens ein Restaurant aus',
    'brandPromotionalBanner.modal.button.cancel': 'Abbrechen',
    'brandPromotionalBanner.modal.button.saveDraft': 'Als Entwurf speichern',
    'brandPromotionalBanner.modal.button.activate': 'Banner aktivieren',
    'brandPromotionalBanner.modal.button.deactivate': 'Banner deaktivieren',
    'brandPromotionalBanner.modal.button.update': 'Banner aktualisieren',
    'brandPromotionalBanner.delete.title': 'Banner löschen?',
    'brandPromotionalBanner.delete.message': 'Der Banner wird von allen zugehörigen Restaurants entfernt.',
    'brandPromotionalBanner.carousel.title': 'Anzeigeverzögerung zwischen zwei Bannern',
    'brandPromotionalBanner.carousel.description': 'Legen Sie die Anzeigezeit zwischen zwei aktiven Bannern fest.',
    'brandPromotionalBanner.carousel.helper': 'Wartezeit zwischen der Anzeige von zwei aktiven Bannern.',
    'brandPromotionalBanner.carousel.seconds': 'Sekunden',
    'brandPromotionalBanner.carousel.save': 'Speichern',
    'brandPromotionalBanner.carousel.saved': 'Verzögerung aktualisiert',
    'brandPromotionalBanner.carousel.help':
        'Diese Verzögerung gilt beim nächsten Neuladen der Terminals für alle Restaurants der Marke.',
    'brandPromotionalBanner.modal.restaurants.ineligible.noChannel':
        'Für dieses Restaurant ist das Terminal nicht aktiviert.',
    'brandPromotionalBanner.modal.restaurants.ineligible.noMenu': 'Dieses Restaurant hat kein aktives Terminalmenü.',
};

export default translationDe;
